import { createRequire } from "node:module";
var __create = Object.create;
var __getProtoOf = Object.getPrototypeOf;
var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __toESM = (mod, isNodeMode, target) => {
  target = mod != null ? __create(__getProtoOf(mod)) : {};
  const to = isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target;
  for (let key of __getOwnPropNames(mod))
    if (!__hasOwnProp.call(to, key))
      __defProp(to, key, {
        get: () => mod[key],
        enumerable: true
      });
  return to;
};
var __commonJS = (cb, mod) => () => (mod || cb((mod = { exports: {} }).exports, mod), mod.exports);
var __require = /* @__PURE__ */ createRequire(import.meta.url);

// node_modules/kind-of/index.js
var require_kind_of = __commonJS((exports, module) => {
  var toString = Object.prototype.toString;
  module.exports = function kindOf(val) {
    if (val === undefined)
      return "undefined";
    if (val === null)
      return "null";
    var type = typeof val;
    if (type === "boolean")
      return "boolean";
    if (type === "string")
      return "string";
    if (type === "number")
      return "number";
    if (type === "symbol")
      return "symbol";
    if (type === "function") {
      return isGeneratorFn(val) ? "generatorfunction" : "function";
    }
    if (isArray(val))
      return "array";
    if (isBuffer(val))
      return "buffer";
    if (isArguments(val))
      return "arguments";
    if (isDate(val))
      return "date";
    if (isError(val))
      return "error";
    if (isRegexp(val))
      return "regexp";
    switch (ctorName(val)) {
      case "Symbol":
        return "symbol";
      case "Promise":
        return "promise";
      case "WeakMap":
        return "weakmap";
      case "WeakSet":
        return "weakset";
      case "Map":
        return "map";
      case "Set":
        return "set";
      case "Int8Array":
        return "int8array";
      case "Uint8Array":
        return "uint8array";
      case "Uint8ClampedArray":
        return "uint8clampedarray";
      case "Int16Array":
        return "int16array";
      case "Uint16Array":
        return "uint16array";
      case "Int32Array":
        return "int32array";
      case "Uint32Array":
        return "uint32array";
      case "Float32Array":
        return "float32array";
      case "Float64Array":
        return "float64array";
    }
    if (isGeneratorObj(val)) {
      return "generator";
    }
    type = toString.call(val);
    switch (type) {
      case "[object Object]":
        return "object";
      case "[object Map Iterator]":
        return "mapiterator";
      case "[object Set Iterator]":
        return "setiterator";
      case "[object String Iterator]":
        return "stringiterator";
      case "[object Array Iterator]":
        return "arrayiterator";
    }
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
  };
  function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
  }
  function isArray(val) {
    if (Array.isArray)
      return Array.isArray(val);
    return val instanceof Array;
  }
  function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
  }
  function isDate(val) {
    if (val instanceof Date)
      return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
  }
  function isRegexp(val) {
    if (val instanceof RegExp)
      return true;
    return typeof val.flags === "string" && typeof val.ignoreCase === "boolean" && typeof val.multiline === "boolean" && typeof val.global === "boolean";
  }
  function isGeneratorFn(name, val) {
    return ctorName(name) === "GeneratorFunction";
  }
  function isGeneratorObj(val) {
    return typeof val.throw === "function" && typeof val.return === "function" && typeof val.next === "function";
  }
  function isArguments(val) {
    try {
      if (typeof val.length === "number" && typeof val.callee === "function") {
        return true;
      }
    } catch (err) {
      if (err.message.indexOf("callee") !== -1) {
        return true;
      }
    }
    return false;
  }
  function isBuffer(val) {
    if (val.constructor && typeof val.constructor.isBuffer === "function") {
      return val.constructor.isBuffer(val);
    }
    return false;
  }
});

// node_modules/is-extendable/index.js
var require_is_extendable = __commonJS((exports, module) => {
  /*!
   * is-extendable <https://github.com/jonschlinkert/is-extendable>
   *
   * Copyright (c) 2015, Jon Schlinkert.
   * Licensed under the MIT License.
   */
  module.exports = function isExtendable(val) {
    return typeof val !== "undefined" && val !== null && (typeof val === "object" || typeof val === "function");
  };
});

// node_modules/extend-shallow/index.js
var require_extend_shallow = __commonJS((exports, module) => {
  var isObject = require_is_extendable();
  module.exports = function extend(o) {
    if (!isObject(o)) {
      o = {};
    }
    var len = arguments.length;
    for (var i = 1;i < len; i++) {
      var obj = arguments[i];
      if (isObject(obj)) {
        assign(o, obj);
      }
    }
    return o;
  };
  function assign(a, b) {
    for (var key in b) {
      if (hasOwn(b, key)) {
        a[key] = b[key];
      }
    }
  }
  function hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }
});

// node_modules/section-matter/index.js
var require_section_matter = __commonJS((exports, module) => {
  var typeOf = require_kind_of();
  var extend = require_extend_shallow();
  module.exports = function(input, options2) {
    if (typeof options2 === "function") {
      options2 = { parse: options2 };
    }
    var file = toObject(input);
    var defaults = { section_delimiter: "---", parse: identity };
    var opts = extend({}, defaults, options2);
    var delim = opts.section_delimiter;
    var lines = file.content.split(/\r?\n/);
    var sections = null;
    var section = createSection();
    var content = [];
    var stack = [];
    function initSections(val) {
      file.content = val;
      sections = [];
      content = [];
    }
    function closeSection(val) {
      if (stack.length) {
        section.key = getKey(stack[0], delim);
        section.content = val;
        opts.parse(section, sections);
        sections.push(section);
        section = createSection();
        content = [];
        stack = [];
      }
    }
    for (var i = 0;i < lines.length; i++) {
      var line = lines[i];
      var len = stack.length;
      var ln = line.trim();
      if (isDelimiter(ln, delim)) {
        if (ln.length === 3 && i !== 0) {
          if (len === 0 || len === 2) {
            content.push(line);
            continue;
          }
          stack.push(ln);
          section.data = content.join(`
`);
          content = [];
          continue;
        }
        if (sections === null) {
          initSections(content.join(`
`));
        }
        if (len === 2) {
          closeSection(content.join(`
`));
        }
        stack.push(ln);
        continue;
      }
      content.push(line);
    }
    if (sections === null) {
      initSections(content.join(`
`));
    } else {
      closeSection(content.join(`
`));
    }
    file.sections = sections;
    return file;
  };
  function isDelimiter(line, delim) {
    if (line.slice(0, delim.length) !== delim) {
      return false;
    }
    if (line.charAt(delim.length + 1) === delim.slice(-1)) {
      return false;
    }
    return true;
  }
  function toObject(input) {
    if (typeOf(input) !== "object") {
      input = { content: input };
    }
    if (typeof input.content !== "string" && !isBuffer(input.content)) {
      throw new TypeError("expected a buffer or string");
    }
    input.content = input.content.toString();
    input.sections = [];
    return input;
  }
  function getKey(val, delim) {
    return val ? val.slice(delim.length).trim() : "";
  }
  function createSection() {
    return { key: "", data: "", content: "" };
  }
  function identity(val) {
    return val;
  }
  function isBuffer(val) {
    if (val && val.constructor && typeof val.constructor.isBuffer === "function") {
      return val.constructor.isBuffer(val);
    }
    return false;
  }
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/common.js
var require_common = __commonJS((exports, module) => {
  function isNothing(subject) {
    return typeof subject === "undefined" || subject === null;
  }
  function isObject(subject) {
    return typeof subject === "object" && subject !== null;
  }
  function toArray(sequence) {
    if (Array.isArray(sequence))
      return sequence;
    else if (isNothing(sequence))
      return [];
    return [sequence];
  }
  function extend(target, source) {
    var index, length, key, sourceKeys;
    if (source) {
      sourceKeys = Object.keys(source);
      for (index = 0, length = sourceKeys.length;index < length; index += 1) {
        key = sourceKeys[index];
        target[key] = source[key];
      }
    }
    return target;
  }
  function repeat(string, count) {
    var result = "", cycle;
    for (cycle = 0;cycle < count; cycle += 1) {
      result += string;
    }
    return result;
  }
  function isNegativeZero(number) {
    return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
  }
  exports.isNothing = isNothing;
  exports.isObject = isObject;
  exports.toArray = toArray;
  exports.repeat = repeat;
  exports.isNegativeZero = isNegativeZero;
  exports.extend = extend;
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/exception.js
var require_exception = __commonJS((exports, module) => {
  function YAMLException(reason, mark) {
    Error.call(this);
    this.name = "YAMLException";
    this.reason = reason;
    this.mark = mark;
    this.message = (this.reason || "(unknown reason)") + (this.mark ? " " + this.mark.toString() : "");
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error().stack || "";
    }
  }
  YAMLException.prototype = Object.create(Error.prototype);
  YAMLException.prototype.constructor = YAMLException;
  YAMLException.prototype.toString = function toString(compact) {
    var result = this.name + ": ";
    result += this.reason || "(unknown reason)";
    if (!compact && this.mark) {
      result += " " + this.mark.toString();
    }
    return result;
  };
  module.exports = YAMLException;
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/mark.js
var require_mark = __commonJS((exports, module) => {
  var common = require_common();
  function Mark(name, buffer, position, line, column) {
    this.name = name;
    this.buffer = buffer;
    this.position = position;
    this.line = line;
    this.column = column;
  }
  Mark.prototype.getSnippet = function getSnippet(indent, maxLength) {
    var head, start, tail, end, snippet;
    if (!this.buffer)
      return null;
    indent = indent || 4;
    maxLength = maxLength || 75;
    head = "";
    start = this.position;
    while (start > 0 && `\x00\r
\u2028\u2029`.indexOf(this.buffer.charAt(start - 1)) === -1) {
      start -= 1;
      if (this.position - start > maxLength / 2 - 1) {
        head = " ... ";
        start += 5;
        break;
      }
    }
    tail = "";
    end = this.position;
    while (end < this.buffer.length && `\x00\r
\u2028\u2029`.indexOf(this.buffer.charAt(end)) === -1) {
      end += 1;
      if (end - this.position > maxLength / 2 - 1) {
        tail = " ... ";
        end -= 5;
        break;
      }
    }
    snippet = this.buffer.slice(start, end);
    return common.repeat(" ", indent) + head + snippet + tail + `
` + common.repeat(" ", indent + this.position - start + head.length) + "^";
  };
  Mark.prototype.toString = function toString(compact) {
    var snippet, where = "";
    if (this.name) {
      where += 'in "' + this.name + '" ';
    }
    where += "at line " + (this.line + 1) + ", column " + (this.column + 1);
    if (!compact) {
      snippet = this.getSnippet();
      if (snippet) {
        where += `:
` + snippet;
      }
    }
    return where;
  };
  module.exports = Mark;
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type.js
var require_type = __commonJS((exports, module) => {
  var YAMLException = require_exception();
  var TYPE_CONSTRUCTOR_OPTIONS = [
    "kind",
    "resolve",
    "construct",
    "instanceOf",
    "predicate",
    "represent",
    "defaultStyle",
    "styleAliases"
  ];
  var YAML_NODE_KINDS = [
    "scalar",
    "sequence",
    "mapping"
  ];
  function compileStyleAliases(map) {
    var result = {};
    if (map !== null) {
      Object.keys(map).forEach(function(style) {
        map[style].forEach(function(alias) {
          result[String(alias)] = style;
        });
      });
    }
    return result;
  }
  function Type(tag, options2) {
    options2 = options2 || {};
    Object.keys(options2).forEach(function(name) {
      if (TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) {
        throw new YAMLException('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
      }
    });
    this.tag = tag;
    this.kind = options2["kind"] || null;
    this.resolve = options2["resolve"] || function() {
      return true;
    };
    this.construct = options2["construct"] || function(data) {
      return data;
    };
    this.instanceOf = options2["instanceOf"] || null;
    this.predicate = options2["predicate"] || null;
    this.represent = options2["represent"] || null;
    this.defaultStyle = options2["defaultStyle"] || null;
    this.styleAliases = compileStyleAliases(options2["styleAliases"] || null);
    if (YAML_NODE_KINDS.indexOf(this.kind) === -1) {
      throw new YAMLException('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
    }
  }
  module.exports = Type;
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/schema.js
var require_schema = __commonJS((exports, module) => {
  var common = require_common();
  var YAMLException = require_exception();
  var Type = require_type();
  function compileList(schema, name, result) {
    var exclude = [];
    schema.include.forEach(function(includedSchema) {
      result = compileList(includedSchema, name, result);
    });
    schema[name].forEach(function(currentType) {
      result.forEach(function(previousType, previousIndex) {
        if (previousType.tag === currentType.tag && previousType.kind === currentType.kind) {
          exclude.push(previousIndex);
        }
      });
      result.push(currentType);
    });
    return result.filter(function(type, index) {
      return exclude.indexOf(index) === -1;
    });
  }
  function compileMap() {
    var result = {
      scalar: {},
      sequence: {},
      mapping: {},
      fallback: {}
    }, index, length;
    function collectType(type) {
      result[type.kind][type.tag] = result["fallback"][type.tag] = type;
    }
    for (index = 0, length = arguments.length;index < length; index += 1) {
      arguments[index].forEach(collectType);
    }
    return result;
  }
  function Schema(definition) {
    this.include = definition.include || [];
    this.implicit = definition.implicit || [];
    this.explicit = definition.explicit || [];
    this.implicit.forEach(function(type) {
      if (type.loadKind && type.loadKind !== "scalar") {
        throw new YAMLException("There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.");
      }
    });
    this.compiledImplicit = compileList(this, "implicit", []);
    this.compiledExplicit = compileList(this, "explicit", []);
    this.compiledTypeMap = compileMap(this.compiledImplicit, this.compiledExplicit);
  }
  Schema.DEFAULT = null;
  Schema.create = function createSchema() {
    var schemas, types;
    switch (arguments.length) {
      case 1:
        schemas = Schema.DEFAULT;
        types = arguments[0];
        break;
      case 2:
        schemas = arguments[0];
        types = arguments[1];
        break;
      default:
        throw new YAMLException("Wrong number of arguments for Schema.create function");
    }
    schemas = common.toArray(schemas);
    types = common.toArray(types);
    if (!schemas.every(function(schema) {
      return schema instanceof Schema;
    })) {
      throw new YAMLException("Specified list of super schemas (or a single Schema object) contains a non-Schema object.");
    }
    if (!types.every(function(type) {
      return type instanceof Type;
    })) {
      throw new YAMLException("Specified list of YAML types (or a single Type object) contains a non-Type object.");
    }
    return new Schema({
      include: schemas,
      explicit: types
    });
  };
  module.exports = Schema;
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/str.js
var require_str = __commonJS((exports, module) => {
  var Type = require_type();
  module.exports = new Type("tag:yaml.org,2002:str", {
    kind: "scalar",
    construct: function(data) {
      return data !== null ? data : "";
    }
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/seq.js
var require_seq = __commonJS((exports, module) => {
  var Type = require_type();
  module.exports = new Type("tag:yaml.org,2002:seq", {
    kind: "sequence",
    construct: function(data) {
      return data !== null ? data : [];
    }
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/map.js
var require_map = __commonJS((exports, module) => {
  var Type = require_type();
  module.exports = new Type("tag:yaml.org,2002:map", {
    kind: "mapping",
    construct: function(data) {
      return data !== null ? data : {};
    }
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/schema/failsafe.js
var require_failsafe = __commonJS((exports, module) => {
  var Schema = require_schema();
  module.exports = new Schema({
    explicit: [
      require_str(),
      require_seq(),
      require_map()
    ]
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/null.js
var require_null = __commonJS((exports, module) => {
  var Type = require_type();
  function resolveYamlNull(data) {
    if (data === null)
      return true;
    var max = data.length;
    return max === 1 && data === "~" || max === 4 && (data === "null" || data === "Null" || data === "NULL");
  }
  function constructYamlNull() {
    return null;
  }
  function isNull(object) {
    return object === null;
  }
  module.exports = new Type("tag:yaml.org,2002:null", {
    kind: "scalar",
    resolve: resolveYamlNull,
    construct: constructYamlNull,
    predicate: isNull,
    represent: {
      canonical: function() {
        return "~";
      },
      lowercase: function() {
        return "null";
      },
      uppercase: function() {
        return "NULL";
      },
      camelcase: function() {
        return "Null";
      }
    },
    defaultStyle: "lowercase"
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/bool.js
var require_bool = __commonJS((exports, module) => {
  var Type = require_type();
  function resolveYamlBoolean(data) {
    if (data === null)
      return false;
    var max = data.length;
    return max === 4 && (data === "true" || data === "True" || data === "TRUE") || max === 5 && (data === "false" || data === "False" || data === "FALSE");
  }
  function constructYamlBoolean(data) {
    return data === "true" || data === "True" || data === "TRUE";
  }
  function isBoolean(object) {
    return Object.prototype.toString.call(object) === "[object Boolean]";
  }
  module.exports = new Type("tag:yaml.org,2002:bool", {
    kind: "scalar",
    resolve: resolveYamlBoolean,
    construct: constructYamlBoolean,
    predicate: isBoolean,
    represent: {
      lowercase: function(object) {
        return object ? "true" : "false";
      },
      uppercase: function(object) {
        return object ? "TRUE" : "FALSE";
      },
      camelcase: function(object) {
        return object ? "True" : "False";
      }
    },
    defaultStyle: "lowercase"
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/int.js
var require_int = __commonJS((exports, module) => {
  var common = require_common();
  var Type = require_type();
  function isHexCode(c) {
    return 48 <= c && c <= 57 || 65 <= c && c <= 70 || 97 <= c && c <= 102;
  }
  function isOctCode(c) {
    return 48 <= c && c <= 55;
  }
  function isDecCode(c) {
    return 48 <= c && c <= 57;
  }
  function resolveYamlInteger(data) {
    if (data === null)
      return false;
    var max = data.length, index = 0, hasDigits = false, ch;
    if (!max)
      return false;
    ch = data[index];
    if (ch === "-" || ch === "+") {
      ch = data[++index];
    }
    if (ch === "0") {
      if (index + 1 === max)
        return true;
      ch = data[++index];
      if (ch === "b") {
        index++;
        for (;index < max; index++) {
          ch = data[index];
          if (ch === "_")
            continue;
          if (ch !== "0" && ch !== "1")
            return false;
          hasDigits = true;
        }
        return hasDigits && ch !== "_";
      }
      if (ch === "x") {
        index++;
        for (;index < max; index++) {
          ch = data[index];
          if (ch === "_")
            continue;
          if (!isHexCode(data.charCodeAt(index)))
            return false;
          hasDigits = true;
        }
        return hasDigits && ch !== "_";
      }
      for (;index < max; index++) {
        ch = data[index];
        if (ch === "_")
          continue;
        if (!isOctCode(data.charCodeAt(index)))
          return false;
        hasDigits = true;
      }
      return hasDigits && ch !== "_";
    }
    if (ch === "_")
      return false;
    for (;index < max; index++) {
      ch = data[index];
      if (ch === "_")
        continue;
      if (ch === ":")
        break;
      if (!isDecCode(data.charCodeAt(index))) {
        return false;
      }
      hasDigits = true;
    }
    if (!hasDigits || ch === "_")
      return false;
    if (ch !== ":")
      return true;
    return /^(:[0-5]?[0-9])+$/.test(data.slice(index));
  }
  function constructYamlInteger(data) {
    var value = data, sign = 1, ch, base, digits = [];
    if (value.indexOf("_") !== -1) {
      value = value.replace(/_/g, "");
    }
    ch = value[0];
    if (ch === "-" || ch === "+") {
      if (ch === "-")
        sign = -1;
      value = value.slice(1);
      ch = value[0];
    }
    if (value === "0")
      return 0;
    if (ch === "0") {
      if (value[1] === "b")
        return sign * parseInt(value.slice(2), 2);
      if (value[1] === "x")
        return sign * parseInt(value, 16);
      return sign * parseInt(value, 8);
    }
    if (value.indexOf(":") !== -1) {
      value.split(":").forEach(function(v) {
        digits.unshift(parseInt(v, 10));
      });
      value = 0;
      base = 1;
      digits.forEach(function(d) {
        value += d * base;
        base *= 60;
      });
      return sign * value;
    }
    return sign * parseInt(value, 10);
  }
  function isInteger(object) {
    return Object.prototype.toString.call(object) === "[object Number]" && (object % 1 === 0 && !common.isNegativeZero(object));
  }
  module.exports = new Type("tag:yaml.org,2002:int", {
    kind: "scalar",
    resolve: resolveYamlInteger,
    construct: constructYamlInteger,
    predicate: isInteger,
    represent: {
      binary: function(obj) {
        return obj >= 0 ? "0b" + obj.toString(2) : "-0b" + obj.toString(2).slice(1);
      },
      octal: function(obj) {
        return obj >= 0 ? "0" + obj.toString(8) : "-0" + obj.toString(8).slice(1);
      },
      decimal: function(obj) {
        return obj.toString(10);
      },
      hexadecimal: function(obj) {
        return obj >= 0 ? "0x" + obj.toString(16).toUpperCase() : "-0x" + obj.toString(16).toUpperCase().slice(1);
      }
    },
    defaultStyle: "decimal",
    styleAliases: {
      binary: [2, "bin"],
      octal: [8, "oct"],
      decimal: [10, "dec"],
      hexadecimal: [16, "hex"]
    }
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/float.js
var require_float = __commonJS((exports, module) => {
  var common = require_common();
  var Type = require_type();
  var YAML_FLOAT_PATTERN = new RegExp("^(?:[-+]?(?:0|[1-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?" + "|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?" + "|[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\\.[0-9_]*" + "|[-+]?\\.(?:inf|Inf|INF)" + "|\\.(?:nan|NaN|NAN))$");
  function resolveYamlFloat(data) {
    if (data === null)
      return false;
    if (!YAML_FLOAT_PATTERN.test(data) || data[data.length - 1] === "_") {
      return false;
    }
    return true;
  }
  function constructYamlFloat(data) {
    var value, sign, base, digits;
    value = data.replace(/_/g, "").toLowerCase();
    sign = value[0] === "-" ? -1 : 1;
    digits = [];
    if ("+-".indexOf(value[0]) >= 0) {
      value = value.slice(1);
    }
    if (value === ".inf") {
      return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    } else if (value === ".nan") {
      return NaN;
    } else if (value.indexOf(":") >= 0) {
      value.split(":").forEach(function(v) {
        digits.unshift(parseFloat(v, 10));
      });
      value = 0;
      base = 1;
      digits.forEach(function(d) {
        value += d * base;
        base *= 60;
      });
      return sign * value;
    }
    return sign * parseFloat(value, 10);
  }
  var SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
  function representYamlFloat(object, style) {
    var res;
    if (isNaN(object)) {
      switch (style) {
        case "lowercase":
          return ".nan";
        case "uppercase":
          return ".NAN";
        case "camelcase":
          return ".NaN";
      }
    } else if (Number.POSITIVE_INFINITY === object) {
      switch (style) {
        case "lowercase":
          return ".inf";
        case "uppercase":
          return ".INF";
        case "camelcase":
          return ".Inf";
      }
    } else if (Number.NEGATIVE_INFINITY === object) {
      switch (style) {
        case "lowercase":
          return "-.inf";
        case "uppercase":
          return "-.INF";
        case "camelcase":
          return "-.Inf";
      }
    } else if (common.isNegativeZero(object)) {
      return "-0.0";
    }
    res = object.toString(10);
    return SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace("e", ".e") : res;
  }
  function isFloat(object) {
    return Object.prototype.toString.call(object) === "[object Number]" && (object % 1 !== 0 || common.isNegativeZero(object));
  }
  module.exports = new Type("tag:yaml.org,2002:float", {
    kind: "scalar",
    resolve: resolveYamlFloat,
    construct: constructYamlFloat,
    predicate: isFloat,
    represent: representYamlFloat,
    defaultStyle: "lowercase"
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/schema/json.js
var require_json = __commonJS((exports, module) => {
  var Schema = require_schema();
  module.exports = new Schema({
    include: [
      require_failsafe()
    ],
    implicit: [
      require_null(),
      require_bool(),
      require_int(),
      require_float()
    ]
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/schema/core.js
var require_core = __commonJS((exports, module) => {
  var Schema = require_schema();
  module.exports = new Schema({
    include: [
      require_json()
    ]
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/timestamp.js
var require_timestamp = __commonJS((exports, module) => {
  var Type = require_type();
  var YAML_DATE_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])" + "-([0-9][0-9])" + "-([0-9][0-9])$");
  var YAML_TIMESTAMP_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])" + "-([0-9][0-9]?)" + "-([0-9][0-9]?)" + "(?:[Tt]|[ \\t]+)" + "([0-9][0-9]?)" + ":([0-9][0-9])" + ":([0-9][0-9])" + "(?:\\.([0-9]*))?" + "(?:[ \\t]*(Z|([-+])([0-9][0-9]?)" + "(?::([0-9][0-9]))?))?$");
  function resolveYamlTimestamp(data) {
    if (data === null)
      return false;
    if (YAML_DATE_REGEXP.exec(data) !== null)
      return true;
    if (YAML_TIMESTAMP_REGEXP.exec(data) !== null)
      return true;
    return false;
  }
  function constructYamlTimestamp(data) {
    var match, year, month, day, hour, minute, second, fraction = 0, delta = null, tz_hour, tz_minute, date;
    match = YAML_DATE_REGEXP.exec(data);
    if (match === null)
      match = YAML_TIMESTAMP_REGEXP.exec(data);
    if (match === null)
      throw new Error("Date resolve error");
    year = +match[1];
    month = +match[2] - 1;
    day = +match[3];
    if (!match[4]) {
      return new Date(Date.UTC(year, month, day));
    }
    hour = +match[4];
    minute = +match[5];
    second = +match[6];
    if (match[7]) {
      fraction = match[7].slice(0, 3);
      while (fraction.length < 3) {
        fraction += "0";
      }
      fraction = +fraction;
    }
    if (match[9]) {
      tz_hour = +match[10];
      tz_minute = +(match[11] || 0);
      delta = (tz_hour * 60 + tz_minute) * 60000;
      if (match[9] === "-")
        delta = -delta;
    }
    date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
    if (delta)
      date.setTime(date.getTime() - delta);
    return date;
  }
  function representYamlTimestamp(object) {
    return object.toISOString();
  }
  module.exports = new Type("tag:yaml.org,2002:timestamp", {
    kind: "scalar",
    resolve: resolveYamlTimestamp,
    construct: constructYamlTimestamp,
    instanceOf: Date,
    represent: representYamlTimestamp
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/merge.js
var require_merge = __commonJS((exports, module) => {
  var Type = require_type();
  function resolveYamlMerge(data) {
    return data === "<<" || data === null;
  }
  module.exports = new Type("tag:yaml.org,2002:merge", {
    kind: "scalar",
    resolve: resolveYamlMerge
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/binary.js
var require_binary = __commonJS((exports, module) => {
  var NodeBuffer;
  try {
    _require = __require;
    NodeBuffer = _require("buffer").Buffer;
  } catch (__) {}
  var _require;
  var Type = require_type();
  var BASE64_MAP = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
\r`;
  function resolveYamlBinary(data) {
    if (data === null)
      return false;
    var code, idx, bitlen = 0, max = data.length, map = BASE64_MAP;
    for (idx = 0;idx < max; idx++) {
      code = map.indexOf(data.charAt(idx));
      if (code > 64)
        continue;
      if (code < 0)
        return false;
      bitlen += 6;
    }
    return bitlen % 8 === 0;
  }
  function constructYamlBinary(data) {
    var idx, tailbits, input = data.replace(/[\r\n=]/g, ""), max = input.length, map = BASE64_MAP, bits = 0, result = [];
    for (idx = 0;idx < max; idx++) {
      if (idx % 4 === 0 && idx) {
        result.push(bits >> 16 & 255);
        result.push(bits >> 8 & 255);
        result.push(bits & 255);
      }
      bits = bits << 6 | map.indexOf(input.charAt(idx));
    }
    tailbits = max % 4 * 6;
    if (tailbits === 0) {
      result.push(bits >> 16 & 255);
      result.push(bits >> 8 & 255);
      result.push(bits & 255);
    } else if (tailbits === 18) {
      result.push(bits >> 10 & 255);
      result.push(bits >> 2 & 255);
    } else if (tailbits === 12) {
      result.push(bits >> 4 & 255);
    }
    if (NodeBuffer) {
      return NodeBuffer.from ? NodeBuffer.from(result) : new NodeBuffer(result);
    }
    return result;
  }
  function representYamlBinary(object) {
    var result = "", bits = 0, idx, tail, max = object.length, map = BASE64_MAP;
    for (idx = 0;idx < max; idx++) {
      if (idx % 3 === 0 && idx) {
        result += map[bits >> 18 & 63];
        result += map[bits >> 12 & 63];
        result += map[bits >> 6 & 63];
        result += map[bits & 63];
      }
      bits = (bits << 8) + object[idx];
    }
    tail = max % 3;
    if (tail === 0) {
      result += map[bits >> 18 & 63];
      result += map[bits >> 12 & 63];
      result += map[bits >> 6 & 63];
      result += map[bits & 63];
    } else if (tail === 2) {
      result += map[bits >> 10 & 63];
      result += map[bits >> 4 & 63];
      result += map[bits << 2 & 63];
      result += map[64];
    } else if (tail === 1) {
      result += map[bits >> 2 & 63];
      result += map[bits << 4 & 63];
      result += map[64];
      result += map[64];
    }
    return result;
  }
  function isBinary(object) {
    return NodeBuffer && NodeBuffer.isBuffer(object);
  }
  module.exports = new Type("tag:yaml.org,2002:binary", {
    kind: "scalar",
    resolve: resolveYamlBinary,
    construct: constructYamlBinary,
    predicate: isBinary,
    represent: representYamlBinary
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/omap.js
var require_omap = __commonJS((exports, module) => {
  var Type = require_type();
  var _hasOwnProperty = Object.prototype.hasOwnProperty;
  var _toString = Object.prototype.toString;
  function resolveYamlOmap(data) {
    if (data === null)
      return true;
    var objectKeys = [], index, length, pair, pairKey, pairHasKey, object = data;
    for (index = 0, length = object.length;index < length; index += 1) {
      pair = object[index];
      pairHasKey = false;
      if (_toString.call(pair) !== "[object Object]")
        return false;
      for (pairKey in pair) {
        if (_hasOwnProperty.call(pair, pairKey)) {
          if (!pairHasKey)
            pairHasKey = true;
          else
            return false;
        }
      }
      if (!pairHasKey)
        return false;
      if (objectKeys.indexOf(pairKey) === -1)
        objectKeys.push(pairKey);
      else
        return false;
    }
    return true;
  }
  function constructYamlOmap(data) {
    return data !== null ? data : [];
  }
  module.exports = new Type("tag:yaml.org,2002:omap", {
    kind: "sequence",
    resolve: resolveYamlOmap,
    construct: constructYamlOmap
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/pairs.js
var require_pairs = __commonJS((exports, module) => {
  var Type = require_type();
  var _toString = Object.prototype.toString;
  function resolveYamlPairs(data) {
    if (data === null)
      return true;
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for (index = 0, length = object.length;index < length; index += 1) {
      pair = object[index];
      if (_toString.call(pair) !== "[object Object]")
        return false;
      keys = Object.keys(pair);
      if (keys.length !== 1)
        return false;
      result[index] = [keys[0], pair[keys[0]]];
    }
    return true;
  }
  function constructYamlPairs(data) {
    if (data === null)
      return [];
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for (index = 0, length = object.length;index < length; index += 1) {
      pair = object[index];
      keys = Object.keys(pair);
      result[index] = [keys[0], pair[keys[0]]];
    }
    return result;
  }
  module.exports = new Type("tag:yaml.org,2002:pairs", {
    kind: "sequence",
    resolve: resolveYamlPairs,
    construct: constructYamlPairs
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/set.js
var require_set = __commonJS((exports, module) => {
  var Type = require_type();
  var _hasOwnProperty = Object.prototype.hasOwnProperty;
  function resolveYamlSet(data) {
    if (data === null)
      return true;
    var key, object = data;
    for (key in object) {
      if (_hasOwnProperty.call(object, key)) {
        if (object[key] !== null)
          return false;
      }
    }
    return true;
  }
  function constructYamlSet(data) {
    return data !== null ? data : {};
  }
  module.exports = new Type("tag:yaml.org,2002:set", {
    kind: "mapping",
    resolve: resolveYamlSet,
    construct: constructYamlSet
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/schema/default_safe.js
var require_default_safe = __commonJS((exports, module) => {
  var Schema = require_schema();
  module.exports = new Schema({
    include: [
      require_core()
    ],
    implicit: [
      require_timestamp(),
      require_merge()
    ],
    explicit: [
      require_binary(),
      require_omap(),
      require_pairs(),
      require_set()
    ]
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/js/undefined.js
var require_undefined = __commonJS((exports, module) => {
  var Type = require_type();
  function resolveJavascriptUndefined() {
    return true;
  }
  function constructJavascriptUndefined() {
    return;
  }
  function representJavascriptUndefined() {
    return "";
  }
  function isUndefined(object) {
    return typeof object === "undefined";
  }
  module.exports = new Type("tag:yaml.org,2002:js/undefined", {
    kind: "scalar",
    resolve: resolveJavascriptUndefined,
    construct: constructJavascriptUndefined,
    predicate: isUndefined,
    represent: representJavascriptUndefined
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/js/regexp.js
var require_regexp = __commonJS((exports, module) => {
  var Type = require_type();
  function resolveJavascriptRegExp(data) {
    if (data === null)
      return false;
    if (data.length === 0)
      return false;
    var regexp = data, tail = /\/([gim]*)$/.exec(data), modifiers = "";
    if (regexp[0] === "/") {
      if (tail)
        modifiers = tail[1];
      if (modifiers.length > 3)
        return false;
      if (regexp[regexp.length - modifiers.length - 1] !== "/")
        return false;
    }
    return true;
  }
  function constructJavascriptRegExp(data) {
    var regexp = data, tail = /\/([gim]*)$/.exec(data), modifiers = "";
    if (regexp[0] === "/") {
      if (tail)
        modifiers = tail[1];
      regexp = regexp.slice(1, regexp.length - modifiers.length - 1);
    }
    return new RegExp(regexp, modifiers);
  }
  function representJavascriptRegExp(object) {
    var result = "/" + object.source + "/";
    if (object.global)
      result += "g";
    if (object.multiline)
      result += "m";
    if (object.ignoreCase)
      result += "i";
    return result;
  }
  function isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
  }
  module.exports = new Type("tag:yaml.org,2002:js/regexp", {
    kind: "scalar",
    resolve: resolveJavascriptRegExp,
    construct: constructJavascriptRegExp,
    predicate: isRegExp,
    represent: representJavascriptRegExp
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/type/js/function.js
var require_function = __commonJS((exports, module) => {
  var esprima;
  try {
    _require = __require;
    esprima = _require("esprima");
  } catch (_) {
    if (typeof window !== "undefined")
      esprima = window.esprima;
  }
  var _require;
  var Type = require_type();
  function resolveJavascriptFunction(data) {
    if (data === null)
      return false;
    try {
      var source = "(" + data + ")", ast = esprima.parse(source, { range: true });
      if (ast.type !== "Program" || ast.body.length !== 1 || ast.body[0].type !== "ExpressionStatement" || ast.body[0].expression.type !== "ArrowFunctionExpression" && ast.body[0].expression.type !== "FunctionExpression") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  function constructJavascriptFunction(data) {
    var source = "(" + data + ")", ast = esprima.parse(source, { range: true }), params = [], body;
    if (ast.type !== "Program" || ast.body.length !== 1 || ast.body[0].type !== "ExpressionStatement" || ast.body[0].expression.type !== "ArrowFunctionExpression" && ast.body[0].expression.type !== "FunctionExpression") {
      throw new Error("Failed to resolve function");
    }
    ast.body[0].expression.params.forEach(function(param) {
      params.push(param.name);
    });
    body = ast.body[0].expression.body.range;
    if (ast.body[0].expression.body.type === "BlockStatement") {
      return new Function(params, source.slice(body[0] + 1, body[1] - 1));
    }
    return new Function(params, "return " + source.slice(body[0], body[1]));
  }
  function representJavascriptFunction(object) {
    return object.toString();
  }
  function isFunction(object) {
    return Object.prototype.toString.call(object) === "[object Function]";
  }
  module.exports = new Type("tag:yaml.org,2002:js/function", {
    kind: "scalar",
    resolve: resolveJavascriptFunction,
    construct: constructJavascriptFunction,
    predicate: isFunction,
    represent: representJavascriptFunction
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/schema/default_full.js
var require_default_full = __commonJS((exports, module) => {
  var Schema = require_schema();
  module.exports = Schema.DEFAULT = new Schema({
    include: [
      require_default_safe()
    ],
    explicit: [
      require_undefined(),
      require_regexp(),
      require_function()
    ]
  });
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/loader.js
var require_loader = __commonJS((exports, module) => {
  var common = require_common();
  var YAMLException = require_exception();
  var Mark = require_mark();
  var DEFAULT_SAFE_SCHEMA = require_default_safe();
  var DEFAULT_FULL_SCHEMA = require_default_full();
  var _hasOwnProperty = Object.prototype.hasOwnProperty;
  var CONTEXT_FLOW_IN = 1;
  var CONTEXT_FLOW_OUT = 2;
  var CONTEXT_BLOCK_IN = 3;
  var CONTEXT_BLOCK_OUT = 4;
  var CHOMPING_CLIP = 1;
  var CHOMPING_STRIP = 2;
  var CHOMPING_KEEP = 3;
  var PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
  var PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
  var PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
  var PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
  var PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
  function _class(obj) {
    return Object.prototype.toString.call(obj);
  }
  function is_EOL(c) {
    return c === 10 || c === 13;
  }
  function is_WHITE_SPACE(c) {
    return c === 9 || c === 32;
  }
  function is_WS_OR_EOL(c) {
    return c === 9 || c === 32 || c === 10 || c === 13;
  }
  function is_FLOW_INDICATOR(c) {
    return c === 44 || c === 91 || c === 93 || c === 123 || c === 125;
  }
  function fromHexCode(c) {
    var lc;
    if (48 <= c && c <= 57) {
      return c - 48;
    }
    lc = c | 32;
    if (97 <= lc && lc <= 102) {
      return lc - 97 + 10;
    }
    return -1;
  }
  function escapedHexLen(c) {
    if (c === 120) {
      return 2;
    }
    if (c === 117) {
      return 4;
    }
    if (c === 85) {
      return 8;
    }
    return 0;
  }
  function fromDecimalCode(c) {
    if (48 <= c && c <= 57) {
      return c - 48;
    }
    return -1;
  }
  function simpleEscapeSequence(c) {
    return c === 48 ? "\x00" : c === 97 ? "\x07" : c === 98 ? "\b" : c === 116 ? "\t" : c === 9 ? "\t" : c === 110 ? `
` : c === 118 ? "\v" : c === 102 ? "\f" : c === 114 ? "\r" : c === 101 ? "\x1B" : c === 32 ? " " : c === 34 ? '"' : c === 47 ? "/" : c === 92 ? "\\" : c === 78 ? "" : c === 95 ? " " : c === 76 ? "\u2028" : c === 80 ? "\u2029" : "";
  }
  function charFromCodepoint(c) {
    if (c <= 65535) {
      return String.fromCharCode(c);
    }
    return String.fromCharCode((c - 65536 >> 10) + 55296, (c - 65536 & 1023) + 56320);
  }
  function setProperty(object, key, value) {
    if (key === "__proto__") {
      Object.defineProperty(object, key, {
        configurable: true,
        enumerable: true,
        writable: true,
        value
      });
    } else {
      object[key] = value;
    }
  }
  var simpleEscapeCheck = new Array(256);
  var simpleEscapeMap = new Array(256);
  for (i = 0;i < 256; i++) {
    simpleEscapeCheck[i] = simpleEscapeSequence(i) ? 1 : 0;
    simpleEscapeMap[i] = simpleEscapeSequence(i);
  }
  var i;
  function State(input, options2) {
    this.input = input;
    this.filename = options2["filename"] || null;
    this.schema = options2["schema"] || DEFAULT_FULL_SCHEMA;
    this.onWarning = options2["onWarning"] || null;
    this.legacy = options2["legacy"] || false;
    this.json = options2["json"] || false;
    this.listener = options2["listener"] || null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.typeMap = this.schema.compiledTypeMap;
    this.length = input.length;
    this.position = 0;
    this.line = 0;
    this.lineStart = 0;
    this.lineIndent = 0;
    this.documents = [];
  }
  function generateError(state, message) {
    return new YAMLException(message, new Mark(state.filename, state.input, state.position, state.line, state.position - state.lineStart));
  }
  function throwError(state, message) {
    throw generateError(state, message);
  }
  function throwWarning(state, message) {
    if (state.onWarning) {
      state.onWarning.call(null, generateError(state, message));
    }
  }
  var directiveHandlers = {
    YAML: function handleYamlDirective(state, name, args) {
      var match, major, minor;
      if (state.version !== null) {
        throwError(state, "duplication of %YAML directive");
      }
      if (args.length !== 1) {
        throwError(state, "YAML directive accepts exactly one argument");
      }
      match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
      if (match === null) {
        throwError(state, "ill-formed argument of the YAML directive");
      }
      major = parseInt(match[1], 10);
      minor = parseInt(match[2], 10);
      if (major !== 1) {
        throwError(state, "unacceptable YAML version of the document");
      }
      state.version = args[0];
      state.checkLineBreaks = minor < 2;
      if (minor !== 1 && minor !== 2) {
        throwWarning(state, "unsupported YAML version of the document");
      }
    },
    TAG: function handleTagDirective(state, name, args) {
      var handle, prefix;
      if (args.length !== 2) {
        throwError(state, "TAG directive accepts exactly two arguments");
      }
      handle = args[0];
      prefix = args[1];
      if (!PATTERN_TAG_HANDLE.test(handle)) {
        throwError(state, "ill-formed tag handle (first argument) of the TAG directive");
      }
      if (_hasOwnProperty.call(state.tagMap, handle)) {
        throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
      }
      if (!PATTERN_TAG_URI.test(prefix)) {
        throwError(state, "ill-formed tag prefix (second argument) of the TAG directive");
      }
      state.tagMap[handle] = prefix;
    }
  };
  function captureSegment(state, start, end, checkJson) {
    var _position, _length, _character, _result;
    if (start < end) {
      _result = state.input.slice(start, end);
      if (checkJson) {
        for (_position = 0, _length = _result.length;_position < _length; _position += 1) {
          _character = _result.charCodeAt(_position);
          if (!(_character === 9 || 32 <= _character && _character <= 1114111)) {
            throwError(state, "expected valid JSON character");
          }
        }
      } else if (PATTERN_NON_PRINTABLE.test(_result)) {
        throwError(state, "the stream contains non-printable characters");
      }
      state.result += _result;
    }
  }
  function mergeMappings(state, destination, source, overridableKeys) {
    var sourceKeys, key, index, quantity;
    if (!common.isObject(source)) {
      throwError(state, "cannot merge mappings; the provided source object is unacceptable");
    }
    sourceKeys = Object.keys(source);
    for (index = 0, quantity = sourceKeys.length;index < quantity; index += 1) {
      key = sourceKeys[index];
      if (!_hasOwnProperty.call(destination, key)) {
        setProperty(destination, key, source[key]);
        overridableKeys[key] = true;
      }
    }
  }
  function storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startPos) {
    var index, quantity;
    if (Array.isArray(keyNode)) {
      keyNode = Array.prototype.slice.call(keyNode);
      for (index = 0, quantity = keyNode.length;index < quantity; index += 1) {
        if (Array.isArray(keyNode[index])) {
          throwError(state, "nested arrays are not supported inside keys");
        }
        if (typeof keyNode === "object" && _class(keyNode[index]) === "[object Object]") {
          keyNode[index] = "[object Object]";
        }
      }
    }
    if (typeof keyNode === "object" && _class(keyNode) === "[object Object]") {
      keyNode = "[object Object]";
    }
    keyNode = String(keyNode);
    if (_result === null) {
      _result = {};
    }
    if (keyTag === "tag:yaml.org,2002:merge") {
      if (Array.isArray(valueNode)) {
        for (index = 0, quantity = valueNode.length;index < quantity; index += 1) {
          mergeMappings(state, _result, valueNode[index], overridableKeys);
        }
      } else {
        mergeMappings(state, _result, valueNode, overridableKeys);
      }
    } else {
      if (!state.json && !_hasOwnProperty.call(overridableKeys, keyNode) && _hasOwnProperty.call(_result, keyNode)) {
        state.line = startLine || state.line;
        state.position = startPos || state.position;
        throwError(state, "duplicated mapping key");
      }
      setProperty(_result, keyNode, valueNode);
      delete overridableKeys[keyNode];
    }
    return _result;
  }
  function readLineBreak(state) {
    var ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 10) {
      state.position++;
    } else if (ch === 13) {
      state.position++;
      if (state.input.charCodeAt(state.position) === 10) {
        state.position++;
      }
    } else {
      throwError(state, "a line break is expected");
    }
    state.line += 1;
    state.lineStart = state.position;
  }
  function skipSeparationSpace(state, allowComments, checkIndent) {
    var lineBreaks = 0, ch = state.input.charCodeAt(state.position);
    while (ch !== 0) {
      while (is_WHITE_SPACE(ch)) {
        ch = state.input.charCodeAt(++state.position);
      }
      if (allowComments && ch === 35) {
        do {
          ch = state.input.charCodeAt(++state.position);
        } while (ch !== 10 && ch !== 13 && ch !== 0);
      }
      if (is_EOL(ch)) {
        readLineBreak(state);
        ch = state.input.charCodeAt(state.position);
        lineBreaks++;
        state.lineIndent = 0;
        while (ch === 32) {
          state.lineIndent++;
          ch = state.input.charCodeAt(++state.position);
        }
      } else {
        break;
      }
    }
    if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) {
      throwWarning(state, "deficient indentation");
    }
    return lineBreaks;
  }
  function testDocumentSeparator(state) {
    var _position = state.position, ch;
    ch = state.input.charCodeAt(_position);
    if ((ch === 45 || ch === 46) && ch === state.input.charCodeAt(_position + 1) && ch === state.input.charCodeAt(_position + 2)) {
      _position += 3;
      ch = state.input.charCodeAt(_position);
      if (ch === 0 || is_WS_OR_EOL(ch)) {
        return true;
      }
    }
    return false;
  }
  function writeFoldedLines(state, count) {
    if (count === 1) {
      state.result += " ";
    } else if (count > 1) {
      state.result += common.repeat(`
`, count - 1);
    }
  }
  function readPlainScalar(state, nodeIndent, withinFlowCollection) {
    var preceding, following, captureStart, captureEnd, hasPendingContent, _line, _lineStart, _lineIndent, _kind = state.kind, _result = state.result, ch;
    ch = state.input.charCodeAt(state.position);
    if (is_WS_OR_EOL(ch) || is_FLOW_INDICATOR(ch) || ch === 35 || ch === 38 || ch === 42 || ch === 33 || ch === 124 || ch === 62 || ch === 39 || ch === 34 || ch === 37 || ch === 64 || ch === 96) {
      return false;
    }
    if (ch === 63 || ch === 45) {
      following = state.input.charCodeAt(state.position + 1);
      if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) {
        return false;
      }
    }
    state.kind = "scalar";
    state.result = "";
    captureStart = captureEnd = state.position;
    hasPendingContent = false;
    while (ch !== 0) {
      if (ch === 58) {
        following = state.input.charCodeAt(state.position + 1);
        if (is_WS_OR_EOL(following) || withinFlowCollection && is_FLOW_INDICATOR(following)) {
          break;
        }
      } else if (ch === 35) {
        preceding = state.input.charCodeAt(state.position - 1);
        if (is_WS_OR_EOL(preceding)) {
          break;
        }
      } else if (state.position === state.lineStart && testDocumentSeparator(state) || withinFlowCollection && is_FLOW_INDICATOR(ch)) {
        break;
      } else if (is_EOL(ch)) {
        _line = state.line;
        _lineStart = state.lineStart;
        _lineIndent = state.lineIndent;
        skipSeparationSpace(state, false, -1);
        if (state.lineIndent >= nodeIndent) {
          hasPendingContent = true;
          ch = state.input.charCodeAt(state.position);
          continue;
        } else {
          state.position = captureEnd;
          state.line = _line;
          state.lineStart = _lineStart;
          state.lineIndent = _lineIndent;
          break;
        }
      }
      if (hasPendingContent) {
        captureSegment(state, captureStart, captureEnd, false);
        writeFoldedLines(state, state.line - _line);
        captureStart = captureEnd = state.position;
        hasPendingContent = false;
      }
      if (!is_WHITE_SPACE(ch)) {
        captureEnd = state.position + 1;
      }
      ch = state.input.charCodeAt(++state.position);
    }
    captureSegment(state, captureStart, captureEnd, false);
    if (state.result) {
      return true;
    }
    state.kind = _kind;
    state.result = _result;
    return false;
  }
  function readSingleQuotedScalar(state, nodeIndent) {
    var ch, captureStart, captureEnd;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 39) {
      return false;
    }
    state.kind = "scalar";
    state.result = "";
    state.position++;
    captureStart = captureEnd = state.position;
    while ((ch = state.input.charCodeAt(state.position)) !== 0) {
      if (ch === 39) {
        captureSegment(state, captureStart, state.position, true);
        ch = state.input.charCodeAt(++state.position);
        if (ch === 39) {
          captureStart = state.position;
          state.position++;
          captureEnd = state.position;
        } else {
          return true;
        }
      } else if (is_EOL(ch)) {
        captureSegment(state, captureStart, captureEnd, true);
        writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
        captureStart = captureEnd = state.position;
      } else if (state.position === state.lineStart && testDocumentSeparator(state)) {
        throwError(state, "unexpected end of the document within a single quoted scalar");
      } else {
        state.position++;
        captureEnd = state.position;
      }
    }
    throwError(state, "unexpected end of the stream within a single quoted scalar");
  }
  function readDoubleQuotedScalar(state, nodeIndent) {
    var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 34) {
      return false;
    }
    state.kind = "scalar";
    state.result = "";
    state.position++;
    captureStart = captureEnd = state.position;
    while ((ch = state.input.charCodeAt(state.position)) !== 0) {
      if (ch === 34) {
        captureSegment(state, captureStart, state.position, true);
        state.position++;
        return true;
      } else if (ch === 92) {
        captureSegment(state, captureStart, state.position, true);
        ch = state.input.charCodeAt(++state.position);
        if (is_EOL(ch)) {
          skipSeparationSpace(state, false, nodeIndent);
        } else if (ch < 256 && simpleEscapeCheck[ch]) {
          state.result += simpleEscapeMap[ch];
          state.position++;
        } else if ((tmp = escapedHexLen(ch)) > 0) {
          hexLength = tmp;
          hexResult = 0;
          for (;hexLength > 0; hexLength--) {
            ch = state.input.charCodeAt(++state.position);
            if ((tmp = fromHexCode(ch)) >= 0) {
              hexResult = (hexResult << 4) + tmp;
            } else {
              throwError(state, "expected hexadecimal character");
            }
          }
          state.result += charFromCodepoint(hexResult);
          state.position++;
        } else {
          throwError(state, "unknown escape sequence");
        }
        captureStart = captureEnd = state.position;
      } else if (is_EOL(ch)) {
        captureSegment(state, captureStart, captureEnd, true);
        writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
        captureStart = captureEnd = state.position;
      } else if (state.position === state.lineStart && testDocumentSeparator(state)) {
        throwError(state, "unexpected end of the document within a double quoted scalar");
      } else {
        state.position++;
        captureEnd = state.position;
      }
    }
    throwError(state, "unexpected end of the stream within a double quoted scalar");
  }
  function readFlowCollection(state, nodeIndent) {
    var readNext = true, _line, _tag = state.tag, _result, _anchor = state.anchor, following, terminator, isPair, isExplicitPair, isMapping, overridableKeys = {}, keyNode, keyTag, valueNode, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 91) {
      terminator = 93;
      isMapping = false;
      _result = [];
    } else if (ch === 123) {
      terminator = 125;
      isMapping = true;
      _result = {};
    } else {
      return false;
    }
    if (state.anchor !== null) {
      state.anchorMap[state.anchor] = _result;
    }
    ch = state.input.charCodeAt(++state.position);
    while (ch !== 0) {
      skipSeparationSpace(state, true, nodeIndent);
      ch = state.input.charCodeAt(state.position);
      if (ch === terminator) {
        state.position++;
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = isMapping ? "mapping" : "sequence";
        state.result = _result;
        return true;
      } else if (!readNext) {
        throwError(state, "missed comma between flow collection entries");
      }
      keyTag = keyNode = valueNode = null;
      isPair = isExplicitPair = false;
      if (ch === 63) {
        following = state.input.charCodeAt(state.position + 1);
        if (is_WS_OR_EOL(following)) {
          isPair = isExplicitPair = true;
          state.position++;
          skipSeparationSpace(state, true, nodeIndent);
        }
      }
      _line = state.line;
      composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
      keyTag = state.tag;
      keyNode = state.result;
      skipSeparationSpace(state, true, nodeIndent);
      ch = state.input.charCodeAt(state.position);
      if ((isExplicitPair || state.line === _line) && ch === 58) {
        isPair = true;
        ch = state.input.charCodeAt(++state.position);
        skipSeparationSpace(state, true, nodeIndent);
        composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
        valueNode = state.result;
      }
      if (isMapping) {
        storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode);
      } else if (isPair) {
        _result.push(storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode));
      } else {
        _result.push(keyNode);
      }
      skipSeparationSpace(state, true, nodeIndent);
      ch = state.input.charCodeAt(state.position);
      if (ch === 44) {
        readNext = true;
        ch = state.input.charCodeAt(++state.position);
      } else {
        readNext = false;
      }
    }
    throwError(state, "unexpected end of the stream within a flow collection");
  }
  function readBlockScalar(state, nodeIndent) {
    var captureStart, folding, chomping = CHOMPING_CLIP, didReadContent = false, detectedIndent = false, textIndent = nodeIndent, emptyLines = 0, atMoreIndented = false, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 124) {
      folding = false;
    } else if (ch === 62) {
      folding = true;
    } else {
      return false;
    }
    state.kind = "scalar";
    state.result = "";
    while (ch !== 0) {
      ch = state.input.charCodeAt(++state.position);
      if (ch === 43 || ch === 45) {
        if (CHOMPING_CLIP === chomping) {
          chomping = ch === 43 ? CHOMPING_KEEP : CHOMPING_STRIP;
        } else {
          throwError(state, "repeat of a chomping mode identifier");
        }
      } else if ((tmp = fromDecimalCode(ch)) >= 0) {
        if (tmp === 0) {
          throwError(state, "bad explicit indentation width of a block scalar; it cannot be less than one");
        } else if (!detectedIndent) {
          textIndent = nodeIndent + tmp - 1;
          detectedIndent = true;
        } else {
          throwError(state, "repeat of an indentation width identifier");
        }
      } else {
        break;
      }
    }
    if (is_WHITE_SPACE(ch)) {
      do {
        ch = state.input.charCodeAt(++state.position);
      } while (is_WHITE_SPACE(ch));
      if (ch === 35) {
        do {
          ch = state.input.charCodeAt(++state.position);
        } while (!is_EOL(ch) && ch !== 0);
      }
    }
    while (ch !== 0) {
      readLineBreak(state);
      state.lineIndent = 0;
      ch = state.input.charCodeAt(state.position);
      while ((!detectedIndent || state.lineIndent < textIndent) && ch === 32) {
        state.lineIndent++;
        ch = state.input.charCodeAt(++state.position);
      }
      if (!detectedIndent && state.lineIndent > textIndent) {
        textIndent = state.lineIndent;
      }
      if (is_EOL(ch)) {
        emptyLines++;
        continue;
      }
      if (state.lineIndent < textIndent) {
        if (chomping === CHOMPING_KEEP) {
          state.result += common.repeat(`
`, didReadContent ? 1 + emptyLines : emptyLines);
        } else if (chomping === CHOMPING_CLIP) {
          if (didReadContent) {
            state.result += `
`;
          }
        }
        break;
      }
      if (folding) {
        if (is_WHITE_SPACE(ch)) {
          atMoreIndented = true;
          state.result += common.repeat(`
`, didReadContent ? 1 + emptyLines : emptyLines);
        } else if (atMoreIndented) {
          atMoreIndented = false;
          state.result += common.repeat(`
`, emptyLines + 1);
        } else if (emptyLines === 0) {
          if (didReadContent) {
            state.result += " ";
          }
        } else {
          state.result += common.repeat(`
`, emptyLines);
        }
      } else {
        state.result += common.repeat(`
`, didReadContent ? 1 + emptyLines : emptyLines);
      }
      didReadContent = true;
      detectedIndent = true;
      emptyLines = 0;
      captureStart = state.position;
      while (!is_EOL(ch) && ch !== 0) {
        ch = state.input.charCodeAt(++state.position);
      }
      captureSegment(state, captureStart, state.position, false);
    }
    return true;
  }
  function readBlockSequence(state, nodeIndent) {
    var _line, _tag = state.tag, _anchor = state.anchor, _result = [], following, detected = false, ch;
    if (state.anchor !== null) {
      state.anchorMap[state.anchor] = _result;
    }
    ch = state.input.charCodeAt(state.position);
    while (ch !== 0) {
      if (ch !== 45) {
        break;
      }
      following = state.input.charCodeAt(state.position + 1);
      if (!is_WS_OR_EOL(following)) {
        break;
      }
      detected = true;
      state.position++;
      if (skipSeparationSpace(state, true, -1)) {
        if (state.lineIndent <= nodeIndent) {
          _result.push(null);
          ch = state.input.charCodeAt(state.position);
          continue;
        }
      }
      _line = state.line;
      composeNode(state, nodeIndent, CONTEXT_BLOCK_IN, false, true);
      _result.push(state.result);
      skipSeparationSpace(state, true, -1);
      ch = state.input.charCodeAt(state.position);
      if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) {
        throwError(state, "bad indentation of a sequence entry");
      } else if (state.lineIndent < nodeIndent) {
        break;
      }
    }
    if (detected) {
      state.tag = _tag;
      state.anchor = _anchor;
      state.kind = "sequence";
      state.result = _result;
      return true;
    }
    return false;
  }
  function readBlockMapping(state, nodeIndent, flowIndent) {
    var following, allowCompact, _line, _pos, _tag = state.tag, _anchor = state.anchor, _result = {}, overridableKeys = {}, keyTag = null, keyNode = null, valueNode = null, atExplicitKey = false, detected = false, ch;
    if (state.anchor !== null) {
      state.anchorMap[state.anchor] = _result;
    }
    ch = state.input.charCodeAt(state.position);
    while (ch !== 0) {
      following = state.input.charCodeAt(state.position + 1);
      _line = state.line;
      _pos = state.position;
      if ((ch === 63 || ch === 58) && is_WS_OR_EOL(following)) {
        if (ch === 63) {
          if (atExplicitKey) {
            storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
            keyTag = keyNode = valueNode = null;
          }
          detected = true;
          atExplicitKey = true;
          allowCompact = true;
        } else if (atExplicitKey) {
          atExplicitKey = false;
          allowCompact = true;
        } else {
          throwError(state, "incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line");
        }
        state.position += 1;
        ch = following;
      } else if (composeNode(state, flowIndent, CONTEXT_FLOW_OUT, false, true)) {
        if (state.line === _line) {
          ch = state.input.charCodeAt(state.position);
          while (is_WHITE_SPACE(ch)) {
            ch = state.input.charCodeAt(++state.position);
          }
          if (ch === 58) {
            ch = state.input.charCodeAt(++state.position);
            if (!is_WS_OR_EOL(ch)) {
              throwError(state, "a whitespace character is expected after the key-value separator within a block mapping");
            }
            if (atExplicitKey) {
              storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
              keyTag = keyNode = valueNode = null;
            }
            detected = true;
            atExplicitKey = false;
            allowCompact = false;
            keyTag = state.tag;
            keyNode = state.result;
          } else if (detected) {
            throwError(state, "can not read an implicit mapping pair; a colon is missed");
          } else {
            state.tag = _tag;
            state.anchor = _anchor;
            return true;
          }
        } else if (detected) {
          throwError(state, "can not read a block mapping entry; a multiline key may not be an implicit key");
        } else {
          state.tag = _tag;
          state.anchor = _anchor;
          return true;
        }
      } else {
        break;
      }
      if (state.line === _line || state.lineIndent > nodeIndent) {
        if (composeNode(state, nodeIndent, CONTEXT_BLOCK_OUT, true, allowCompact)) {
          if (atExplicitKey) {
            keyNode = state.result;
          } else {
            valueNode = state.result;
          }
        }
        if (!atExplicitKey) {
          storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _pos);
          keyTag = keyNode = valueNode = null;
        }
        skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
      }
      if (state.lineIndent > nodeIndent && ch !== 0) {
        throwError(state, "bad indentation of a mapping entry");
      } else if (state.lineIndent < nodeIndent) {
        break;
      }
    }
    if (atExplicitKey) {
      storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null);
    }
    if (detected) {
      state.tag = _tag;
      state.anchor = _anchor;
      state.kind = "mapping";
      state.result = _result;
    }
    return detected;
  }
  function readTagProperty(state) {
    var _position, isVerbatim = false, isNamed = false, tagHandle, tagName, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 33)
      return false;
    if (state.tag !== null) {
      throwError(state, "duplication of a tag property");
    }
    ch = state.input.charCodeAt(++state.position);
    if (ch === 60) {
      isVerbatim = true;
      ch = state.input.charCodeAt(++state.position);
    } else if (ch === 33) {
      isNamed = true;
      tagHandle = "!!";
      ch = state.input.charCodeAt(++state.position);
    } else {
      tagHandle = "!";
    }
    _position = state.position;
    if (isVerbatim) {
      do {
        ch = state.input.charCodeAt(++state.position);
      } while (ch !== 0 && ch !== 62);
      if (state.position < state.length) {
        tagName = state.input.slice(_position, state.position);
        ch = state.input.charCodeAt(++state.position);
      } else {
        throwError(state, "unexpected end of the stream within a verbatim tag");
      }
    } else {
      while (ch !== 0 && !is_WS_OR_EOL(ch)) {
        if (ch === 33) {
          if (!isNamed) {
            tagHandle = state.input.slice(_position - 1, state.position + 1);
            if (!PATTERN_TAG_HANDLE.test(tagHandle)) {
              throwError(state, "named tag handle cannot contain such characters");
            }
            isNamed = true;
            _position = state.position + 1;
          } else {
            throwError(state, "tag suffix cannot contain exclamation marks");
          }
        }
        ch = state.input.charCodeAt(++state.position);
      }
      tagName = state.input.slice(_position, state.position);
      if (PATTERN_FLOW_INDICATORS.test(tagName)) {
        throwError(state, "tag suffix cannot contain flow indicator characters");
      }
    }
    if (tagName && !PATTERN_TAG_URI.test(tagName)) {
      throwError(state, "tag name cannot contain such characters: " + tagName);
    }
    if (isVerbatim) {
      state.tag = tagName;
    } else if (_hasOwnProperty.call(state.tagMap, tagHandle)) {
      state.tag = state.tagMap[tagHandle] + tagName;
    } else if (tagHandle === "!") {
      state.tag = "!" + tagName;
    } else if (tagHandle === "!!") {
      state.tag = "tag:yaml.org,2002:" + tagName;
    } else {
      throwError(state, 'undeclared tag handle "' + tagHandle + '"');
    }
    return true;
  }
  function readAnchorProperty(state) {
    var _position, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 38)
      return false;
    if (state.anchor !== null) {
      throwError(state, "duplication of an anchor property");
    }
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
      ch = state.input.charCodeAt(++state.position);
    }
    if (state.position === _position) {
      throwError(state, "name of an anchor node must contain at least one character");
    }
    state.anchor = state.input.slice(_position, state.position);
    return true;
  }
  function readAlias(state) {
    var _position, alias, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 42)
      return false;
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
      ch = state.input.charCodeAt(++state.position);
    }
    if (state.position === _position) {
      throwError(state, "name of an alias node must contain at least one character");
    }
    alias = state.input.slice(_position, state.position);
    if (!_hasOwnProperty.call(state.anchorMap, alias)) {
      throwError(state, 'unidentified alias "' + alias + '"');
    }
    state.result = state.anchorMap[alias];
    skipSeparationSpace(state, true, -1);
    return true;
  }
  function composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
    var allowBlockStyles, allowBlockScalars, allowBlockCollections, indentStatus = 1, atNewLine = false, hasContent = false, typeIndex, typeQuantity, type, flowIndent, blockIndent;
    if (state.listener !== null) {
      state.listener("open", state);
    }
    state.tag = null;
    state.anchor = null;
    state.kind = null;
    state.result = null;
    allowBlockStyles = allowBlockScalars = allowBlockCollections = CONTEXT_BLOCK_OUT === nodeContext || CONTEXT_BLOCK_IN === nodeContext;
    if (allowToSeek) {
      if (skipSeparationSpace(state, true, -1)) {
        atNewLine = true;
        if (state.lineIndent > parentIndent) {
          indentStatus = 1;
        } else if (state.lineIndent === parentIndent) {
          indentStatus = 0;
        } else if (state.lineIndent < parentIndent) {
          indentStatus = -1;
        }
      }
    }
    if (indentStatus === 1) {
      while (readTagProperty(state) || readAnchorProperty(state)) {
        if (skipSeparationSpace(state, true, -1)) {
          atNewLine = true;
          allowBlockCollections = allowBlockStyles;
          if (state.lineIndent > parentIndent) {
            indentStatus = 1;
          } else if (state.lineIndent === parentIndent) {
            indentStatus = 0;
          } else if (state.lineIndent < parentIndent) {
            indentStatus = -1;
          }
        } else {
          allowBlockCollections = false;
        }
      }
    }
    if (allowBlockCollections) {
      allowBlockCollections = atNewLine || allowCompact;
    }
    if (indentStatus === 1 || CONTEXT_BLOCK_OUT === nodeContext) {
      if (CONTEXT_FLOW_IN === nodeContext || CONTEXT_FLOW_OUT === nodeContext) {
        flowIndent = parentIndent;
      } else {
        flowIndent = parentIndent + 1;
      }
      blockIndent = state.position - state.lineStart;
      if (indentStatus === 1) {
        if (allowBlockCollections && (readBlockSequence(state, blockIndent) || readBlockMapping(state, blockIndent, flowIndent)) || readFlowCollection(state, flowIndent)) {
          hasContent = true;
        } else {
          if (allowBlockScalars && readBlockScalar(state, flowIndent) || readSingleQuotedScalar(state, flowIndent) || readDoubleQuotedScalar(state, flowIndent)) {
            hasContent = true;
          } else if (readAlias(state)) {
            hasContent = true;
            if (state.tag !== null || state.anchor !== null) {
              throwError(state, "alias node should not have any properties");
            }
          } else if (readPlainScalar(state, flowIndent, CONTEXT_FLOW_IN === nodeContext)) {
            hasContent = true;
            if (state.tag === null) {
              state.tag = "?";
            }
          }
          if (state.anchor !== null) {
            state.anchorMap[state.anchor] = state.result;
          }
        }
      } else if (indentStatus === 0) {
        hasContent = allowBlockCollections && readBlockSequence(state, blockIndent);
      }
    }
    if (state.tag !== null && state.tag !== "!") {
      if (state.tag === "?") {
        if (state.result !== null && state.kind !== "scalar") {
          throwError(state, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state.kind + '"');
        }
        for (typeIndex = 0, typeQuantity = state.implicitTypes.length;typeIndex < typeQuantity; typeIndex += 1) {
          type = state.implicitTypes[typeIndex];
          if (type.resolve(state.result)) {
            state.result = type.construct(state.result);
            state.tag = type.tag;
            if (state.anchor !== null) {
              state.anchorMap[state.anchor] = state.result;
            }
            break;
          }
        }
      } else if (_hasOwnProperty.call(state.typeMap[state.kind || "fallback"], state.tag)) {
        type = state.typeMap[state.kind || "fallback"][state.tag];
        if (state.result !== null && type.kind !== state.kind) {
          throwError(state, "unacceptable node kind for !<" + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
        }
        if (!type.resolve(state.result)) {
          throwError(state, "cannot resolve a node with !<" + state.tag + "> explicit tag");
        } else {
          state.result = type.construct(state.result);
          if (state.anchor !== null) {
            state.anchorMap[state.anchor] = state.result;
          }
        }
      } else {
        throwError(state, "unknown tag !<" + state.tag + ">");
      }
    }
    if (state.listener !== null) {
      state.listener("close", state);
    }
    return state.tag !== null || state.anchor !== null || hasContent;
  }
  function readDocument(state) {
    var documentStart = state.position, _position, directiveName, directiveArgs, hasDirectives = false, ch;
    state.version = null;
    state.checkLineBreaks = state.legacy;
    state.tagMap = {};
    state.anchorMap = {};
    while ((ch = state.input.charCodeAt(state.position)) !== 0) {
      skipSeparationSpace(state, true, -1);
      ch = state.input.charCodeAt(state.position);
      if (state.lineIndent > 0 || ch !== 37) {
        break;
      }
      hasDirectives = true;
      ch = state.input.charCodeAt(++state.position);
      _position = state.position;
      while (ch !== 0 && !is_WS_OR_EOL(ch)) {
        ch = state.input.charCodeAt(++state.position);
      }
      directiveName = state.input.slice(_position, state.position);
      directiveArgs = [];
      if (directiveName.length < 1) {
        throwError(state, "directive name must not be less than one character in length");
      }
      while (ch !== 0) {
        while (is_WHITE_SPACE(ch)) {
          ch = state.input.charCodeAt(++state.position);
        }
        if (ch === 35) {
          do {
            ch = state.input.charCodeAt(++state.position);
          } while (ch !== 0 && !is_EOL(ch));
          break;
        }
        if (is_EOL(ch))
          break;
        _position = state.position;
        while (ch !== 0 && !is_WS_OR_EOL(ch)) {
          ch = state.input.charCodeAt(++state.position);
        }
        directiveArgs.push(state.input.slice(_position, state.position));
      }
      if (ch !== 0)
        readLineBreak(state);
      if (_hasOwnProperty.call(directiveHandlers, directiveName)) {
        directiveHandlers[directiveName](state, directiveName, directiveArgs);
      } else {
        throwWarning(state, 'unknown document directive "' + directiveName + '"');
      }
    }
    skipSeparationSpace(state, true, -1);
    if (state.lineIndent === 0 && state.input.charCodeAt(state.position) === 45 && state.input.charCodeAt(state.position + 1) === 45 && state.input.charCodeAt(state.position + 2) === 45) {
      state.position += 3;
      skipSeparationSpace(state, true, -1);
    } else if (hasDirectives) {
      throwError(state, "directives end mark is expected");
    }
    composeNode(state, state.lineIndent - 1, CONTEXT_BLOCK_OUT, false, true);
    skipSeparationSpace(state, true, -1);
    if (state.checkLineBreaks && PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) {
      throwWarning(state, "non-ASCII line breaks are interpreted as content");
    }
    state.documents.push(state.result);
    if (state.position === state.lineStart && testDocumentSeparator(state)) {
      if (state.input.charCodeAt(state.position) === 46) {
        state.position += 3;
        skipSeparationSpace(state, true, -1);
      }
      return;
    }
    if (state.position < state.length - 1) {
      throwError(state, "end of the stream or a document separator is expected");
    } else {
      return;
    }
  }
  function loadDocuments(input, options2) {
    input = String(input);
    options2 = options2 || {};
    if (input.length !== 0) {
      if (input.charCodeAt(input.length - 1) !== 10 && input.charCodeAt(input.length - 1) !== 13) {
        input += `
`;
      }
      if (input.charCodeAt(0) === 65279) {
        input = input.slice(1);
      }
    }
    var state = new State(input, options2);
    var nullpos = input.indexOf("\x00");
    if (nullpos !== -1) {
      state.position = nullpos;
      throwError(state, "null byte is not allowed in input");
    }
    state.input += "\x00";
    while (state.input.charCodeAt(state.position) === 32) {
      state.lineIndent += 1;
      state.position += 1;
    }
    while (state.position < state.length - 1) {
      readDocument(state);
    }
    return state.documents;
  }
  function loadAll(input, iterator, options2) {
    if (iterator !== null && typeof iterator === "object" && typeof options2 === "undefined") {
      options2 = iterator;
      iterator = null;
    }
    var documents = loadDocuments(input, options2);
    if (typeof iterator !== "function") {
      return documents;
    }
    for (var index = 0, length = documents.length;index < length; index += 1) {
      iterator(documents[index]);
    }
  }
  function load(input, options2) {
    var documents = loadDocuments(input, options2);
    if (documents.length === 0) {
      return;
    } else if (documents.length === 1) {
      return documents[0];
    }
    throw new YAMLException("expected a single document in the stream, but found more");
  }
  function safeLoadAll(input, iterator, options2) {
    if (typeof iterator === "object" && iterator !== null && typeof options2 === "undefined") {
      options2 = iterator;
      iterator = null;
    }
    return loadAll(input, iterator, common.extend({ schema: DEFAULT_SAFE_SCHEMA }, options2));
  }
  function safeLoad(input, options2) {
    return load(input, common.extend({ schema: DEFAULT_SAFE_SCHEMA }, options2));
  }
  exports.loadAll = loadAll;
  exports.load = load;
  exports.safeLoadAll = safeLoadAll;
  exports.safeLoad = safeLoad;
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml/dumper.js
var require_dumper = __commonJS((exports, module) => {
  var common = require_common();
  var YAMLException = require_exception();
  var DEFAULT_FULL_SCHEMA = require_default_full();
  var DEFAULT_SAFE_SCHEMA = require_default_safe();
  var _toString = Object.prototype.toString;
  var _hasOwnProperty = Object.prototype.hasOwnProperty;
  var CHAR_TAB = 9;
  var CHAR_LINE_FEED = 10;
  var CHAR_CARRIAGE_RETURN = 13;
  var CHAR_SPACE = 32;
  var CHAR_EXCLAMATION = 33;
  var CHAR_DOUBLE_QUOTE = 34;
  var CHAR_SHARP = 35;
  var CHAR_PERCENT = 37;
  var CHAR_AMPERSAND = 38;
  var CHAR_SINGLE_QUOTE = 39;
  var CHAR_ASTERISK = 42;
  var CHAR_COMMA = 44;
  var CHAR_MINUS = 45;
  var CHAR_COLON = 58;
  var CHAR_EQUALS = 61;
  var CHAR_GREATER_THAN = 62;
  var CHAR_QUESTION = 63;
  var CHAR_COMMERCIAL_AT = 64;
  var CHAR_LEFT_SQUARE_BRACKET = 91;
  var CHAR_RIGHT_SQUARE_BRACKET = 93;
  var CHAR_GRAVE_ACCENT = 96;
  var CHAR_LEFT_CURLY_BRACKET = 123;
  var CHAR_VERTICAL_LINE = 124;
  var CHAR_RIGHT_CURLY_BRACKET = 125;
  var ESCAPE_SEQUENCES = {};
  ESCAPE_SEQUENCES[0] = "\\0";
  ESCAPE_SEQUENCES[7] = "\\a";
  ESCAPE_SEQUENCES[8] = "\\b";
  ESCAPE_SEQUENCES[9] = "\\t";
  ESCAPE_SEQUENCES[10] = "\\n";
  ESCAPE_SEQUENCES[11] = "\\v";
  ESCAPE_SEQUENCES[12] = "\\f";
  ESCAPE_SEQUENCES[13] = "\\r";
  ESCAPE_SEQUENCES[27] = "\\e";
  ESCAPE_SEQUENCES[34] = "\\\"";
  ESCAPE_SEQUENCES[92] = "\\\\";
  ESCAPE_SEQUENCES[133] = "\\N";
  ESCAPE_SEQUENCES[160] = "\\_";
  ESCAPE_SEQUENCES[8232] = "\\L";
  ESCAPE_SEQUENCES[8233] = "\\P";
  var DEPRECATED_BOOLEANS_SYNTAX = [
    "y",
    "Y",
    "yes",
    "Yes",
    "YES",
    "on",
    "On",
    "ON",
    "n",
    "N",
    "no",
    "No",
    "NO",
    "off",
    "Off",
    "OFF"
  ];
  function compileStyleMap(schema, map) {
    var result, keys, index, length, tag, style, type;
    if (map === null)
      return {};
    result = {};
    keys = Object.keys(map);
    for (index = 0, length = keys.length;index < length; index += 1) {
      tag = keys[index];
      style = String(map[tag]);
      if (tag.slice(0, 2) === "!!") {
        tag = "tag:yaml.org,2002:" + tag.slice(2);
      }
      type = schema.compiledTypeMap["fallback"][tag];
      if (type && _hasOwnProperty.call(type.styleAliases, style)) {
        style = type.styleAliases[style];
      }
      result[tag] = style;
    }
    return result;
  }
  function encodeHex(character) {
    var string, handle, length;
    string = character.toString(16).toUpperCase();
    if (character <= 255) {
      handle = "x";
      length = 2;
    } else if (character <= 65535) {
      handle = "u";
      length = 4;
    } else if (character <= 4294967295) {
      handle = "U";
      length = 8;
    } else {
      throw new YAMLException("code point within a string may not be greater than 0xFFFFFFFF");
    }
    return "\\" + handle + common.repeat("0", length - string.length) + string;
  }
  function State(options2) {
    this.schema = options2["schema"] || DEFAULT_FULL_SCHEMA;
    this.indent = Math.max(1, options2["indent"] || 2);
    this.noArrayIndent = options2["noArrayIndent"] || false;
    this.skipInvalid = options2["skipInvalid"] || false;
    this.flowLevel = common.isNothing(options2["flowLevel"]) ? -1 : options2["flowLevel"];
    this.styleMap = compileStyleMap(this.schema, options2["styles"] || null);
    this.sortKeys = options2["sortKeys"] || false;
    this.lineWidth = options2["lineWidth"] || 80;
    this.noRefs = options2["noRefs"] || false;
    this.noCompatMode = options2["noCompatMode"] || false;
    this.condenseFlow = options2["condenseFlow"] || false;
    this.implicitTypes = this.schema.compiledImplicit;
    this.explicitTypes = this.schema.compiledExplicit;
    this.tag = null;
    this.result = "";
    this.duplicates = [];
    this.usedDuplicates = null;
  }
  function indentString(string, spaces) {
    var ind = common.repeat(" ", spaces), position = 0, next2 = -1, result = "", line, length = string.length;
    while (position < length) {
      next2 = string.indexOf(`
`, position);
      if (next2 === -1) {
        line = string.slice(position);
        position = length;
      } else {
        line = string.slice(position, next2 + 1);
        position = next2 + 1;
      }
      if (line.length && line !== `
`)
        result += ind;
      result += line;
    }
    return result;
  }
  function generateNextLine(state, level) {
    return `
` + common.repeat(" ", state.indent * level);
  }
  function testImplicitResolving(state, str2) {
    var index, length, type;
    for (index = 0, length = state.implicitTypes.length;index < length; index += 1) {
      type = state.implicitTypes[index];
      if (type.resolve(str2)) {
        return true;
      }
    }
    return false;
  }
  function isWhitespace(c) {
    return c === CHAR_SPACE || c === CHAR_TAB;
  }
  function isPrintable(c) {
    return 32 <= c && c <= 126 || 161 <= c && c <= 55295 && c !== 8232 && c !== 8233 || 57344 <= c && c <= 65533 && c !== 65279 || 65536 <= c && c <= 1114111;
  }
  function isNsChar(c) {
    return isPrintable(c) && !isWhitespace(c) && c !== 65279 && c !== CHAR_CARRIAGE_RETURN && c !== CHAR_LINE_FEED;
  }
  function isPlainSafe(c, prev) {
    return isPrintable(c) && c !== 65279 && c !== CHAR_COMMA && c !== CHAR_LEFT_SQUARE_BRACKET && c !== CHAR_RIGHT_SQUARE_BRACKET && c !== CHAR_LEFT_CURLY_BRACKET && c !== CHAR_RIGHT_CURLY_BRACKET && c !== CHAR_COLON && (c !== CHAR_SHARP || prev && isNsChar(prev));
  }
  function isPlainSafeFirst(c) {
    return isPrintable(c) && c !== 65279 && !isWhitespace(c) && c !== CHAR_MINUS && c !== CHAR_QUESTION && c !== CHAR_COLON && c !== CHAR_COMMA && c !== CHAR_LEFT_SQUARE_BRACKET && c !== CHAR_RIGHT_SQUARE_BRACKET && c !== CHAR_LEFT_CURLY_BRACKET && c !== CHAR_RIGHT_CURLY_BRACKET && c !== CHAR_SHARP && c !== CHAR_AMPERSAND && c !== CHAR_ASTERISK && c !== CHAR_EXCLAMATION && c !== CHAR_VERTICAL_LINE && c !== CHAR_EQUALS && c !== CHAR_GREATER_THAN && c !== CHAR_SINGLE_QUOTE && c !== CHAR_DOUBLE_QUOTE && c !== CHAR_PERCENT && c !== CHAR_COMMERCIAL_AT && c !== CHAR_GRAVE_ACCENT;
  }
  function needIndentIndicator(string) {
    var leadingSpaceRe = /^\n* /;
    return leadingSpaceRe.test(string);
  }
  var STYLE_PLAIN = 1;
  var STYLE_SINGLE = 2;
  var STYLE_LITERAL = 3;
  var STYLE_FOLDED = 4;
  var STYLE_DOUBLE = 5;
  function chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth, testAmbiguousType) {
    var i;
    var char, prev_char;
    var hasLineBreak = false;
    var hasFoldableLine = false;
    var shouldTrackWidth = lineWidth !== -1;
    var previousLineBreak = -1;
    var plain = isPlainSafeFirst(string.charCodeAt(0)) && !isWhitespace(string.charCodeAt(string.length - 1));
    if (singleLineOnly) {
      for (i = 0;i < string.length; i++) {
        char = string.charCodeAt(i);
        if (!isPrintable(char)) {
          return STYLE_DOUBLE;
        }
        prev_char = i > 0 ? string.charCodeAt(i - 1) : null;
        plain = plain && isPlainSafe(char, prev_char);
      }
    } else {
      for (i = 0;i < string.length; i++) {
        char = string.charCodeAt(i);
        if (char === CHAR_LINE_FEED) {
          hasLineBreak = true;
          if (shouldTrackWidth) {
            hasFoldableLine = hasFoldableLine || i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== " ";
            previousLineBreak = i;
          }
        } else if (!isPrintable(char)) {
          return STYLE_DOUBLE;
        }
        prev_char = i > 0 ? string.charCodeAt(i - 1) : null;
        plain = plain && isPlainSafe(char, prev_char);
      }
      hasFoldableLine = hasFoldableLine || shouldTrackWidth && (i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== " ");
    }
    if (!hasLineBreak && !hasFoldableLine) {
      return plain && !testAmbiguousType(string) ? STYLE_PLAIN : STYLE_SINGLE;
    }
    if (indentPerLevel > 9 && needIndentIndicator(string)) {
      return STYLE_DOUBLE;
    }
    return hasFoldableLine ? STYLE_FOLDED : STYLE_LITERAL;
  }
  function writeScalar(state, string, level, iskey) {
    state.dump = function() {
      if (string.length === 0) {
        return "''";
      }
      if (!state.noCompatMode && DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1) {
        return "'" + string + "'";
      }
      var indent = state.indent * Math.max(1, level);
      var lineWidth = state.lineWidth === -1 ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);
      var singleLineOnly = iskey || state.flowLevel > -1 && level >= state.flowLevel;
      function testAmbiguity(string2) {
        return testImplicitResolving(state, string2);
      }
      switch (chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth, testAmbiguity)) {
        case STYLE_PLAIN:
          return string;
        case STYLE_SINGLE:
          return "'" + string.replace(/'/g, "''") + "'";
        case STYLE_LITERAL:
          return "|" + blockHeader(string, state.indent) + dropEndingNewline(indentString(string, indent));
        case STYLE_FOLDED:
          return ">" + blockHeader(string, state.indent) + dropEndingNewline(indentString(foldString(string, lineWidth), indent));
        case STYLE_DOUBLE:
          return '"' + escapeString(string, lineWidth) + '"';
        default:
          throw new YAMLException("impossible error: invalid scalar style");
      }
    }();
  }
  function blockHeader(string, indentPerLevel) {
    var indentIndicator = needIndentIndicator(string) ? String(indentPerLevel) : "";
    var clip = string[string.length - 1] === `
`;
    var keep = clip && (string[string.length - 2] === `
` || string === `
`);
    var chomp = keep ? "+" : clip ? "" : "-";
    return indentIndicator + chomp + `
`;
  }
  function dropEndingNewline(string) {
    return string[string.length - 1] === `
` ? string.slice(0, -1) : string;
  }
  function foldString(string, width) {
    var lineRe = /(\n+)([^\n]*)/g;
    var result = function() {
      var nextLF = string.indexOf(`
`);
      nextLF = nextLF !== -1 ? nextLF : string.length;
      lineRe.lastIndex = nextLF;
      return foldLine(string.slice(0, nextLF), width);
    }();
    var prevMoreIndented = string[0] === `
` || string[0] === " ";
    var moreIndented;
    var match;
    while (match = lineRe.exec(string)) {
      var prefix = match[1], line = match[2];
      moreIndented = line[0] === " ";
      result += prefix + (!prevMoreIndented && !moreIndented && line !== "" ? `
` : "") + foldLine(line, width);
      prevMoreIndented = moreIndented;
    }
    return result;
  }
  function foldLine(line, width) {
    if (line === "" || line[0] === " ")
      return line;
    var breakRe = / [^ ]/g;
    var match;
    var start = 0, end, curr = 0, next2 = 0;
    var result = "";
    while (match = breakRe.exec(line)) {
      next2 = match.index;
      if (next2 - start > width) {
        end = curr > start ? curr : next2;
        result += `
` + line.slice(start, end);
        start = end + 1;
      }
      curr = next2;
    }
    result += `
`;
    if (line.length - start > width && curr > start) {
      result += line.slice(start, curr) + `
` + line.slice(curr + 1);
    } else {
      result += line.slice(start);
    }
    return result.slice(1);
  }
  function escapeString(string) {
    var result = "";
    var char, nextChar;
    var escapeSeq;
    for (var i = 0;i < string.length; i++) {
      char = string.charCodeAt(i);
      if (char >= 55296 && char <= 56319) {
        nextChar = string.charCodeAt(i + 1);
        if (nextChar >= 56320 && nextChar <= 57343) {
          result += encodeHex((char - 55296) * 1024 + nextChar - 56320 + 65536);
          i++;
          continue;
        }
      }
      escapeSeq = ESCAPE_SEQUENCES[char];
      result += !escapeSeq && isPrintable(char) ? string[i] : escapeSeq || encodeHex(char);
    }
    return result;
  }
  function writeFlowSequence(state, level, object) {
    var _result = "", _tag = state.tag, index, length;
    for (index = 0, length = object.length;index < length; index += 1) {
      if (writeNode(state, level, object[index], false, false)) {
        if (index !== 0)
          _result += "," + (!state.condenseFlow ? " " : "");
        _result += state.dump;
      }
    }
    state.tag = _tag;
    state.dump = "[" + _result + "]";
  }
  function writeBlockSequence(state, level, object, compact) {
    var _result = "", _tag = state.tag, index, length;
    for (index = 0, length = object.length;index < length; index += 1) {
      if (writeNode(state, level + 1, object[index], true, true)) {
        if (!compact || index !== 0) {
          _result += generateNextLine(state, level);
        }
        if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
          _result += "-";
        } else {
          _result += "- ";
        }
        _result += state.dump;
      }
    }
    state.tag = _tag;
    state.dump = _result || "[]";
  }
  function writeFlowMapping(state, level, object) {
    var _result = "", _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, pairBuffer;
    for (index = 0, length = objectKeyList.length;index < length; index += 1) {
      pairBuffer = "";
      if (index !== 0)
        pairBuffer += ", ";
      if (state.condenseFlow)
        pairBuffer += '"';
      objectKey = objectKeyList[index];
      objectValue = object[objectKey];
      if (!writeNode(state, level, objectKey, false, false)) {
        continue;
      }
      if (state.dump.length > 1024)
        pairBuffer += "? ";
      pairBuffer += state.dump + (state.condenseFlow ? '"' : "") + ":" + (state.condenseFlow ? "" : " ");
      if (!writeNode(state, level, objectValue, false, false)) {
        continue;
      }
      pairBuffer += state.dump;
      _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = "{" + _result + "}";
  }
  function writeBlockMapping(state, level, object, compact) {
    var _result = "", _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, explicitPair, pairBuffer;
    if (state.sortKeys === true) {
      objectKeyList.sort();
    } else if (typeof state.sortKeys === "function") {
      objectKeyList.sort(state.sortKeys);
    } else if (state.sortKeys) {
      throw new YAMLException("sortKeys must be a boolean or a function");
    }
    for (index = 0, length = objectKeyList.length;index < length; index += 1) {
      pairBuffer = "";
      if (!compact || index !== 0) {
        pairBuffer += generateNextLine(state, level);
      }
      objectKey = objectKeyList[index];
      objectValue = object[objectKey];
      if (!writeNode(state, level + 1, objectKey, true, true, true)) {
        continue;
      }
      explicitPair = state.tag !== null && state.tag !== "?" || state.dump && state.dump.length > 1024;
      if (explicitPair) {
        if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
          pairBuffer += "?";
        } else {
          pairBuffer += "? ";
        }
      }
      pairBuffer += state.dump;
      if (explicitPair) {
        pairBuffer += generateNextLine(state, level);
      }
      if (!writeNode(state, level + 1, objectValue, true, explicitPair)) {
        continue;
      }
      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
        pairBuffer += ":";
      } else {
        pairBuffer += ": ";
      }
      pairBuffer += state.dump;
      _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = _result || "{}";
  }
  function detectType(state, object, explicit) {
    var _result, typeList, index, length, type, style;
    typeList = explicit ? state.explicitTypes : state.implicitTypes;
    for (index = 0, length = typeList.length;index < length; index += 1) {
      type = typeList[index];
      if ((type.instanceOf || type.predicate) && (!type.instanceOf || typeof object === "object" && object instanceof type.instanceOf) && (!type.predicate || type.predicate(object))) {
        state.tag = explicit ? type.tag : "?";
        if (type.represent) {
          style = state.styleMap[type.tag] || type.defaultStyle;
          if (_toString.call(type.represent) === "[object Function]") {
            _result = type.represent(object, style);
          } else if (_hasOwnProperty.call(type.represent, style)) {
            _result = type.represent[style](object, style);
          } else {
            throw new YAMLException("!<" + type.tag + '> tag resolver accepts not "' + style + '" style');
          }
          state.dump = _result;
        }
        return true;
      }
    }
    return false;
  }
  function writeNode(state, level, object, block, compact, iskey) {
    state.tag = null;
    state.dump = object;
    if (!detectType(state, object, false)) {
      detectType(state, object, true);
    }
    var type = _toString.call(state.dump);
    if (block) {
      block = state.flowLevel < 0 || state.flowLevel > level;
    }
    var objectOrArray = type === "[object Object]" || type === "[object Array]", duplicateIndex, duplicate;
    if (objectOrArray) {
      duplicateIndex = state.duplicates.indexOf(object);
      duplicate = duplicateIndex !== -1;
    }
    if (state.tag !== null && state.tag !== "?" || duplicate || state.indent !== 2 && level > 0) {
      compact = false;
    }
    if (duplicate && state.usedDuplicates[duplicateIndex]) {
      state.dump = "*ref_" + duplicateIndex;
    } else {
      if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) {
        state.usedDuplicates[duplicateIndex] = true;
      }
      if (type === "[object Object]") {
        if (block && Object.keys(state.dump).length !== 0) {
          writeBlockMapping(state, level, state.dump, compact);
          if (duplicate) {
            state.dump = "&ref_" + duplicateIndex + state.dump;
          }
        } else {
          writeFlowMapping(state, level, state.dump);
          if (duplicate) {
            state.dump = "&ref_" + duplicateIndex + " " + state.dump;
          }
        }
      } else if (type === "[object Array]") {
        var arrayLevel = state.noArrayIndent && level > 0 ? level - 1 : level;
        if (block && state.dump.length !== 0) {
          writeBlockSequence(state, arrayLevel, state.dump, compact);
          if (duplicate) {
            state.dump = "&ref_" + duplicateIndex + state.dump;
          }
        } else {
          writeFlowSequence(state, arrayLevel, state.dump);
          if (duplicate) {
            state.dump = "&ref_" + duplicateIndex + " " + state.dump;
          }
        }
      } else if (type === "[object String]") {
        if (state.tag !== "?") {
          writeScalar(state, state.dump, level, iskey);
        }
      } else {
        if (state.skipInvalid)
          return false;
        throw new YAMLException("unacceptable kind of an object to dump " + type);
      }
      if (state.tag !== null && state.tag !== "?") {
        state.dump = "!<" + state.tag + "> " + state.dump;
      }
    }
    return true;
  }
  function getDuplicateReferences(object, state) {
    var objects = [], duplicatesIndexes = [], index, length;
    inspectNode(object, objects, duplicatesIndexes);
    for (index = 0, length = duplicatesIndexes.length;index < length; index += 1) {
      state.duplicates.push(objects[duplicatesIndexes[index]]);
    }
    state.usedDuplicates = new Array(length);
  }
  function inspectNode(object, objects, duplicatesIndexes) {
    var objectKeyList, index, length;
    if (object !== null && typeof object === "object") {
      index = objects.indexOf(object);
      if (index !== -1) {
        if (duplicatesIndexes.indexOf(index) === -1) {
          duplicatesIndexes.push(index);
        }
      } else {
        objects.push(object);
        if (Array.isArray(object)) {
          for (index = 0, length = object.length;index < length; index += 1) {
            inspectNode(object[index], objects, duplicatesIndexes);
          }
        } else {
          objectKeyList = Object.keys(object);
          for (index = 0, length = objectKeyList.length;index < length; index += 1) {
            inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
          }
        }
      }
    }
  }
  function dump(input, options2) {
    options2 = options2 || {};
    var state = new State(options2);
    if (!state.noRefs)
      getDuplicateReferences(input, state);
    if (writeNode(state, 0, input, true, true))
      return state.dump + `
`;
    return "";
  }
  function safeDump(input, options2) {
    return dump(input, common.extend({ schema: DEFAULT_SAFE_SCHEMA }, options2));
  }
  exports.dump = dump;
  exports.safeDump = safeDump;
});

// node_modules/gray-matter/node_modules/js-yaml/lib/js-yaml.js
var require_js_yaml = __commonJS((exports, module) => {
  var loader = require_loader();
  var dumper = require_dumper();
  function deprecated(name) {
    return function() {
      throw new Error("Function " + name + " is deprecated and cannot be used.");
    };
  }
  exports.Type = require_type();
  exports.Schema = require_schema();
  exports.FAILSAFE_SCHEMA = require_failsafe();
  exports.JSON_SCHEMA = require_json();
  exports.CORE_SCHEMA = require_core();
  exports.DEFAULT_SAFE_SCHEMA = require_default_safe();
  exports.DEFAULT_FULL_SCHEMA = require_default_full();
  exports.load = loader.load;
  exports.loadAll = loader.loadAll;
  exports.safeLoad = loader.safeLoad;
  exports.safeLoadAll = loader.safeLoadAll;
  exports.dump = dumper.dump;
  exports.safeDump = dumper.safeDump;
  exports.YAMLException = require_exception();
  exports.MINIMAL_SCHEMA = require_failsafe();
  exports.SAFE_SCHEMA = require_default_safe();
  exports.DEFAULT_SCHEMA = require_default_full();
  exports.scan = deprecated("scan");
  exports.parse = deprecated("parse");
  exports.compose = deprecated("compose");
  exports.addConstructor = deprecated("addConstructor");
});

// node_modules/gray-matter/node_modules/js-yaml/index.js
var require_js_yaml2 = __commonJS((exports, module) => {
  var yaml = require_js_yaml();
  module.exports = yaml;
});

// node_modules/gray-matter/lib/engines.js
var require_engines = __commonJS((exports, module) => {
  var yaml = require_js_yaml2();
  var engines = exports = module.exports;
  engines.yaml = {
    parse: yaml.safeLoad.bind(yaml),
    stringify: yaml.safeDump.bind(yaml)
  };
  engines.json = {
    parse: JSON.parse.bind(JSON),
    stringify: function(obj, options2) {
      const opts = Object.assign({ replacer: null, space: 2 }, options2);
      return JSON.stringify(obj, opts.replacer, opts.space);
    }
  };
  engines.javascript = {
    parse: function parse(str, options, wrap) {
      try {
        if (wrap !== false) {
          str = `(function() {
return ` + str.trim() + `;
}());`;
        }
        return eval(str) || {};
      } catch (err) {
        if (wrap !== false && /(unexpected|identifier)/i.test(err.message)) {
          return parse(str, options, false);
        }
        throw new SyntaxError(err);
      }
    },
    stringify: function() {
      throw new Error("stringifying JavaScript is not supported");
    }
  };
});

// node_modules/strip-bom-string/index.js
var require_strip_bom_string = __commonJS((exports, module) => {
  /*!
   * strip-bom-string <https://github.com/jonschlinkert/strip-bom-string>
   *
   * Copyright (c) 2015, 2017, Jon Schlinkert.
   * Released under the MIT License.
   */
  module.exports = function(str2) {
    if (typeof str2 === "string" && str2.charAt(0) === "\uFEFF") {
      return str2.slice(1);
    }
    return str2;
  };
});

// node_modules/gray-matter/lib/utils.js
var require_utils = __commonJS((exports) => {
  var stripBom = require_strip_bom_string();
  var typeOf = require_kind_of();
  exports.define = function(obj, key, val) {
    Reflect.defineProperty(obj, key, {
      enumerable: false,
      configurable: true,
      writable: true,
      value: val
    });
  };
  exports.isBuffer = function(val) {
    return typeOf(val) === "buffer";
  };
  exports.isObject = function(val) {
    return typeOf(val) === "object";
  };
  exports.toBuffer = function(input) {
    return typeof input === "string" ? Buffer.from(input) : input;
  };
  exports.toString = function(input) {
    if (exports.isBuffer(input))
      return stripBom(String(input));
    if (typeof input !== "string") {
      throw new TypeError("expected input to be a string or buffer");
    }
    return stripBom(input);
  };
  exports.arrayify = function(val) {
    return val ? Array.isArray(val) ? val : [val] : [];
  };
  exports.startsWith = function(str2, substr, len) {
    if (typeof len !== "number")
      len = substr.length;
    return str2.slice(0, len) === substr;
  };
});

// node_modules/gray-matter/lib/defaults.js
var require_defaults = __commonJS((exports, module) => {
  var engines = require_engines();
  var utils = require_utils();
  module.exports = function(options2) {
    const opts = Object.assign({}, options2);
    opts.delimiters = utils.arrayify(opts.delims || opts.delimiters || "---");
    if (opts.delimiters.length === 1) {
      opts.delimiters.push(opts.delimiters[0]);
    }
    opts.language = (opts.language || opts.lang || "yaml").toLowerCase();
    opts.engines = Object.assign({}, engines, opts.parsers, opts.engines);
    return opts;
  };
});

// node_modules/gray-matter/lib/engine.js
var require_engine = __commonJS((exports, module) => {
  module.exports = function(name, options2) {
    let engine = options2.engines[name] || options2.engines[aliase(name)];
    if (typeof engine === "undefined") {
      throw new Error('gray-matter engine "' + name + '" is not registered');
    }
    if (typeof engine === "function") {
      engine = { parse: engine };
    }
    return engine;
  };
  function aliase(name) {
    switch (name.toLowerCase()) {
      case "js":
      case "javascript":
        return "javascript";
      case "coffee":
      case "coffeescript":
      case "cson":
        return "coffee";
      case "yaml":
      case "yml":
        return "yaml";
      default: {
        return name;
      }
    }
  }
});

// node_modules/gray-matter/lib/stringify.js
var require_stringify = __commonJS((exports, module) => {
  var typeOf = require_kind_of();
  var getEngine = require_engine();
  var defaults = require_defaults();
  module.exports = function(file, data, options2) {
    if (data == null && options2 == null) {
      switch (typeOf(file)) {
        case "object":
          data = file.data;
          options2 = {};
          break;
        case "string":
          return file;
        default: {
          throw new TypeError("expected file to be a string or object");
        }
      }
    }
    const str2 = file.content;
    const opts = defaults(options2);
    if (data == null) {
      if (!opts.data)
        return file;
      data = opts.data;
    }
    const language = file.language || opts.language;
    const engine = getEngine(language, opts);
    if (typeof engine.stringify !== "function") {
      throw new TypeError('expected "' + language + '.stringify" to be a function');
    }
    data = Object.assign({}, file.data, data);
    const open = opts.delimiters[0];
    const close = opts.delimiters[1];
    const matter = engine.stringify(data, options2).trim();
    let buf = "";
    if (matter !== "{}") {
      buf = newline(open) + newline(matter) + newline(close);
    }
    if (typeof file.excerpt === "string" && file.excerpt !== "") {
      if (str2.indexOf(file.excerpt.trim()) === -1) {
        buf += newline(file.excerpt) + newline(close);
      }
    }
    return buf + newline(str2);
  };
  function newline(str2) {
    return str2.slice(-1) !== `
` ? str2 + `
` : str2;
  }
});

// node_modules/gray-matter/lib/excerpt.js
var require_excerpt = __commonJS((exports, module) => {
  var defaults = require_defaults();
  module.exports = function(file, options2) {
    const opts = defaults(options2);
    if (file.data == null) {
      file.data = {};
    }
    if (typeof opts.excerpt === "function") {
      return opts.excerpt(file, opts);
    }
    const sep = file.data.excerpt_separator || opts.excerpt_separator;
    if (sep == null && (opts.excerpt === false || opts.excerpt == null)) {
      return file;
    }
    const delimiter = typeof opts.excerpt === "string" ? opts.excerpt : sep || opts.delimiters[0];
    const idx = file.content.indexOf(delimiter);
    if (idx !== -1) {
      file.excerpt = file.content.slice(0, idx);
    }
    return file;
  };
});

// node_modules/gray-matter/lib/to-file.js
var require_to_file = __commonJS((exports, module) => {
  var typeOf = require_kind_of();
  var stringify = require_stringify();
  var utils = require_utils();
  module.exports = function(file) {
    if (typeOf(file) !== "object") {
      file = { content: file };
    }
    if (typeOf(file.data) !== "object") {
      file.data = {};
    }
    if (file.contents && file.content == null) {
      file.content = file.contents;
    }
    utils.define(file, "orig", utils.toBuffer(file.content));
    utils.define(file, "language", file.language || "");
    utils.define(file, "matter", file.matter || "");
    utils.define(file, "stringify", function(data, options2) {
      if (options2 && options2.language) {
        file.language = options2.language;
      }
      return stringify(file, data, options2);
    });
    file.content = utils.toString(file.content);
    file.isEmpty = false;
    file.excerpt = "";
    return file;
  };
});

// node_modules/gray-matter/lib/parse.js
var require_parse = __commonJS((exports, module) => {
  var getEngine = require_engine();
  var defaults = require_defaults();
  module.exports = function(language, str2, options2) {
    const opts = defaults(options2);
    const engine = getEngine(language, opts);
    if (typeof engine.parse !== "function") {
      throw new TypeError('expected "' + language + '.parse" to be a function');
    }
    return engine.parse(str2, opts);
  };
});

// node_modules/gray-matter/index.js
var require_gray_matter = __commonJS((exports, module) => {
  var fs = __require("fs");
  var sections = require_section_matter();
  var defaults = require_defaults();
  var stringify = require_stringify();
  var excerpt = require_excerpt();
  var engines = require_engines();
  var toFile = require_to_file();
  var parse2 = require_parse();
  var utils = require_utils();
  function matter(input, options2) {
    if (input === "") {
      return { data: {}, content: input, excerpt: "", orig: input };
    }
    let file = toFile(input);
    const cached = matter.cache[file.content];
    if (!options2) {
      if (cached) {
        file = Object.assign({}, cached);
        file.orig = cached.orig;
        return file;
      }
      matter.cache[file.content] = file;
    }
    return parseMatter(file, options2);
  }
  function parseMatter(file, options2) {
    const opts = defaults(options2);
    const open = opts.delimiters[0];
    const close = `
` + opts.delimiters[1];
    let str2 = file.content;
    if (opts.language) {
      file.language = opts.language;
    }
    const openLen = open.length;
    if (!utils.startsWith(str2, open, openLen)) {
      excerpt(file, opts);
      return file;
    }
    if (str2.charAt(openLen) === open.slice(-1)) {
      return file;
    }
    str2 = str2.slice(openLen);
    const len = str2.length;
    const language = matter.language(str2, opts);
    if (language.name) {
      file.language = language.name;
      str2 = str2.slice(language.raw.length);
    }
    let closeIndex = str2.indexOf(close);
    if (closeIndex === -1) {
      closeIndex = len;
    }
    file.matter = str2.slice(0, closeIndex);
    const block = file.matter.replace(/^\s*#[^\n]+/gm, "").trim();
    if (block === "") {
      file.isEmpty = true;
      file.empty = file.content;
      file.data = {};
    } else {
      file.data = parse2(file.language, file.matter, opts);
    }
    if (closeIndex === len) {
      file.content = "";
    } else {
      file.content = str2.slice(closeIndex + close.length);
      if (file.content[0] === "\r") {
        file.content = file.content.slice(1);
      }
      if (file.content[0] === `
`) {
        file.content = file.content.slice(1);
      }
    }
    excerpt(file, opts);
    if (opts.sections === true || typeof opts.section === "function") {
      sections(file, opts.section);
    }
    return file;
  }
  matter.engines = engines;
  matter.stringify = function(file, data, options2) {
    if (typeof file === "string")
      file = matter(file, options2);
    return stringify(file, data, options2);
  };
  matter.read = function(filepath, options2) {
    const str2 = fs.readFileSync(filepath, "utf8");
    const file = matter(str2, options2);
    file.path = filepath;
    return file;
  };
  matter.test = function(str2, options2) {
    return utils.startsWith(str2, defaults(options2).delimiters[0]);
  };
  matter.language = function(str2, options2) {
    const opts = defaults(options2);
    const open = opts.delimiters[0];
    if (matter.test(str2)) {
      str2 = str2.slice(open.length);
    }
    const language = str2.slice(0, str2.search(/\r?\n/));
    return {
      raw: language,
      name: language ? language.trim() : ""
    };
  };
  matter.cache = {};
  matter.clearCache = function() {
    matter.cache = {};
  };
  module.exports = matter;
});

// node_modules/event-emission/dist/index.js
var SymbolObservable = typeof Symbol === "function" && Symbol.observable || Symbol.for("@@observable");
if (typeof Symbol === "function") {
  Symbol.observable = SymbolObservable;
}
function getMethod(obj, key) {
  if (obj === null || obj === undefined)
    return;
  const value = obj[key];
  if (value == null)
    return;
  if (typeof value !== "function") {
    throw new TypeError(value + " is not a function");
  }
  return value;
}
function hostReportError(e) {
  if (typeof queueMicrotask === "function") {
    queueMicrotask(() => {
      throw e;
    });
  } else {
    setTimeout(() => {
      throw e;
    });
  }
}
function SubscriptionObserverImpl(subscription) {
  this._subscription = subscription;
}
SubscriptionObserverImpl.prototype = Object.create(Object.prototype);
Object.defineProperties(SubscriptionObserverImpl.prototype, {
  constructor: { value: Object, configurable: true, writable: true },
  closed: {
    get() {
      return this._subscription._closed;
    },
    configurable: true
  },
  next: {
    value: function next(value) {
      const subscription = this._subscription;
      if (subscription._closed)
        return;
      const observer = subscription._observer;
      try {
        const m = getMethod(observer, "next");
        if (!m)
          return;
        return m.call(observer, value);
      } catch (e) {
        try {
          this.error(e);
        } catch (err) {
          hostReportError(err);
        }
      }
    },
    configurable: true,
    writable: true
  },
  error: {
    value: function error(errorValue) {
      const subscription = this._subscription;
      if (subscription._closed)
        throw errorValue;
      subscription._closed = true;
      const observer = subscription._observer;
      try {
        const m = getMethod(observer, "error");
        if (m) {
          return m.call(observer, errorValue);
        }
        throw errorValue;
      } finally {
        subscription._cleanup();
      }
    },
    configurable: true,
    writable: true
  },
  complete: {
    value: function complete(value) {
      const subscription = this._subscription;
      if (subscription._closed)
        return;
      subscription._closed = true;
      const observer = subscription._observer;
      try {
        const m = getMethod(observer, "complete");
        if (m) {
          return m.call(observer, value);
        }
        return;
      } finally {
        subscription._cleanup();
      }
    },
    configurable: true,
    writable: true
  }
});
Object.defineProperty(SubscriptionObserverImpl.prototype.next, "length", { value: 1 });
Object.defineProperty(SubscriptionObserverImpl.prototype.error, "length", { value: 1 });
Object.defineProperty(SubscriptionObserverImpl.prototype.complete, "length", {
  value: 1
});
function Subscription(observer, subscriber) {
  this._observer = observer;
  this._cleanupFn = undefined;
  this._closed = false;
  const subscriptionObserver = new SubscriptionObserverImpl(this);
  try {
    const start = getMethod(observer, "start");
    if (start) {
      start.call(observer, this);
    }
  } catch (e) {
    hostReportError(e);
  }
  if (this._closed)
    return;
  try {
    const cleanup = subscriber(subscriptionObserver);
    if (cleanup != null) {
      if (typeof cleanup !== "function" && typeof cleanup.unsubscribe !== "function") {
        throw new TypeError(cleanup + " is not a function or a subscription");
      }
      this._cleanupFn = cleanup;
      if (this._closed) {
        this._cleanup();
      }
    }
  } catch (e) {
    subscriptionObserver.error(e);
  }
}
Subscription.prototype = Object.create(Object.prototype);
Object.defineProperties(Subscription.prototype, {
  constructor: { value: Object, configurable: true, writable: true },
  closed: {
    get() {
      return this._closed;
    },
    configurable: true
  },
  unsubscribe: {
    value: function unsubscribe() {
      if (this._closed)
        return;
      this._closed = true;
      this._cleanup();
    },
    configurable: true,
    writable: true
  },
  _cleanup: {
    value: function _cleanup() {
      const cleanup = this._cleanupFn;
      if (!cleanup)
        return;
      this._cleanupFn = undefined;
      try {
        if (typeof cleanup === "function") {
          cleanup();
        } else if (cleanup && typeof cleanup.unsubscribe === "function") {
          cleanup.unsubscribe();
        }
      } catch (e) {
        hostReportError(e);
      }
    },
    configurable: true,
    writable: true
  }
});

class Observable {
  _subscriber;
  constructor(subscriber) {
    if (typeof subscriber !== "function") {
      throw new TypeError("Observable initializer must be a function");
    }
    this._subscriber = subscriber;
  }
  subscribe(observerOrNext, error2, complete2) {
    let observer;
    if (typeof observerOrNext === "function") {
      observer = {
        next: observerOrNext,
        error: error2,
        complete: complete2
      };
    } else if (typeof observerOrNext !== "object" || observerOrNext === null) {
      throw new TypeError(observerOrNext + " is not an object");
    } else {
      observer = observerOrNext;
    }
    return new Subscription(observer, this._subscriber);
  }
  [SymbolObservable]() {
    return this;
  }
  static of(...items) {
    const C = typeof this === "function" ? this : Observable;
    return new C((observer) => {
      for (let i = 0;i < items.length; ++i) {
        observer.next(items[i]);
        if (observer.closed)
          return;
      }
      observer.complete();
    });
  }
  static from(x) {
    const C = typeof this === "function" ? this : Observable;
    if (x == null)
      throw new TypeError(x + " is not an object");
    const method = x[SymbolObservable];
    if (method != null) {
      if (typeof method !== "function") {
        throw new TypeError(method + " is not a function");
      }
      const observable = method.call(x);
      if (Object(observable) !== observable) {
        throw new TypeError(observable + " is not an object");
      }
      if (observable.constructor === C) {
        return observable;
      }
      return new C((observer) => observable.subscribe(observer));
    }
    if (Symbol.iterator in x) {
      return new C((observer) => {
        for (const item of x) {
          observer.next(item);
          if (observer.closed)
            return;
        }
        observer.complete();
      });
    }
    throw new TypeError(x + " is not observable");
  }
}
var PROXY_MARKER = Symbol.for("@lasercat/event-emission/proxy");
var ORIGINAL_TARGET = Symbol.for("@lasercat/event-emission/original");
var ARRAY_MUTATORS = new Set([
  "push",
  "pop",
  "shift",
  "unshift",
  "splice",
  "sort",
  "reverse",
  "fill",
  "copyWithin"
]);
function isProxyable(value) {
  return value !== null && typeof value === "object" && !isProxied(value) && !(value instanceof Date) && !(value instanceof RegExp) && !(value instanceof Map) && !(value instanceof Set) && !(value instanceof WeakMap) && !(value instanceof WeakSet) && !(value instanceof Promise) && !(value instanceof Error) && !(value instanceof ArrayBuffer) && !ArrayBuffer.isView(value);
}
function isProxied(value) {
  return typeof value === "object" && value !== null && value[PROXY_MARKER] === true;
}
function isArrayMutator(prop) {
  return typeof prop === "string" && ARRAY_MUTATORS.has(prop);
}
function cloneAlongPath(obj, path) {
  const isArray = Array.isArray(obj);
  const rootClone = isArray ? [...obj] : { ...obj };
  if (!path || isArray) {
    return rootClone;
  }
  const parts = path.split(".");
  const result = rootClone;
  let current = result;
  for (let i = 0;i < parts.length; i++) {
    const key = parts[i];
    const value = current[key];
    if (value !== null && typeof value === "object") {
      current[key] = Array.isArray(value) ? [...value] : { ...value };
      if (i < parts.length - 1) {
        current = current[key];
      }
    } else {
      break;
    }
  }
  return result;
}
function cloneForComparison(obj, strategy, changedPath, deepClone) {
  if (obj === null || typeof obj !== "object")
    return obj;
  switch (strategy) {
    case "shallow":
      return Array.isArray(obj) ? [...obj] : { ...obj };
    case "deep":
      if (deepClone) {
        return deepClone(obj);
      }
      if (typeof structuredClone !== "function") {
        throw new Error("structuredClone is not available in this runtime; provide observe.deepClone, or use cloneStrategy 'path' or 'shallow'.");
      }
      return structuredClone(obj);
    case "path":
      return cloneAlongPath(obj, changedPath);
    default:
      return obj;
  }
}
function computeArrayDiff(method, before, _after, args) {
  switch (method) {
    case "push":
      return { added: args };
    case "pop":
      return { removed: before.length > 0 ? [before[before.length - 1]] : [] };
    case "shift":
      return { removed: before.length > 0 ? [before[0]] : [] };
    case "unshift":
      return { added: args };
    case "splice": {
      const [start, deleteCount, ...items] = args;
      const actualStart = start < 0 ? Math.max(before.length + start, 0) : Math.min(start, before.length);
      const actualDeleteCount = Math.min(deleteCount ?? before.length - actualStart, before.length - actualStart);
      return {
        removed: before.slice(actualStart, actualStart + actualDeleteCount),
        added: items
      };
    }
    case "sort":
    case "reverse":
    case "fill":
    case "copyWithin":
      return {};
    default:
      return {};
  }
}
var proxyRegistry = new WeakMap;
function getContextRegistry(target) {
  let contextMap = proxyRegistry.get(target);
  if (!contextMap) {
    contextMap = new WeakMap;
    proxyRegistry.set(target, contextMap);
  }
  return contextMap;
}
function createArrayMethodInterceptor(array, method, path, context) {
  const original = array[method];
  return function(...args) {
    const previousState = cloneForComparison(context.originalRoot, context.options.cloneStrategy, path, context.options.deepClone);
    const previousItems = [...array];
    const result = original.apply(this, args);
    const { added, removed } = computeArrayDiff(method, previousItems, array, args);
    const methodEventPath = path ? `update:${path}.${method}` : `update:${method}`;
    const arrayEventPath = path ? `update:${path}` : "update:";
    context.eventTarget.dispatchEvent({
      type: methodEventPath,
      detail: {
        method,
        args,
        result,
        added,
        removed,
        current: context.originalRoot,
        previous: previousState
      }
    });
    if (path) {
      context.eventTarget.dispatchEvent({
        type: arrayEventPath,
        detail: {
          value: array,
          current: context.originalRoot,
          previous: previousState
        }
      });
    }
    context.eventTarget.dispatchEvent({
      type: "update",
      detail: {
        current: context.originalRoot,
        previous: previousState
      }
    });
    return result;
  };
}
function createObservableProxyInternal(target, path, context) {
  const contextRegistry = getContextRegistry(target);
  const existing = contextRegistry.get(context);
  if (existing) {
    return existing.proxy;
  }
  const proxy = new Proxy(target, {
    get(obj, prop, receiver) {
      if (prop === PROXY_MARKER)
        return true;
      if (prop === ORIGINAL_TARGET)
        return obj;
      if (typeof prop === "symbol") {
        return Reflect.get(obj, prop, receiver);
      }
      const value = Reflect.get(obj, prop, receiver);
      if (Array.isArray(obj) && isArrayMutator(prop)) {
        return createArrayMethodInterceptor(obj, prop, path, context);
      }
      if (context.options.deep && isProxyable(value)) {
        const nestedPath = path ? `${path}.${prop}` : prop;
        return createObservableProxyInternal(value, nestedPath, context);
      }
      return value;
    },
    set(obj, prop, value, receiver) {
      if (typeof prop === "symbol") {
        return Reflect.set(obj, prop, value, receiver);
      }
      const oldValue = Reflect.get(obj, prop, receiver);
      if (Object.is(oldValue, value)) {
        return true;
      }
      const propPath = path ? `${path}.${prop}` : prop;
      const previousState = cloneForComparison(context.originalRoot, context.options.cloneStrategy, propPath, context.options.deepClone);
      const success = Reflect.set(obj, prop, value, receiver);
      if (success) {
        context.eventTarget.dispatchEvent({
          type: `update:${propPath}`,
          detail: {
            value,
            current: context.originalRoot,
            previous: previousState
          }
        });
        context.eventTarget.dispatchEvent({
          type: "update",
          detail: {
            current: context.originalRoot,
            previous: previousState
          }
        });
      }
      return success;
    },
    deleteProperty(obj, prop) {
      if (typeof prop === "symbol") {
        return Reflect.deleteProperty(obj, prop);
      }
      const propPath = path ? `${path}.${String(prop)}` : String(prop);
      const previousState = cloneForComparison(context.originalRoot, context.options.cloneStrategy, propPath, context.options.deepClone);
      const success = Reflect.deleteProperty(obj, prop);
      if (success) {
        context.eventTarget.dispatchEvent({
          type: `update:${propPath}`,
          detail: {
            value: undefined,
            current: context.originalRoot,
            previous: previousState
          }
        });
        context.eventTarget.dispatchEvent({
          type: "update",
          detail: {
            current: context.originalRoot,
            previous: previousState
          }
        });
      }
      return success;
    }
  });
  contextRegistry.set(context, {
    proxy,
    path
  });
  return proxy;
}
function isEventTarget(obj) {
  return typeof obj === "object" && obj !== null && typeof obj.addEventListener === "function" && typeof obj.removeEventListener === "function" && typeof obj.dispatchEvent === "function";
}
function setupEventForwarding(source, target) {
  const handlers = new Map;
  const sourceAddEventListener = source.addEventListener.bind(source);
  const sourceRemoveEventListener = source.removeEventListener.bind(source);
  const forwardHandler = (type) => (event) => {
    const detail = event.detail ?? event;
    target.dispatchEvent({
      type,
      detail
    });
  };
  const originalAddEventListener = target.addEventListener.bind(target);
  const wrappedAddEventListener = (type, listener, options2) => {
    if (!handlers.has(type) && type !== "update" && !type.startsWith("update:")) {
      const handler = forwardHandler(type);
      handlers.set(type, handler);
      sourceAddEventListener(type, handler);
    }
    return originalAddEventListener(type, listener, options2);
  };
  target.addEventListener = wrappedAddEventListener;
  return () => {
    target.addEventListener = originalAddEventListener;
    for (const [type, handler] of handlers) {
      sourceRemoveEventListener(type, handler);
    }
    handlers.clear();
  };
}
function createObservableProxy(target, eventTarget, options2) {
  const resolvedOptions = {
    deep: options2?.deep ?? true,
    cloneStrategy: options2?.cloneStrategy ?? "path",
    deepClone: options2?.deepClone
  };
  const context = {
    eventTarget,
    originalRoot: target,
    options: resolvedOptions
  };
  const proxy = createObservableProxyInternal(target, "", context);
  if (isEventTarget(target)) {
    const cleanupForwarding = setupEventForwarding(target, eventTarget);
    const maybeComplete = eventTarget.complete;
    if (typeof maybeComplete === "function") {
      const originalComplete = maybeComplete.bind(eventTarget);
      let cleaned = false;
      eventTarget.complete = () => {
        if (!cleaned) {
          cleaned = true;
          cleanupForwarding();
        }
        return originalComplete();
      };
    }
  }
  return proxy;
}

class BufferOverflowError extends Error {
  constructor(eventType, bufferSize) {
    super(`Buffer overflow for event type "${eventType}" (max: ${bufferSize})`);
    this.name = "BufferOverflowError";
  }
}
function matchesWildcard(eventType, pattern) {
  if (pattern === "*")
    return true;
  return pattern.endsWith(":*") && eventType.startsWith(pattern.slice(0, -2) + ":");
}
var EVENT_STATE = Symbol("event-emission:event-state");
function createEventTarget(targetOrOpts, opts) {
  if (opts?.observe === true && targetOrOpts && typeof targetOrOpts === "object") {
    const target = targetOrOpts;
    const eventTarget = createEventTargetInternal({
      onListenerError: opts.onListenerError
    });
    const proxy = createObservableProxy(target, eventTarget, {
      deep: opts.deep,
      cloneStrategy: opts.cloneStrategy,
      deepClone: opts.deepClone
    });
    const methodNames = [
      "addEventListener",
      "removeEventListener",
      "dispatchEvent",
      "clear",
      "on",
      "once",
      "removeAllListeners",
      "pipe",
      "addWildcardListener",
      "removeWildcardListener",
      "complete",
      "subscribe",
      "toObservable",
      "events"
    ];
    for (const name of methodNames) {
      Object.defineProperty(proxy, name, {
        value: eventTarget[name],
        writable: false,
        enumerable: false,
        configurable: true
      });
    }
    Object.defineProperty(proxy, "completed", {
      get: () => eventTarget.completed,
      enumerable: false,
      configurable: true
    });
    return proxy;
  }
  return createEventTargetInternal(targetOrOpts);
}
function createEventTargetInternal(opts) {
  const listeners = new Map;
  const wildcardListeners = new Set;
  let isCompleted = false;
  const completionCallbacks = new Set;
  const now = () => typeof globalThis.performance?.now === "function" ? globalThis.performance.now() : Date.now();
  const initializeEventState = (state, type, bubbles, cancelable) => {
    state.initializedFlag = true;
    state.stopPropagationFlag = false;
    state.stopImmediatePropagationFlag = false;
    state.canceledFlag = false;
    state.isTrusted = false;
    state.target = null;
    state.currentTarget = null;
    state.eventPhase = 0;
    state.type = type;
    state.bubbles = bubbles;
    state.cancelable = cancelable;
  };
  const setCanceledFlag = (state) => {
    if (state.cancelable && !state.inPassiveListenerFlag) {
      state.canceledFlag = true;
    }
  };
  const createEvent = (type, detail, init) => {
    const state = {
      dispatchFlag: false,
      initializedFlag: true,
      stopPropagationFlag: false,
      stopImmediatePropagationFlag: false,
      canceledFlag: false,
      inPassiveListenerFlag: false,
      composedFlag: Boolean(init?.composed),
      eventPhase: init?.eventPhase ?? 0,
      currentTarget: init?.currentTarget ?? init?.target ?? null,
      target: init?.target ?? null,
      timeStamp: init?.timeStamp ?? now(),
      path: [],
      type,
      bubbles: Boolean(init?.bubbles),
      cancelable: Boolean(init?.cancelable),
      isTrusted: false
    };
    const event = { detail };
    Object.defineProperties(event, {
      type: {
        get: () => state.type,
        enumerable: true,
        configurable: true
      },
      bubbles: {
        get: () => state.bubbles,
        enumerable: true,
        configurable: true
      },
      cancelable: {
        get: () => state.cancelable,
        enumerable: true,
        configurable: true
      },
      cancelBubble: {
        get: () => state.stopPropagationFlag,
        set: (value) => {
          if (value)
            state.stopPropagationFlag = true;
        },
        enumerable: true,
        configurable: true
      },
      composed: {
        get: () => state.composedFlag,
        enumerable: true,
        configurable: true
      },
      currentTarget: {
        get: () => state.currentTarget,
        enumerable: true,
        configurable: true
      },
      defaultPrevented: {
        get: () => state.canceledFlag,
        enumerable: true,
        configurable: true
      },
      eventPhase: {
        get: () => state.eventPhase,
        enumerable: true,
        configurable: true
      },
      isTrusted: {
        get: () => state.isTrusted,
        enumerable: true,
        configurable: true
      },
      returnValue: {
        get: () => !state.canceledFlag,
        set: (value) => {
          if (value === false)
            setCanceledFlag(state);
        },
        enumerable: true,
        configurable: true
      },
      srcElement: {
        get: () => state.target,
        enumerable: true,
        configurable: true
      },
      target: {
        get: () => state.target,
        enumerable: true,
        configurable: true
      },
      timeStamp: {
        get: () => state.timeStamp,
        enumerable: true,
        configurable: true
      },
      composedPath: {
        value: () => state.path.map((entry) => entry.invocationTarget),
        enumerable: true,
        configurable: true
      },
      initEvent: {
        value: (newType, bubbles = false, cancelable = false) => {
          if (state.dispatchFlag)
            return;
          initializeEventState(state, newType, Boolean(bubbles), Boolean(cancelable));
        },
        enumerable: true,
        configurable: true
      },
      preventDefault: {
        value: () => setCanceledFlag(state),
        enumerable: true,
        configurable: true
      },
      stopImmediatePropagation: {
        value: () => {
          state.stopPropagationFlag = true;
          state.stopImmediatePropagationFlag = true;
        },
        enumerable: true,
        configurable: true
      },
      stopPropagation: {
        value: () => {
          state.stopPropagationFlag = true;
        },
        enumerable: true,
        configurable: true
      },
      NONE: { value: 0, enumerable: true, configurable: true },
      CAPTURING_PHASE: { value: 1, enumerable: true, configurable: true },
      AT_TARGET: { value: 2, enumerable: true, configurable: true },
      BUBBLING_PHASE: { value: 3, enumerable: true, configurable: true },
      [EVENT_STATE]: {
        value: state,
        enumerable: false,
        configurable: false
      }
    });
    return event;
  };
  const getEventState = (event) => event[EVENT_STATE];
  const normalizeAddListenerOptions = (options2) => {
    if (typeof options2 === "boolean") {
      return {
        capture: options2,
        passive: false,
        once: false,
        signal: null
      };
    }
    return {
      capture: Boolean(options2?.capture),
      passive: Boolean(options2?.passive),
      once: Boolean(options2?.once),
      signal: options2?.signal ?? null
    };
  };
  const normalizeCaptureOption = (options2) => {
    if (typeof options2 === "boolean")
      return options2;
    return Boolean(options2?.capture);
  };
  const removeListenerRecord = (type, record) => {
    if (record.removed)
      return;
    record.removed = true;
    const list = listeners.get(type);
    if (list) {
      const idx = list.indexOf(record);
      if (idx >= 0)
        list.splice(idx, 1);
      if (list.length === 0)
        listeners.delete(type);
    }
    if (record.signal && record.abortHandler) {
      record.signal.removeEventListener("abort", record.abortHandler);
    }
  };
  const handleListenerError = (eventType, error2) => {
    if (eventType === "error")
      return;
    if (opts?.onListenerError) {
      opts.onListenerError(eventType, error2);
      return;
    }
    const errorListeners = listeners.get("error");
    if (errorListeners && errorListeners.length > 0) {
      dispatchEvent({ type: "error", detail: error2 });
    } else {
      throw error2;
    }
  };
  const notifyWildcardListeners = (eventType, event) => {
    if (wildcardListeners.size === 0)
      return;
    for (const rec of Array.from(wildcardListeners)) {
      if (!matchesWildcard(eventType, rec.pattern))
        continue;
      const baseEvent = createEvent(rec.pattern, event.detail, {
        target,
        currentTarget: target,
        eventPhase: 2,
        bubbles: event.bubbles,
        cancelable: event.cancelable,
        composed: event.composed
      });
      const wildcardEvent = Object.defineProperties(baseEvent, {
        originalType: { value: eventType, enumerable: true, configurable: true }
      });
      try {
        const fn = rec.fn;
        const res = fn(wildcardEvent);
        if (res && typeof res.then === "function") {
          res.catch((error2) => {
            try {
              handleListenerError(eventType, error2);
            } catch (rethrown) {
              queueMicrotask(() => {
                throw rethrown;
              });
            }
          });
        }
      } catch (error2) {
        handleListenerError(eventType, error2);
      } finally {
        if (rec.once)
          wildcardListeners.delete(rec);
      }
      const state = getEventState(wildcardEvent);
      if (state?.stopImmediatePropagationFlag || state?.stopPropagationFlag) {
        break;
      }
    }
  };
  const addEventListener = (type, listener, options2) => {
    if (isCompleted || !listener) {
      return () => {};
    }
    const { capture, passive, once, signal } = normalizeAddListenerOptions(options2);
    let list = listeners.get(type);
    if (!list) {
      list = [];
      listeners.set(type, list);
    }
    for (const existing of list) {
      if (existing.original === listener && existing.capture === capture) {
        return () => removeEventListener(type, listener, options2);
      }
    }
    const original = listener;
    const callback = typeof listener === "function" ? listener : (event) => listener.handleEvent(event);
    const record = {
      type,
      original,
      callback,
      capture,
      passive,
      once,
      signal,
      removed: false
    };
    list.push(record);
    const unsubscribe2 = () => removeListenerRecord(type, record);
    if (signal) {
      const onAbort = () => removeListenerRecord(type, record);
      record.abortHandler = onAbort;
      signal.addEventListener("abort", onAbort, { once: true });
      if (signal.aborted)
        onAbort();
    }
    return unsubscribe2;
  };
  const addWildcardListener = (pattern, listener, options2) => {
    if (isCompleted)
      return () => {};
    const opts2 = options2 ?? {};
    for (const existing of wildcardListeners) {
      if (existing.pattern === pattern && existing.fn === listener) {
        return () => removeWildcardListener(pattern, listener);
      }
    }
    const record = {
      fn: listener,
      pattern,
      once: opts2.once,
      signal: opts2.signal
    };
    wildcardListeners.add(record);
    const unsubscribe2 = () => {
      wildcardListeners.delete(record);
      if (record.signal && record.abortHandler) {
        record.signal.removeEventListener("abort", record.abortHandler);
      }
    };
    if (opts2.signal) {
      const onAbort = () => unsubscribe2();
      record.abortHandler = onAbort;
      opts2.signal.addEventListener("abort", onAbort, { once: true });
      if (opts2.signal.aborted)
        onAbort();
    }
    return unsubscribe2;
  };
  const removeWildcardListener = (pattern, listener) => {
    for (const record of Array.from(wildcardListeners)) {
      if (record.pattern === pattern && record.fn === listener) {
        wildcardListeners.delete(record);
        if (record.signal && record.abortHandler) {
          record.signal.removeEventListener("abort", record.abortHandler);
        }
      }
    }
  };
  const invokeListeners = (eventType, event, phase, listenersSnapshot) => {
    const state = getEventState(event);
    if (!state || state.stopPropagationFlag)
      return;
    state.currentTarget = target;
    state.target = target;
    state.eventPhase = event.AT_TARGET;
    for (const rec of listenersSnapshot) {
      if (rec.removed)
        continue;
      if (phase === "capturing" && !rec.capture)
        continue;
      if (phase === "bubbling" && rec.capture)
        continue;
      if (rec.once)
        removeListenerRecord(rec.type, rec);
      if (rec.passive)
        state.inPassiveListenerFlag = true;
      try {
        const res = rec.callback.call(state.currentTarget, event);
        if (res && typeof res.then === "function") {
          res.catch((error2) => {
            try {
              handleListenerError(eventType, error2);
            } catch (rethrown) {
              queueMicrotask(() => {
                throw rethrown;
              });
            }
          });
        }
      } catch (error2) {
        handleListenerError(eventType, error2);
      } finally {
        if (rec.passive)
          state.inPassiveListenerFlag = false;
      }
      if (state.stopImmediatePropagationFlag)
        break;
    }
  };
  const dispatchEvent = (eventInput) => {
    if (isCompleted)
      return false;
    let event;
    let state;
    if (eventInput && typeof eventInput === "object") {
      state = getEventState(eventInput);
      if (state) {
        event = eventInput;
      } else {
        const input = eventInput;
        if (typeof input.type !== "string") {
          throw new TypeError("Event type must be a string");
        }
        event = createEvent(input.type, input.detail, {
          bubbles: input.bubbles,
          cancelable: input.cancelable,
          composed: input.composed,
          timeStamp: input.timeStamp
        });
        state = getEventState(event);
      }
    } else {
      throw new TypeError("dispatchEvent expects an event object");
    }
    const dispatchState = state ?? getEventState(event);
    if (dispatchState.dispatchFlag || !dispatchState.initializedFlag) {
      const message = "Failed to execute dispatchEvent: event is already being dispatched";
      if (typeof globalThis.DOMException === "function") {
        throw new globalThis.DOMException(message, "InvalidStateError");
      }
      const err = new Error(message);
      err.name = "InvalidStateError";
      throw err;
    }
    dispatchState.isTrusted = false;
    dispatchState.dispatchFlag = true;
    dispatchState.path = [
      {
        invocationTarget: target,
        invocationTargetInShadowTree: false,
        shadowAdjustedTarget: target,
        relatedTarget: null,
        touchTargets: [],
        rootOfClosedTree: false,
        slotInClosedTree: false
      }
    ];
    notifyWildcardListeners(dispatchState.type, event);
    const list = listeners.get(dispatchState.type);
    const snapshot = list ? list.slice() : [];
    invokeListeners(dispatchState.type, event, "capturing", snapshot);
    invokeListeners(dispatchState.type, event, "bubbling", snapshot);
    dispatchState.eventPhase = event.NONE;
    dispatchState.currentTarget = null;
    dispatchState.path = [];
    dispatchState.dispatchFlag = false;
    dispatchState.stopPropagationFlag = false;
    dispatchState.stopImmediatePropagationFlag = false;
    return !dispatchState.canceledFlag;
  };
  const removeEventListener = (type, listener, options2) => {
    if (!listener)
      return;
    const capture = normalizeCaptureOption(options2);
    const list = listeners.get(type);
    if (!list)
      return;
    for (const record of [...list]) {
      if (record.original === listener && record.capture === capture) {
        removeListenerRecord(type, record);
      }
    }
  };
  const clear = () => {
    for (const [type, list] of Array.from(listeners.entries())) {
      for (const record of [...list]) {
        removeListenerRecord(type, record);
      }
    }
    listeners.clear();
    for (const record of wildcardListeners) {
      if (record.signal && record.abortHandler) {
        record.signal.removeEventListener("abort", record.abortHandler);
      }
    }
    wildcardListeners.clear();
  };
  const on = (type, options2) => {
    return new Observable((observer) => {
      let opts2;
      if (typeof options2 === "boolean") {
        opts2 = { capture: options2 };
      } else {
        opts2 = options2 ?? {};
      }
      const handler = opts2.handler;
      const once = opts2.once;
      const eventHandler = (e) => {
        let success = false;
        try {
          if (handler) {
            handler(e);
          }
          observer.next(e);
          success = true;
        } finally {
          if (once && success) {
            observer.complete();
          }
        }
      };
      const errorHandler = (e) => {
        observer.error(e.detail);
      };
      const unsubscribeEvent = addEventListener(type, eventHandler, opts2);
      let unsubscribeError;
      if (opts2.receiveError) {
        unsubscribeError = addEventListener("error", errorHandler, opts2);
      }
      return () => {
        unsubscribeEvent();
        if (unsubscribeError) {
          unsubscribeError();
        }
      };
    });
  };
  const onceMethod = (type, listener, options2) => {
    if (typeof options2 === "boolean") {
      return addEventListener(type, listener, { capture: options2, once: true });
    }
    return addEventListener(type, listener, { ...options2 ?? {}, once: true });
  };
  const removeAllListeners = (type) => {
    if (type !== undefined) {
      const list = listeners.get(type);
      if (list) {
        for (const record of [...list]) {
          removeListenerRecord(type, record);
        }
        listeners.delete(type);
      }
    } else {
      for (const [eventType, list] of Array.from(listeners.entries())) {
        for (const record of [...list]) {
          removeListenerRecord(eventType, record);
        }
      }
      listeners.clear();
      for (const record of wildcardListeners) {
        if (record.signal && record.abortHandler) {
          record.signal.removeEventListener("abort", record.abortHandler);
        }
      }
      wildcardListeners.clear();
    }
  };
  const pipe = (target2, mapFn) => {
    if (isCompleted) {
      return () => {};
    }
    const unsubscribe2 = addWildcardListener("*", (event) => {
      if (mapFn) {
        const mapped = mapFn(createEvent(event.originalType, event.detail, {
          target: target2,
          currentTarget: target2,
          eventPhase: 2,
          bubbles: event.bubbles,
          cancelable: event.cancelable,
          composed: event.composed
        }));
        if (mapped !== null) {
          target2.dispatchEvent(mapped);
        }
      } else {
        target2.dispatchEvent({
          type: event.originalType,
          detail: event.detail
        });
      }
    });
    const completionUnsub = () => {
      unsubscribe2();
    };
    completionCallbacks.add(completionUnsub);
    return () => {
      completionCallbacks.delete(completionUnsub);
      unsubscribe2();
    };
  };
  const complete2 = () => {
    if (isCompleted)
      return;
    isCompleted = true;
    for (const cb of completionCallbacks) {
      try {
        cb();
      } catch (err) {
        try {
          handleListenerError("complete", err);
        } catch {}
      }
    }
    completionCallbacks.clear();
    for (const [eventType, list] of Array.from(listeners.entries())) {
      for (const record of [...list]) {
        removeListenerRecord(eventType, record);
      }
    }
    listeners.clear();
    for (const record of wildcardListeners) {
      if (record.signal && record.abortHandler) {
        record.signal.removeEventListener("abort", record.abortHandler);
      }
    }
    wildcardListeners.clear();
  };
  const subscribe = (type, observerOrNext, error2, completeHandler) => {
    let observer;
    if (typeof observerOrNext === "function") {
      observer = {
        next: observerOrNext,
        error: error2,
        complete: completeHandler
      };
    } else {
      observer = observerOrNext ?? {};
    }
    let closed = false;
    if (isCompleted) {
      if (observer.complete) {
        try {
          observer.complete();
        } catch {}
      }
      return {
        unsubscribe: () => {
          closed = true;
        },
        get closed() {
          return closed || isCompleted;
        }
      };
    }
    const unsub = addEventListener(type, (event) => {
      if (closed)
        return;
      if (observer.next) {
        try {
          observer.next(event);
        } catch (err) {
          if (observer.error) {
            try {
              observer.error(err);
            } catch {}
          }
        }
      }
    });
    const onComplete = () => {
      if (closed)
        return;
      closed = true;
      if (observer.complete) {
        try {
          observer.complete();
        } catch {}
      }
    };
    completionCallbacks.add(onComplete);
    return {
      unsubscribe: () => {
        if (closed)
          return;
        closed = true;
        completionCallbacks.delete(onComplete);
        unsub();
      },
      get closed() {
        return closed || isCompleted;
      }
    };
  };
  const toObservable = () => {
    return new Observable((observer) => {
      if (isCompleted) {
        observer.complete();
        return;
      }
      const wildcardListener = (event) => {
        observer.next(createEvent(event.originalType, event.detail, {
          target,
          currentTarget: target,
          eventPhase: 2,
          bubbles: event.bubbles,
          cancelable: event.cancelable,
          composed: event.composed
        }));
      };
      const unsubscribe2 = addWildcardListener("*", wildcardListener);
      const onComplete = () => {
        observer.complete();
      };
      completionCallbacks.add(onComplete);
      return () => {
        unsubscribe2();
        completionCallbacks.delete(onComplete);
      };
    });
  };
  function events(type, options2) {
    if (isCompleted) {
      return {
        [Symbol.asyncIterator]() {
          return this;
        },
        next() {
          return Promise.resolve({
            value: undefined,
            done: true
          });
        },
        return() {
          return Promise.resolve({
            value: undefined,
            done: true
          });
        }
      };
    }
    const signal = options2?.signal;
    const bufferSize = options2?.bufferSize ?? Infinity;
    const overflowStrategy = options2?.overflowStrategy ?? "drop-oldest";
    const buffer = [];
    let resolve = null;
    let done = false;
    let hasOverflow = false;
    let onAbort = null;
    const cleanupAbortListener = () => {
      if (signal && onAbort) {
        signal.removeEventListener("abort", onAbort);
      }
    };
    const unsub = addEventListener(type, (event) => {
      if (done)
        return;
      const typedEvent = event;
      if (resolve) {
        const r = resolve;
        resolve = null;
        r({ value: typedEvent, done: false });
      } else {
        if (buffer.length >= bufferSize && bufferSize !== Infinity) {
          switch (overflowStrategy) {
            case "drop-oldest":
              buffer.shift();
              buffer.push(typedEvent);
              break;
            case "drop-latest":
              break;
            case "throw":
              unsub();
              completionCallbacks.delete(onComplete);
              done = true;
              hasOverflow = true;
              cleanupAbortListener();
              return;
          }
        } else {
          buffer.push(typedEvent);
        }
      }
    });
    const onComplete = () => {
      done = true;
      cleanupAbortListener();
      if (resolve) {
        const r = resolve;
        resolve = null;
        r({ value: undefined, done: true });
      }
    };
    completionCallbacks.add(onComplete);
    if (signal) {
      onAbort = () => {
        done = true;
        completionCallbacks.delete(onComplete);
        unsub();
        if (resolve) {
          const r = resolve;
          resolve = null;
          r({ value: undefined, done: true });
        }
      };
      signal.addEventListener("abort", onAbort, { once: true });
      if (signal.aborted)
        onAbort();
    }
    const iterator = {
      [Symbol.asyncIterator]() {
        return this;
      },
      async next() {
        if (buffer.length > 0) {
          return { value: buffer.shift(), done: false };
        }
        if (resolve !== null) {
          return Promise.reject(new Error("Concurrent calls to next() are not supported on this async iterator"));
        }
        return new Promise((_resolve, _reject) => {
          if (hasOverflow) {
            hasOverflow = false;
            _reject(new BufferOverflowError(type, bufferSize));
            return;
          }
          if (done) {
            _resolve({
              value: undefined,
              done: true
            });
            return;
          }
          resolve = _resolve;
        });
      },
      return() {
        if (resolve) {
          const r = resolve;
          resolve = null;
          r({ value: undefined, done: true });
        }
        done = true;
        completionCallbacks.delete(onComplete);
        unsub();
        cleanupAbortListener();
        return Promise.resolve({
          value: undefined,
          done: true
        });
      }
    };
    return iterator;
  }
  const target = {
    addEventListener,
    removeEventListener,
    dispatchEvent,
    clear,
    on,
    once: onceMethod,
    removeAllListeners,
    pipe,
    addWildcardListener,
    removeWildcardListener,
    complete: complete2,
    get completed() {
      return isCompleted;
    },
    subscribe,
    toObservable,
    events
  };
  target[SymbolObservable] = () => {
    return toObservable();
  };
  return target;
}

class EventEmission {
  #target;
  constructor() {
    this.#target = createEventTarget();
  }
  addEventListener(type, listener, options2) {
    return this.#target.addEventListener(type, listener, options2);
  }
  removeEventListener(type, listener, options2) {
    this.#target.removeEventListener(type, listener, options2);
  }
  dispatchEvent(event) {
    return this.#target.dispatchEvent(event);
  }
  on(type, options2) {
    return this.#target.on(type, options2);
  }
  once(type, listener, options2) {
    return this.#target.once(type, listener, options2);
  }
  removeAllListeners(type) {
    this.#target.removeAllListeners(type);
  }
  clear() {
    this.#target.clear();
  }
  pipe(target, mapFn) {
    return this.#target.pipe(target, mapFn);
  }
  addWildcardListener(pattern, listener, options2) {
    return this.#target.addWildcardListener(pattern, listener, options2);
  }
  removeWildcardListener(pattern, listener) {
    this.#target.removeWildcardListener(pattern, listener);
  }
  subscribe(typeOrObserver, observerOrNext, error2, completeHandler) {
    if (typeof typeOrObserver === "string") {
      return this.#target.subscribe(typeOrObserver, observerOrNext, error2, completeHandler);
    }
    if (typeof typeOrObserver === "function") {
      return this.#target.toObservable().subscribe(typeOrObserver);
    }
    if (typeof typeOrObserver === "object" && typeOrObserver !== null) {
      const maybeObserver = typeOrObserver;
      if (typeof maybeObserver.next === "function" || typeof maybeObserver.error === "function" || typeof maybeObserver.complete === "function") {
        return this.#target.toObservable().subscribe(typeOrObserver);
      }
      return this.#target.toObservable().subscribe({});
    }
    throw new Error("subscribe() requires a string event type, callback function, or observer object");
  }
  toObservable() {
    return this.#target.toObservable();
  }
  [SymbolObservable]() {
    return this.toObservable();
  }
  complete() {
    this.#target.complete();
  }
  get completed() {
    return this.#target.completed;
  }
  events(type, options2) {
    return this.#target.events(type, options2);
  }
}

// src/errors.ts
class ConversationalistError extends Error {
  code;
  context;
  cause;
  constructor(code, message, options2) {
    super(message);
    this.name = "ConversationalistError";
    this.code = code;
    this.context = options2?.context;
    this.cause = options2?.cause;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ConversationalistError);
    }
  }
  toDetailedString() {
    const parts = [`[${this.code}] ${this.message}`];
    if (this.context && Object.keys(this.context).length > 0) {
      parts.push(`Context: ${JSON.stringify(this.context, null, 2)}`);
    }
    if (this.cause) {
      parts.push(`Caused by: ${this.cause.message}`);
    }
    return parts.join(`
`);
  }
}
function createInvalidPositionError(expected, actual) {
  return new ConversationalistError("error:invalid-position", `invalid position: expected ${expected}, got ${actual}`, { context: { expected, actual } });
}
function createInvalidToolReferenceError(callId) {
  return new ConversationalistError("error:invalid-tool-reference", `tool result references non-existent tool-use: ${callId}`, { context: { callId } });
}
function createSerializationError(message, cause) {
  return new ConversationalistError("error:serialization", message, { cause });
}
function createValidationError(message, context, cause) {
  return new ConversationalistError("error:validation", message, { context, cause });
}
function createIntegrityError(message, context) {
  return new ConversationalistError("error:integrity", message, { context });
}

// src/schemas.ts
import { z } from "zod";
var isPlainObject = (value) => {
  if (!value || typeof value !== "object")
    return false;
  const prototype = Reflect.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
};
function toMultiModalContent(value) {
  const result = { type: value.type };
  if (value.text !== undefined)
    result.text = value.text;
  if (value.url !== undefined)
    result.url = value.url;
  if (value.mimeType !== undefined)
    result.mimeType = value.mimeType;
  return result;
}
var jsonValueSchema = z.lazy(() => {
  const jsonObjectSchema = z.preprocess((value, ctx) => {
    if (!isPlainObject(value)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "expected a plain object"
      });
      return z.NEVER;
    }
    return value;
  }, z.record(z.string(), jsonValueSchema));
  return z.union([
    z.string(),
    z.number().refine((value) => Number.isFinite(value), {
      message: "expected a finite number"
    }),
    z.boolean(),
    z.null(),
    z.array(jsonValueSchema),
    jsonObjectSchema
  ]);
});
var multiModalContentSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("text"),
    text: z.string()
  }),
  z.object({
    type: z.literal("image"),
    url: z.string().url(),
    mimeType: z.string().optional(),
    text: z.string().optional()
  })
]).transform(toMultiModalContent);
var messageRoleSchema = z.enum([
  "user",
  "assistant",
  "system",
  "developer",
  "tool-use",
  "tool-result",
  "snapshot"
]);
var toolCallSchema = z.object({
  id: z.string(),
  name: z.string(),
  arguments: jsonValueSchema
}).strict();
var toolResultSchema = z.object({
  callId: z.string(),
  outcome: z.enum(["success", "error"]),
  content: jsonValueSchema
}).strict();
var tokenUsageSchema = z.object({
  prompt: z.number().int().min(0),
  completion: z.number().int().min(0),
  total: z.number().int().min(0)
});
var messageInputSchema = z.object({
  role: messageRoleSchema,
  content: z.union([z.string(), z.array(multiModalContentSchema)]),
  metadata: z.record(z.string(), jsonValueSchema).optional(),
  hidden: z.boolean().optional(),
  toolCall: toolCallSchema.optional(),
  toolResult: toolResultSchema.optional(),
  tokenUsage: tokenUsageSchema.optional(),
  goalCompleted: z.boolean().optional()
}).strict();
var messageSchema = z.object({
  id: z.string(),
  role: messageRoleSchema,
  content: z.union([z.string(), z.array(multiModalContentSchema)]),
  position: z.number().int().min(0),
  createdAt: z.string(),
  metadata: z.record(z.string(), jsonValueSchema),
  hidden: z.boolean(),
  toolCall: toolCallSchema.optional(),
  toolResult: toolResultSchema.optional(),
  tokenUsage: tokenUsageSchema.optional(),
  goalCompleted: z.boolean().optional()
}).strict();
var conversationStatusSchema = z.enum([
  "active",
  "archived",
  "deleted"
]);
var conversationShape = {
  schemaVersion: z.number().int().min(1),
  id: z.string(),
  title: z.string().optional(),
  status: conversationStatusSchema,
  metadata: z.record(z.string(), jsonValueSchema),
  ids: z.array(z.string()),
  messages: z.record(z.string(), messageSchema),
  createdAt: z.string(),
  updatedAt: z.string()
};
var conversationSchema = z.object(conversationShape).strict();

// src/conversation/integrity.ts
function validateConversationIntegrity(conversation) {
  const issues = [];
  const seenIds = new Set;
  conversation.ids.forEach((id, index) => {
    if (seenIds.has(id)) {
      issues.push({
        code: "integrity:duplicate-message-id",
        message: `duplicate message id in ids: ${id}`,
        data: { id, position: index }
      });
    } else {
      seenIds.add(id);
    }
    if (!conversation.messages[id]) {
      issues.push({
        code: "integrity:missing-message",
        message: `missing message for id ${id}`,
        data: { id, position: index }
      });
    }
  });
  for (const id of Object.keys(conversation.messages)) {
    if (!seenIds.has(id)) {
      issues.push({
        code: "integrity:unlisted-message",
        message: `message ${id} is not listed in ids`,
        data: { id }
      });
    }
  }
  const toolUses = new Map;
  conversation.ids.forEach((id, index) => {
    const message = conversation.messages[id];
    if (!message)
      return;
    if (message.role === "tool-use" && message.toolCall) {
      if (toolUses.has(message.toolCall.id)) {
        issues.push({
          code: "integrity:duplicate-tool-call",
          message: `duplicate toolCall.id ${message.toolCall.id}`,
          data: { toolCallId: message.toolCall.id, messageId: message.id }
        });
      } else {
        toolUses.set(message.toolCall.id, { position: index, messageId: message.id });
      }
    }
  });
  conversation.ids.forEach((id, index) => {
    const message = conversation.messages[id];
    if (!message)
      return;
    if (message.role === "tool-result" && message.toolResult) {
      const toolUse = toolUses.get(message.toolResult.callId);
      if (!toolUse) {
        issues.push({
          code: "integrity:orphan-tool-result",
          message: `tool-result references missing tool-use ${message.toolResult.callId}`,
          data: { callId: message.toolResult.callId, messageId: message.id }
        });
      } else if (toolUse.position >= index) {
        issues.push({
          code: "integrity:tool-result-before-call",
          message: `tool-result ${message.toolResult.callId} occurs before tool-use`,
          data: {
            callId: message.toolResult.callId,
            messageId: message.id,
            toolUseMessageId: toolUse.messageId
          }
        });
      }
    }
  });
  return issues;
}
function assertConversationIntegrity(conversation) {
  const issues = validateConversationIntegrity(conversation);
  if (issues.length === 0)
    return;
  throw createIntegrityError("conversation integrity check failed", { issues });
}

// src/conversation/validation.ts
function assertConversationSafe(conversation) {
  const parsed = conversationSchema.safeParse(conversation);
  if (!parsed.success) {
    throw createValidationError("conversation failed schema validation", {
      issues: parsed.error.issues
    });
  }
  assertConversationIntegrity(conversation);
}
function ensureConversationSafe(conversation) {
  assertConversationSafe(conversation);
  return conversation;
}

// src/utilities/content.ts
function normalizeContent(content) {
  if (content === undefined)
    return;
  if (typeof content === "string")
    return content;
  return Array.isArray(content) ? content : [content];
}
// src/multi-modal.ts
function copyMultiModalContent(item) {
  if (item.type === "text") {
    const result2 = { type: "text" };
    if (item.text !== undefined)
      result2.text = item.text;
    return result2;
  }
  const result = { type: "image" };
  if (item.url !== undefined)
    result.url = item.url;
  if (item.mimeType !== undefined)
    result.mimeType = item.mimeType;
  if (item.text !== undefined)
    result.text = item.text;
  return result;
}
function copyContent(content) {
  if (typeof content === "string") {
    return content;
  }
  return content.map(copyMultiModalContent);
}

// src/utilities/type-helpers.ts
function toReadonly(value) {
  return value;
}

// src/utilities/message.ts
function createMessage(props) {
  const content = typeof props.content === "string" ? props.content : toReadonly(props.content.map((part) => part));
  const message = {
    id: props.id,
    role: props.role,
    content,
    position: props.position,
    createdAt: props.createdAt,
    metadata: toReadonly({ ...props.metadata }),
    hidden: props.hidden,
    toolCall: props.toolCall ? toReadonly({ ...props.toolCall }) : undefined,
    toolResult: props.toolResult ? toReadonly({ ...props.toolResult }) : undefined,
    tokenUsage: props.tokenUsage ? toReadonly({ ...props.tokenUsage }) : undefined
  };
  if (isAssistantMessage(props)) {
    return toReadonly({
      ...message,
      role: "assistant",
      goalCompleted: props.goalCompleted
    });
  }
  return toReadonly(message);
}
function messageParts(message) {
  if (typeof message.content === "string") {
    return message.content ? [{ type: "text", text: message.content }] : [];
  }
  return message.content;
}
function messageText(message, joiner = `

`) {
  if (typeof message.content === "string")
    return message.content;
  return messageParts(message).filter((p) => p.type === "text").map((p) => p.type === "text" ? p.text : "").join(joiner);
}
function messageHasImages(message) {
  return messageParts(message).some((p) => p.type === "image");
}
function isAssistantMessage(message) {
  return message.role === "assistant";
}
// src/utilities/message-store.ts
function getOrderedMessages(conversation) {
  const ordered = [];
  for (const id of conversation.ids) {
    const message = conversation.messages[id];
    if (message) {
      ordered.push(message);
    }
  }
  return ordered;
}
function toIdRecord(items) {
  const record = {};
  for (const item of items) {
    record[item.id] = item;
  }
  return record;
}

// src/utilities/transient.ts
function isTransientKey(key) {
  return key.startsWith("_");
}
function stripTransientFromRecord(metadata) {
  const result = {};
  for (const [key, value] of Object.entries(metadata)) {
    if (!isTransientKey(key)) {
      result[key] = value;
    }
  }
  return result;
}
// src/environment.ts
function simpleTokenEstimator(message) {
  const text = messageText(message);
  return Math.ceil(text.length / 4);
}
var defaultConversationEnvironment = {
  now: () => new Date().toISOString(),
  randomId: () => crypto.randomUUID(),
  estimateTokens: simpleTokenEstimator,
  plugins: []
};
function resolveConversationEnvironment(environment) {
  return {
    now: environment?.now ?? defaultConversationEnvironment.now,
    randomId: environment?.randomId ?? defaultConversationEnvironment.randomId,
    estimateTokens: environment?.estimateTokens ?? defaultConversationEnvironment.estimateTokens,
    plugins: [...environment?.plugins ?? defaultConversationEnvironment.plugins]
  };
}
function isConversationEnvironmentParameter(value) {
  if (!value || typeof value !== "object" || value === null)
    return false;
  if ("role" in value)
    return false;
  const candidate = value;
  return typeof candidate["now"] === "function" || typeof candidate["randomId"] === "function" || typeof candidate["estimateTokens"] === "function" || Array.isArray(candidate["plugins"]) && candidate["plugins"].length > 0;
}

// src/context.ts
var cloneMessageWithPosition = (message, position, content) => {
  const baseMessage = {
    id: message.id,
    role: message.role,
    content,
    position,
    createdAt: message.createdAt,
    metadata: { ...message.metadata },
    hidden: message.hidden,
    toolCall: message.toolCall ? { ...message.toolCall } : undefined,
    toolResult: message.toolResult ? { ...message.toolResult } : undefined,
    tokenUsage: message.tokenUsage ? { ...message.tokenUsage } : undefined
  };
  if (isAssistantMessage(message)) {
    const assistantMessage = {
      ...baseMessage,
      role: "assistant",
      goalCompleted: message.goalCompleted
    };
    return createMessage(assistantMessage);
  }
  return createMessage(baseMessage);
};
var createMessageBlock = (message, estimator) => ({
  messages: [message],
  minPosition: message.position,
  maxPosition: message.position,
  tokenCount: estimator(message)
});
var buildMessageBlocks = (messages, estimator, preserveToolPairs) => {
  if (!preserveToolPairs) {
    const blocks2 = messages.map((message) => createMessageBlock(message, estimator));
    const messageToBlock2 = new Map;
    for (const block of blocks2) {
      const message = block.messages[0];
      if (message) {
        messageToBlock2.set(message.id, block);
      }
    }
    return { blocks: blocks2, messageToBlock: messageToBlock2 };
  }
  const blocks = [];
  const toolUses = new Map;
  for (const message of messages) {
    if (message.role === "tool-use" && message.toolCall) {
      const block = createMessageBlock(message, estimator);
      toolUses.set(message.toolCall.id, block);
      blocks.push(block);
      continue;
    }
    if (message.role === "tool-result" && message.toolResult) {
      const existing = toolUses.get(message.toolResult.callId);
      if (existing) {
        existing.messages.push(message);
        existing.maxPosition = Math.max(existing.maxPosition, message.position);
        existing.tokenCount += estimator(message);
        continue;
      }
      const orphanBlock = createMessageBlock(message, estimator);
      orphanBlock.orphanToolResult = true;
      blocks.push(orphanBlock);
      continue;
    }
    blocks.push(createMessageBlock(message, estimator));
  }
  const filteredBlocks = blocks.filter((block) => !block.orphanToolResult);
  const messageToBlock = new Map;
  for (const block of filteredBlocks) {
    for (const message of block.messages) {
      messageToBlock.set(message.id, block);
    }
  }
  return { blocks: filteredBlocks, messageToBlock };
};
var collectBlocksForMessages = (messages, messageToBlock) => {
  const blocks = [];
  const seen = new Set;
  for (const message of messages) {
    const block = messageToBlock.get(message.id);
    if (block && !seen.has(block)) {
      seen.add(block);
      blocks.push(block);
    }
  }
  return blocks;
};
var collectMessagesFromBlocks = (blocks) => {
  const messages = [];
  const seen = new Set;
  for (const block of blocks) {
    for (const message of block.messages) {
      if (!seen.has(message.id)) {
        seen.add(message.id);
        messages.push(message);
      }
    }
  }
  messages.sort((a, b) => a.position - b.position);
  return messages;
};
var ensureTruncationSafe = (conversation, preserveToolPairs, operation) => {
  try {
    return ensureConversationSafe(conversation);
  } catch (error2) {
    if (!preserveToolPairs && error2 instanceof ConversationalistError && error2.code === "error:integrity")
      throw createIntegrityError(`${operation} produced invalid tool linkage; use preserveToolPairs: true to keep tool interactions intact`, { preserveToolPairs, issues: error2.context?.["issues"] });
    throw error2;
  }
};
function estimateConversationTokens(conversation, estimateTokens, environment) {
  let estimator = estimateTokens;
  let env = environment;
  if (!environment && estimateTokens && isConversationEnvironmentParameter(estimateTokens)) {
    env = estimateTokens;
    estimator = undefined;
  }
  const resolvedEnvironment = resolveConversationEnvironment(env);
  const finalEstimator = typeof estimator === "function" ? estimator : resolvedEnvironment.estimateTokens;
  return getOrderedMessages(conversation).reduce((total, message) => total + finalEstimator(message), 0);
}
function truncateToTokenLimit(conversation, maxTokens, optionsOrEstimator, environment) {
  assertConversationSafe(conversation);
  let options2 = {};
  let env = environment;
  if (typeof optionsOrEstimator === "function") {
    options2 = { estimateTokens: optionsOrEstimator };
  } else if (optionsOrEstimator) {
    if (!environment && isConversationEnvironmentParameter(optionsOrEstimator)) {
      const candidate = optionsOrEstimator;
      const hasEnvFields = !!(candidate["now"] || candidate["randomId"] || Array.isArray(candidate["plugins"]) && candidate["plugins"].length > 0);
      if (hasEnvFields) {
        env = optionsOrEstimator;
      } else {
        options2 = optionsOrEstimator;
      }
    } else {
      options2 = optionsOrEstimator;
    }
  }
  const resolvedEnvironment = resolveConversationEnvironment(env);
  const estimator = options2.estimateTokens ?? resolvedEnvironment.estimateTokens;
  const preserveSystem = options2.preserveSystemMessages ?? true;
  const preserveLastN = options2.preserveLastN ?? 0;
  const preserveToolPairs = options2.preserveToolPairs ?? true;
  const currentTokens = estimateConversationTokens(conversation, estimator, resolvedEnvironment);
  if (currentTokens <= maxTokens) {
    return conversation;
  }
  const now = resolvedEnvironment.now();
  const orderedMessages = getOrderedMessages(conversation);
  const { blocks, messageToBlock } = buildMessageBlocks(orderedMessages, estimator, preserveToolPairs);
  const systemMessages = preserveSystem ? orderedMessages.filter((m) => m.role === "system") : [];
  const nonSystemMessages = orderedMessages.filter((m) => m.role !== "system");
  const protectedMessages = preserveLastN > 0 ? nonSystemMessages.slice(-preserveLastN) : [];
  const systemBlocks = collectBlocksForMessages(systemMessages, messageToBlock);
  const protectedBlocks = collectBlocksForMessages(protectedMessages, messageToBlock);
  const lockedBlocks = new Set([...systemBlocks, ...protectedBlocks]);
  const removableBlocks = blocks.filter((block) => !lockedBlocks.has(block));
  const systemTokens = systemBlocks.reduce((sum, block) => sum + block.tokenCount, 0);
  const protectedTokens = protectedBlocks.reduce((sum, block) => sum + block.tokenCount, 0);
  const availableTokens = maxTokens - systemTokens - protectedTokens;
  let selectedBlocks = [];
  if (availableTokens <= 0) {
    selectedBlocks = [...systemBlocks, ...protectedBlocks];
  } else {
    const sortedRemovable = [...removableBlocks].sort((a, b) => a.maxPosition - b.maxPosition);
    const keptRemovable = [];
    let usedTokens = 0;
    for (let i = sortedRemovable.length - 1;i >= 0; i--) {
      const block = sortedRemovable[i];
      if (usedTokens + block.tokenCount <= availableTokens) {
        keptRemovable.unshift(block);
        usedTokens += block.tokenCount;
      } else {
        break;
      }
    }
    selectedBlocks = [...systemBlocks, ...keptRemovable, ...protectedBlocks];
  }
  const allMessages = collectMessagesFromBlocks(selectedBlocks);
  const renumbered = allMessages.map((message, index) => cloneMessageWithPosition(message, index, copyContent(message.content)));
  const next2 = toReadonly({
    ...conversation,
    ids: renumbered.map((message) => message.id),
    messages: toIdRecord(renumbered),
    updatedAt: now
  });
  return ensureTruncationSafe(next2, preserveToolPairs, "truncateToTokenLimit");
}
function getRecentMessages(conversation, count, options2) {
  const includeHidden = options2?.includeHidden ?? false;
  const includeSystem = options2?.includeSystem ?? false;
  const preserveToolPairs = options2?.preserveToolPairs ?? true;
  const filtered = getOrderedMessages(conversation).filter((m) => {
    if (!includeHidden && m.hidden)
      return false;
    if (!includeSystem && m.role === "system")
      return false;
    return true;
  });
  if (!preserveToolPairs) {
    return filtered.slice(-count);
  }
  const { messageToBlock } = buildMessageBlocks(filtered, () => 0, preserveToolPairs);
  const tail = filtered.slice(-count);
  const blocks = collectBlocksForMessages(tail, messageToBlock);
  return collectMessagesFromBlocks(blocks);
}
function truncateFromPosition(conversation, position, options2, environment) {
  assertConversationSafe(conversation);
  const preserveSystem = options2?.preserveSystemMessages ?? true;
  const preserveToolPairs = options2?.preserveToolPairs ?? true;
  const resolvedEnvironment = resolveConversationEnvironment(environment);
  const now = resolvedEnvironment.now();
  const ordered = getOrderedMessages(conversation);
  const { messageToBlock } = buildMessageBlocks(ordered, () => 0, preserveToolPairs);
  const systemMessages = preserveSystem ? ordered.filter((m) => m.role === "system" && m.position < position) : [];
  const keptMessages = ordered.filter((m) => m.position >= position);
  const systemBlocks = collectBlocksForMessages(systemMessages, messageToBlock);
  const keptBlocks = collectBlocksForMessages(keptMessages, messageToBlock);
  const allMessages = collectMessagesFromBlocks([...systemBlocks, ...keptBlocks]);
  const renumbered = allMessages.map((message, index) => cloneMessageWithPosition(message, index, copyContent(message.content)));
  const next2 = toReadonly({
    ...conversation,
    ids: renumbered.map((message) => message.id),
    messages: toIdRecord(renumbered),
    updatedAt: now
  });
  return ensureTruncationSafe(next2, preserveToolPairs, "truncateFromPosition");
}

// src/types.ts
var CURRENT_SCHEMA_VERSION = 3;

// src/conversation/create.ts
function createConversation(options2, environment) {
  const resolvedEnvironment = resolveConversationEnvironment(environment);
  const now = resolvedEnvironment.now();
  const conv = {
    schemaVersion: CURRENT_SCHEMA_VERSION,
    id: options2?.id ?? resolvedEnvironment.randomId(),
    title: options2?.title,
    status: options2?.status ?? "active",
    metadata: { ...options2?.metadata ?? {} },
    ids: [],
    messages: {},
    createdAt: now,
    updatedAt: now
  };
  return ensureConversationSafe(toReadonly(conv));
}
// src/conversation/tool-tracking.ts
var buildToolUseIndex = (messages) => messages.reduce((index, message) => {
  if (message.role === "tool-use" && message.toolCall) {
    index.set(message.toolCall.id, { name: message.toolCall.name });
  }
  return index;
}, new Map);
var registerToolUse = (index, toolCall) => {
  const next2 = new Map(index);
  next2.set(toolCall.id, { name: toolCall.name });
  return next2;
};
var assertToolReference = (index, callId) => {
  if (!index.has(callId)) {
    throw createInvalidToolReferenceError(callId);
  }
};

// src/conversation/append.ts
function partitionAppendArgs(args) {
  const filtered = args.filter((arg) => arg !== undefined);
  if (filtered.length === 0) {
    return { inputs: [] };
  }
  const last = filtered[filtered.length - 1];
  if (isConversationEnvironmentParameter(last)) {
    return {
      inputs: filtered.slice(0, -1),
      environment: last
    };
  }
  return { inputs: filtered };
}
function appendMessages(conversation, ...args) {
  return appendMessagesInternal(conversation, args, true);
}
var appendMessagesInternal = (conversation, args, validate) => {
  const { inputs, environment } = partitionAppendArgs(args);
  const resolvedEnvironment = resolveConversationEnvironment(environment);
  const now = resolvedEnvironment.now();
  const startPosition = conversation.ids.length;
  const initialToolUses = validate ? buildToolUseIndex(getOrderedMessages(conversation)) : new Map;
  const { messages } = inputs.reduce((state, input, index) => {
    const processedInput = resolvedEnvironment.plugins.reduce((acc, plugin) => plugin(acc), input);
    if (validate && processedInput.role === "tool-result" && processedInput.toolResult) {
      assertToolReference(state.toolUses, processedInput.toolResult.callId);
    }
    const normalizedContent = normalizeContent(processedInput.content);
    const baseMessage = {
      id: resolvedEnvironment.randomId(),
      role: processedInput.role,
      content: normalizedContent,
      position: startPosition + index,
      createdAt: now,
      metadata: { ...processedInput.metadata ?? {} },
      hidden: processedInput.hidden ?? false,
      toolCall: processedInput.toolCall,
      toolResult: processedInput.toolResult,
      tokenUsage: processedInput.tokenUsage
    };
    let message;
    if (processedInput.role === "assistant") {
      const assistantMessage = {
        ...baseMessage,
        role: "assistant",
        goalCompleted: processedInput.goalCompleted
      };
      message = createMessage(assistantMessage);
    } else {
      message = createMessage(baseMessage);
    }
    let toolUses = state.toolUses;
    if (processedInput.role === "tool-use" && processedInput.toolCall) {
      if (validate && state.toolUses.has(processedInput.toolCall.id)) {
        throw createIntegrityError("duplicate toolCall.id in conversation", {
          toolCallId: processedInput.toolCall.id,
          messageId: baseMessage.id
        });
      }
      toolUses = validate ? registerToolUse(state.toolUses, processedInput.toolCall) : state.toolUses;
    }
    return {
      toolUses,
      messages: [...state.messages, message]
    };
  }, { toolUses: initialToolUses, messages: [] });
  const messageIds = messages.map((message) => message.id);
  const next2 = {
    ...conversation,
    ids: [...conversation.ids, ...messageIds],
    messages: { ...conversation.messages, ...toIdRecord(messages) },
    updatedAt: now
  };
  const readonly = toReadonly(next2);
  return validate ? ensureConversationSafe(readonly) : readonly;
};
function appendUserMessage(conversation, content, metadata, environment) {
  const resolvedEnvironment = isConversationEnvironmentParameter(metadata) ? metadata : environment;
  const resolvedMetadata = isConversationEnvironmentParameter(metadata) ? undefined : metadata;
  return appendMessages(conversation, { role: "user", content, metadata: resolvedMetadata }, resolvedEnvironment);
}
function appendAssistantMessage(conversation, content, metadata, environment) {
  const resolvedEnvironment = isConversationEnvironmentParameter(metadata) ? metadata : environment;
  const resolvedMetadata = isConversationEnvironmentParameter(metadata) ? undefined : metadata;
  return appendMessages(conversation, { role: "assistant", content, metadata: resolvedMetadata }, resolvedEnvironment);
}
function appendSystemMessage(conversation, content, metadata, environment) {
  const resolvedEnvironment = isConversationEnvironmentParameter(metadata) ? metadata : environment;
  const resolvedMetadata = isConversationEnvironmentParameter(metadata) ? undefined : metadata;
  return appendMessages(conversation, { role: "system", content, metadata: resolvedMetadata }, resolvedEnvironment);
}
// src/conversation/query.ts
function getMessages(conversation, options2) {
  const includeHidden = options2?.includeHidden ?? false;
  const ordered = getOrderedMessages(conversation);
  return includeHidden ? ordered : ordered.filter((m) => !m.hidden);
}
function getMessageAtPosition(conversation, position) {
  const id = conversation.ids[position];
  return id ? conversation.messages[id] : undefined;
}
function getMessageIds(conversation) {
  return [...conversation.ids];
}
function getMessageById(conversation, id) {
  return conversation.messages[id];
}
function searchConversationMessages(conversation, predicate) {
  return getOrderedMessages(conversation).filter(predicate);
}
function getStatistics(conversation) {
  const ordered = getOrderedMessages(conversation);
  const stats = ordered.reduce((acc, message) => {
    const byRole = {
      ...acc.byRole,
      [message.role]: (acc.byRole[message.role] ?? 0) + 1
    };
    return {
      byRole,
      hidden: acc.hidden + (message.hidden ? 1 : 0),
      withImages: acc.withImages + (messageHasImages(message) ? 1 : 0)
    };
  }, { byRole: {}, hidden: 0, withImages: 0 });
  return { total: ordered.length, ...stats };
}
// src/conversation/system-messages.ts
function hasSystemMessage(conversation) {
  return getOrderedMessages(conversation).some((m) => m.role === "system");
}
function getFirstSystemMessage(conversation) {
  return getOrderedMessages(conversation).find((m) => m.role === "system");
}
function getSystemMessages(conversation) {
  return getOrderedMessages(conversation).filter((m) => m.role === "system");
}
function prependSystemMessage(conversation, content, metadata, environment) {
  const resolvedEnvironment = resolveConversationEnvironment(isConversationEnvironmentParameter(metadata) ? metadata : environment);
  const resolvedMetadata = isConversationEnvironmentParameter(metadata) ? undefined : metadata;
  const now = resolvedEnvironment.now();
  const newMessage = createMessage({
    id: resolvedEnvironment.randomId(),
    role: "system",
    content,
    position: 0,
    createdAt: now,
    metadata: { ...resolvedMetadata ?? {} },
    hidden: false,
    toolCall: undefined,
    toolResult: undefined,
    tokenUsage: undefined
  });
  const ordered = getOrderedMessages(conversation);
  const renumberedMessages = ordered.map((message) => createMessage({
    id: message.id,
    role: message.role,
    content: copyContent(message.content),
    position: message.position + 1,
    createdAt: message.createdAt,
    metadata: { ...message.metadata },
    hidden: message.hidden,
    toolCall: message.toolCall,
    toolResult: message.toolResult,
    tokenUsage: message.tokenUsage
  }));
  return ensureConversationSafe(toReadonly({
    ...conversation,
    ids: [newMessage.id, ...ordered.map((message) => message.id)],
    messages: toIdRecord([newMessage, ...renumberedMessages]),
    updatedAt: now
  }));
}
function replaceSystemMessage(conversation, content, metadata, environment) {
  const resolvedEnvironment = resolveConversationEnvironment(isConversationEnvironmentParameter(metadata) ? metadata : environment);
  const resolvedMetadata = isConversationEnvironmentParameter(metadata) ? undefined : metadata;
  const now = resolvedEnvironment.now();
  const ordered = getOrderedMessages(conversation);
  const firstSystemIndex = ordered.findIndex((m) => m.role === "system");
  if (firstSystemIndex === -1) {
    return prependSystemMessage(conversation, content, resolvedMetadata, resolvedEnvironment);
  }
  const original = ordered[firstSystemIndex];
  const replaced = createMessage({
    id: original.id,
    role: "system",
    content,
    position: original.position,
    createdAt: original.createdAt,
    metadata: { ...resolvedMetadata ?? original.metadata },
    hidden: original.hidden,
    toolCall: undefined,
    toolResult: undefined,
    tokenUsage: undefined
  });
  const next2 = {
    ...conversation,
    ids: [...conversation.ids],
    messages: { ...conversation.messages, [replaced.id]: replaced },
    updatedAt: now
  };
  return ensureConversationSafe(toReadonly(next2));
}
function collapseSystemMessages(conversation, environment) {
  const ordered = getOrderedMessages(conversation);
  const systemMessages = ordered.filter((m) => m.role === "system");
  if (systemMessages.length <= 1) {
    return ensureConversationSafe(conversation);
  }
  const resolvedEnvironment = resolveConversationEnvironment(environment);
  const now = resolvedEnvironment.now();
  const { parts } = systemMessages.reduce((state, message) => {
    const contentStr = typeof message.content === "string" ? message.content : message.content.map((part) => part.type === "text" ? part.text : "").join("");
    if (!contentStr || state.seen.has(contentStr)) {
      return state;
    }
    const seen = new Set(state.seen);
    seen.add(contentStr);
    return { seen, parts: [...state.parts, contentStr] };
  }, { seen: new Set, parts: [] });
  const collapsedContent = parts.join(`
`);
  const firstSystemMsg = systemMessages[0];
  const collapsed = createMessage({
    id: firstSystemMsg.id,
    role: "system",
    content: collapsedContent,
    position: firstSystemMsg.position,
    createdAt: firstSystemMsg.createdAt,
    metadata: { ...firstSystemMsg.metadata },
    hidden: firstSystemMsg.hidden,
    toolCall: undefined,
    toolResult: undefined,
    tokenUsage: undefined
  });
  const systemIdsToRemove = systemMessages.slice(1).reduce((ids, message) => {
    const nextIds = new Set(ids);
    nextIds.add(message.id);
    return nextIds;
  }, new Set);
  const messages = ordered.filter((m) => !systemIdsToRemove.has(m.id)).map((m) => m.id === firstSystemMsg.id ? collapsed : m);
  const renumbered = messages.map((message, index) => {
    if (message.position === index)
      return message;
    return createMessage({
      id: message.id,
      role: message.role,
      content: copyContent(message.content),
      position: index,
      createdAt: message.createdAt,
      metadata: { ...message.metadata },
      hidden: message.hidden,
      toolCall: message.toolCall,
      toolResult: message.toolResult,
      tokenUsage: message.tokenUsage
    });
  });
  const next2 = {
    ...conversation,
    ids: renumbered.map((message) => message.id),
    messages: toIdRecord(renumbered),
    updatedAt: now
  };
  return ensureConversationSafe(toReadonly(next2));
}
// src/utilities/tool-results.ts
function copyToolResult(toolResult) {
  return { ...toolResult };
}
function redactToolResult(toolResult, placeholder) {
  return { ...toolResult, content: placeholder };
}

// src/conversation/modify.ts
var isRedactMessageOptions = (value) => {
  if (!value || typeof value !== "object")
    return false;
  const candidate = value;
  return "placeholder" in candidate || "redactToolArguments" in candidate || "redactToolResults" in candidate || "clearToolMetadata" in candidate;
};
function redactMessageAtPosition(conversation, position, placeholderOrOptions, environment) {
  let placeholder = "[REDACTED]";
  let options2 = {};
  let env = environment;
  if (typeof placeholderOrOptions === "string") {
    placeholder = placeholderOrOptions;
  } else if (placeholderOrOptions) {
    if (!environment && isConversationEnvironmentParameter(placeholderOrOptions)) {
      env = placeholderOrOptions;
    } else if (isRedactMessageOptions(placeholderOrOptions)) {
      options2 = placeholderOrOptions;
      if (options2.placeholder) {
        placeholder = options2.placeholder;
      }
    }
  }
  const redactToolArguments = options2.redactToolArguments ?? true;
  const redactToolResults = options2.redactToolResults ?? true;
  const clearToolMetadata = options2.clearToolMetadata ?? false;
  if (position < 0 || position >= conversation.ids.length) {
    throw createInvalidPositionError(conversation.ids.length - 1, position);
  }
  const id = conversation.ids[position];
  const original = id ? conversation.messages[id] : undefined;
  if (!original) {
    throw createInvalidPositionError(conversation.ids.length - 1, position);
  }
  let toolCall = original.toolCall ? { ...original.toolCall } : undefined;
  let toolResult = original.toolResult ? { ...original.toolResult } : undefined;
  if (clearToolMetadata) {
    toolCall = undefined;
    toolResult = undefined;
  } else {
    if (original.role === "tool-use" && toolCall) {
      toolCall = {
        ...toolCall,
        arguments: redactToolArguments ? placeholder : toolCall.arguments
      };
    }
    if (original.role === "tool-result" && toolResult) {
      toolResult = redactToolResults ? redactToolResult(toolResult, placeholder) : { ...toolResult };
    }
  }
  const redacted = createMessage({
    id: original.id,
    role: original.role,
    content: placeholder,
    position: original.position,
    createdAt: original.createdAt,
    metadata: { ...original.metadata },
    hidden: original.hidden,
    toolCall,
    toolResult,
    tokenUsage: original.tokenUsage ? { ...original.tokenUsage } : undefined
  });
  const resolvedEnvironment = resolveConversationEnvironment(env);
  const now = resolvedEnvironment.now();
  const next2 = {
    ...conversation,
    ids: [...conversation.ids],
    messages: { ...conversation.messages, [redacted.id]: redacted },
    updatedAt: now
  };
  return ensureConversationSafe(toReadonly(next2));
}
// src/conversation/serialization.ts
function normalizeToolResult(toolResult) {
  if (!toolResult)
    return;
  return {
    callId: toolResult.callId,
    outcome: toolResult.outcome,
    content: toolResult.content
  };
}
function normalizeMessage(message) {
  const base = {
    id: message.id,
    role: message.role,
    content: message.content,
    position: message.position,
    createdAt: message.createdAt,
    metadata: message.metadata,
    hidden: message.hidden,
    toolCall: message.toolCall ? { ...message.toolCall } : undefined,
    toolResult: normalizeToolResult(message.toolResult),
    tokenUsage: message.tokenUsage ? { ...message.tokenUsage } : undefined
  };
  if (isAssistantMessage(message)) {
    return {
      ...base,
      role: "assistant",
      goalCompleted: message.goalCompleted
    };
  }
  return base;
}
function deserializeConversation(json) {
  const parsed = conversationSchema.safeParse(json);
  if (!parsed.success) {
    throw createSerializationError("failed to deserialize conversation: invalid data");
  }
  const data = parsed.data;
  try {
    const messageIds = new Set(Object.keys(data.messages));
    const orderedMessages = data.ids.map((id, index) => {
      const message = data.messages[id];
      if (!message) {
        throw createSerializationError(`missing message for id ${id}`);
      }
      if (message.position !== index) {
        throw createInvalidPositionError(index, message.position);
      }
      messageIds.delete(id);
      return normalizeMessage(message);
    });
    if (messageIds.size > 0) {
      throw createSerializationError(`messages not listed in ids: ${[...messageIds].join(", ")}`);
    }
    orderedMessages.reduce((state, message) => {
      if (message.role === "tool-use" && message.toolCall) {
        return {
          toolUses: registerToolUse(state.toolUses, message.toolCall)
        };
      }
      if (message.role === "tool-result" && message.toolResult) {
        assertToolReference(state.toolUses, message.toolResult.callId);
      }
      return state;
    }, { toolUses: new Map });
    const messageInstances = orderedMessages.map((message) => createMessage(message));
    const conv = {
      schemaVersion: data.schemaVersion,
      id: data.id,
      title: data.title,
      status: data.status,
      metadata: { ...data.metadata },
      ids: orderedMessages.map((message) => message.id),
      messages: toIdRecord(messageInstances),
      createdAt: data.createdAt,
      updatedAt: data.updatedAt
    };
    const readonly = toReadonly(conv);
    assertConversationIntegrity(readonly);
    return readonly;
  } catch (error2) {
    throw createSerializationError(`failed to deserialize conversation: ${error2 instanceof Error ? error2.message : String(error2)}`, error2);
  }
}
// src/conversation/transform.ts
function toChatMessages(conversation) {
  assertConversationSafe(conversation);
  const roleMap = {
    user: "user",
    assistant: "assistant",
    system: "system",
    developer: "system",
    "tool-use": "assistant",
    "tool-result": "user",
    snapshot: "system"
  };
  const result = [];
  for (const message of getOrderedMessages(conversation)) {
    if (message.hidden)
      continue;
    const externalRole = roleMap[message.role];
    result.push({
      role: externalRole,
      content: message.content
    });
  }
  return result;
}
// src/streaming.ts
var STREAMING_KEY = "__streaming";
var cloneMessage = (original, overrides = {}) => {
  const baseMessage = {
    id: original.id,
    role: original.role,
    content: overrides.content ?? (typeof original.content === "string" ? original.content : [...original.content]),
    position: overrides.position ?? original.position,
    createdAt: original.createdAt,
    metadata: overrides.metadata ?? { ...original.metadata },
    hidden: original.hidden,
    toolCall: original.toolCall ? { ...original.toolCall } : undefined,
    toolResult: original.toolResult ? { ...original.toolResult } : undefined,
    tokenUsage: overrides.tokenUsage
  };
  if (isAssistantMessage(original)) {
    const assistantMessage = {
      ...baseMessage,
      role: "assistant",
      goalCompleted: original.goalCompleted
    };
    return createMessage(assistantMessage);
  }
  return createMessage(baseMessage);
};
function isStreamingMessage(message) {
  return message.metadata[STREAMING_KEY] === true;
}
function getStreamingMessage(conversation) {
  return getOrderedMessages(conversation).find(isStreamingMessage);
}
function appendStreamingMessage(conversation, role, metadata, environment) {
  const resolvedEnvironment = resolveConversationEnvironment(isConversationEnvironmentParameter(metadata) ? metadata : environment);
  const resolvedMetadata = isConversationEnvironmentParameter(metadata) ? undefined : metadata;
  const now = resolvedEnvironment.now();
  const messageId = resolvedEnvironment.randomId();
  const newMessage = createMessage({
    id: messageId,
    role,
    content: "",
    position: conversation.ids.length,
    createdAt: now,
    metadata: { ...resolvedMetadata ?? {}, [STREAMING_KEY]: true },
    hidden: false,
    toolCall: undefined,
    toolResult: undefined,
    tokenUsage: undefined
  });
  const updatedConversation = toReadonly({
    ...conversation,
    ids: [...conversation.ids, messageId],
    messages: { ...conversation.messages, [messageId]: newMessage },
    updatedAt: now
  });
  return { conversation: ensureConversationSafe(updatedConversation), messageId };
}
function updateStreamingMessage(conversation, messageId, content, environment) {
  const resolvedEnvironment = resolveConversationEnvironment(environment);
  const now = resolvedEnvironment.now();
  const original = conversation.messages[messageId];
  if (!original) {
    return ensureConversationSafe(conversation);
  }
  const overrides = {
    content: typeof content === "string" ? content : [...content]
  };
  if (original.tokenUsage) {
    overrides.tokenUsage = { ...original.tokenUsage };
  }
  const updated = cloneMessage(original, overrides);
  return ensureConversationSafe(toReadonly({
    ...conversation,
    ids: [...conversation.ids],
    messages: { ...conversation.messages, [updated.id]: updated },
    updatedAt: now
  }));
}
function finalizeStreamingMessage(conversation, messageId, options2, environment) {
  const resolvedEnvironment = resolveConversationEnvironment(isConversationEnvironmentParameter(options2) ? options2 : environment);
  const resolvedOptions = isConversationEnvironmentParameter(options2) ? undefined : options2;
  const now = resolvedEnvironment.now();
  const original = conversation.messages[messageId];
  if (!original) {
    return ensureConversationSafe(conversation);
  }
  const { [STREAMING_KEY]: _, ...restMetadata } = original.metadata;
  const finalMetadata = {
    ...restMetadata,
    ...resolvedOptions?.metadata ?? {}
  };
  const finalizeOverrides = {
    metadata: finalMetadata
  };
  if (resolvedOptions?.tokenUsage) {
    finalizeOverrides.tokenUsage = { ...resolvedOptions.tokenUsage };
  }
  const updated = cloneMessage(original, finalizeOverrides);
  return ensureConversationSafe(toReadonly({
    ...conversation,
    ids: [...conversation.ids],
    messages: { ...conversation.messages, [updated.id]: updated },
    updatedAt: now
  }));
}
function cancelStreamingMessage(conversation, messageId, environment) {
  const resolvedEnvironment = resolveConversationEnvironment(environment);
  const now = resolvedEnvironment.now();
  if (!conversation.messages[messageId]) {
    return ensureConversationSafe(conversation);
  }
  const messages = getOrderedMessages(conversation).filter((m) => m.id !== messageId).map((message, index) => message.position === index ? message : (() => {
    const overrides = {
      position: index
    };
    if (message.tokenUsage) {
      overrides.tokenUsage = { ...message.tokenUsage };
    }
    return cloneMessage(message, overrides);
  })());
  return ensureConversationSafe(toReadonly({
    ...conversation,
    ids: messages.map((message) => message.id),
    messages: toIdRecord(messages),
    updatedAt: now
  }));
}

// src/history.ts
class ConversationHistory extends EventTarget {
  currentNode;
  environment;
  events;
  constructor(initial = createConversation(), environment) {
    super();
    this.environment = resolveConversationEnvironment(environment);
    this.events = createEventTarget();
    const safeInitial = ensureConversationSafe(initial);
    this.currentNode = {
      conversation: safeInitial,
      parent: null,
      children: []
    };
  }
  notifyChange(type) {
    const detail = {
      type,
      conversation: this.current
    };
    this.events.dispatchEvent({ type: "change", detail });
    this.events.dispatchEvent({ type, detail });
  }
  toAddListenerOptions(options2) {
    if (typeof options2 === "boolean" || options2 === undefined)
      return options2;
    const mapped = {};
    if (options2.capture !== undefined)
      mapped.capture = options2.capture;
    if (options2.once !== undefined)
      mapped.once = options2.once;
    if (options2.passive !== undefined)
      mapped.passive = options2.passive;
    if (options2.signal !== undefined) {
      mapped.signal = options2.signal;
    }
    return mapped;
  }
  toRemoveListenerOptions(options2) {
    if (typeof options2 === "boolean" || options2 === undefined)
      return options2;
    const mapped = {};
    if (options2.capture !== undefined)
      mapped.capture = options2.capture;
    return mapped;
  }
  addEventListener(type, callback, options2) {
    if (!callback)
      return;
    return this.events.addEventListener(type, callback, this.toAddListenerOptions(options2));
  }
  removeEventListener(type, callback, options2) {
    if (!callback)
      return;
    this.events.removeEventListener(type, callback, this.toRemoveListenerOptions(options2));
  }
  dispatchEvent(event) {
    return this.events.dispatchEvent(event);
  }
  subscribe(run) {
    run(this.current);
    const handler = (event) => {
      if (event?.detail?.conversation) {
        run(event.detail.conversation);
      }
    };
    const unsubscribe2 = this.addEventListener("change", handler);
    return unsubscribe2 || (() => {});
  }
  getSnapshot() {
    return this.current;
  }
  get current() {
    return this.currentNode.conversation;
  }
  get ids() {
    return getMessageIds(this.current);
  }
  get canUndo() {
    return this.currentNode.parent !== null;
  }
  get canRedo() {
    return this.currentNode.children.length > 0;
  }
  get env() {
    return this.environment;
  }
  get branchCount() {
    return this.currentNode.parent ? this.currentNode.parent.children.length : 1;
  }
  get branchIndex() {
    if (!this.currentNode.parent)
      return 0;
    return this.currentNode.parent.children.indexOf(this.currentNode);
  }
  get redoCount() {
    return this.currentNode.children.length;
  }
  push(next2) {
    const newNode = {
      conversation: next2,
      parent: this.currentNode,
      children: []
    };
    this.currentNode.children.push(newNode);
    this.currentNode = newNode;
    this.notifyChange("push");
  }
  undo() {
    if (this.currentNode.parent) {
      this.currentNode = this.currentNode.parent;
      this.notifyChange("undo");
      return this.current;
    }
    return;
  }
  redo(childIndex = 0) {
    const next2 = this.currentNode.children[childIndex];
    if (next2) {
      this.currentNode = next2;
      this.notifyChange("redo");
      return this.current;
    }
    return;
  }
  switchToBranch(index) {
    if (this.currentNode.parent) {
      const target = this.currentNode.parent.children[index];
      if (target) {
        this.currentNode = target;
        this.notifyChange("switch");
        return this.current;
      }
    }
    return;
  }
  getPath() {
    const path = [];
    let curr = this.currentNode;
    while (curr) {
      path.unshift(curr.conversation);
      curr = curr.parent;
    }
    return path;
  }
  getMessages(options2) {
    return getMessages(this.current, options2);
  }
  getMessageAtPosition(position) {
    return getMessageAtPosition(this.current, position);
  }
  getMessageIds() {
    return getMessageIds(this.current);
  }
  getMessageById(id) {
    return getMessageById(this.current, id);
  }
  get(id) {
    return getMessageById(this.current, id);
  }
  searchMessages(predicate) {
    return searchConversationMessages(this.current, predicate);
  }
  getStatistics() {
    return getStatistics(this.current);
  }
  hasSystemMessage() {
    return hasSystemMessage(this.current);
  }
  getFirstSystemMessage() {
    return getFirstSystemMessage(this.current);
  }
  getSystemMessages() {
    return getSystemMessages(this.current);
  }
  toChatMessages() {
    return toChatMessages(this.current);
  }
  estimateTokens(estimator) {
    return estimateConversationTokens(this.current, estimator, this.env);
  }
  getRecentMessages(count, options2) {
    return getRecentMessages(this.current, count, options2);
  }
  getStreamingMessage() {
    return getStreamingMessage(this.current);
  }
  appendMessages(...inputs) {
    this.push(appendMessages(this.current, ...inputs, this.env));
  }
  appendUserMessage(content, metadata) {
    this.push(appendUserMessage(this.current, content, metadata, this.env));
  }
  appendAssistantMessage(content, metadata) {
    this.push(appendAssistantMessage(this.current, content, metadata, this.env));
  }
  appendSystemMessage(content, metadata) {
    this.push(appendSystemMessage(this.current, content, metadata, this.env));
  }
  prependSystemMessage(content, metadata) {
    this.push(prependSystemMessage(this.current, content, metadata, this.env));
  }
  replaceSystemMessage(content, metadata) {
    this.push(replaceSystemMessage(this.current, content, metadata, this.env));
  }
  collapseSystemMessages() {
    this.push(collapseSystemMessages(this.current, this.env));
  }
  redactMessageAtPosition(position, placeholderOrOptions) {
    this.push(redactMessageAtPosition(this.current, position, placeholderOrOptions, this.env));
  }
  truncateFromPosition(position, options2) {
    this.push(truncateFromPosition(this.current, position, options2, this.env));
  }
  truncateToTokenLimit(maxTokens, options2) {
    this.push(truncateToTokenLimit(this.current, maxTokens, options2, this.env));
  }
  appendStreamingMessage(role, metadata) {
    const { conversation, messageId } = appendStreamingMessage(this.current, role, metadata, this.env);
    this.push(conversation);
    return messageId;
  }
  updateStreamingMessage(messageId, content) {
    this.push(updateStreamingMessage(this.current, messageId, content, this.env));
  }
  finalizeStreamingMessage(messageId, options2) {
    this.push(finalizeStreamingMessage(this.current, messageId, options2, this.env));
  }
  cancelStreamingMessage(messageId) {
    this.push(cancelStreamingMessage(this.current, messageId, this.env));
  }
  snapshot() {
    const getPath = (node) => {
      const path = [];
      let curr = node;
      while (curr.parent) {
        path.unshift(curr.parent.children.indexOf(curr));
        curr = curr.parent;
      }
      return path;
    };
    const serializeNode = (node) => ({
      conversation: node.conversation,
      children: node.children.map(serializeNode)
    });
    let root = this.currentNode;
    while (root.parent) {
      root = root.parent;
    }
    return {
      root: serializeNode(root),
      currentPath: getPath(this.currentNode)
    };
  }
  static from(json, environment) {
    const rootConv = deserializeConversation(json.root.conversation);
    const history = new ConversationHistory(rootConv, environment);
    const buildTree = (nodeJSON, parentNode) => {
      const nodeConv = deserializeConversation(nodeJSON.conversation);
      const node = {
        conversation: nodeConv,
        parent: parentNode,
        children: []
      };
      node.children = nodeJSON.children.map((child) => buildTree(child, node));
      return node;
    };
    const h = history;
    const rootNode = h.currentNode;
    rootNode.children = json.root.children.map((child) => buildTree(child, rootNode));
    let current = rootNode;
    for (const index of json.currentPath) {
      const target = current.children[index];
      if (target) {
        current = target;
      }
    }
    h.currentNode = current;
    return history;
  }
  bind(fn) {
    return (...args) => {
      const boundFn = fn;
      const result = boundFn(this.current, ...args, this.env);
      if (isConversation(result)) {
        this.push(result);
      }
      return result;
    };
  }
  [Symbol.dispose]() {
    let root = this.currentNode;
    while (root?.parent) {
      root = root.parent;
    }
    const clearNode = (node) => {
      for (const child of node.children) {
        clearNode(child);
      }
      node.children = [];
      const n = node;
      n.parent = null;
      n.conversation = null;
    };
    if (root)
      clearNode(root);
    this.events.clear();
  }
}
function isConversation(value) {
  return value !== null && typeof value === "object" && typeof value.schemaVersion === "number" && typeof value.id === "string" && typeof value.status === "string" && value.metadata !== null && typeof value.metadata === "object" && Array.isArray(value.ids) && typeof value.messages === "object" && value.messages !== null && !Array.isArray(value.messages) && typeof value.createdAt === "string" && typeof value.updatedAt === "string";
}

// src/utilities/markdown.ts
var import_gray_matter = __toESM(require_gray_matter(), 1);
var ROLE_LABELS = {
  user: "User",
  assistant: "Assistant",
  system: "System",
  developer: "Developer",
  "tool-use": "Tool Use",
  "tool-result": "Tool Result",
  snapshot: "Snapshot"
};
var LABEL_TO_ROLE = {
  User: "user",
  Assistant: "assistant",
  System: "system",
  Developer: "developer",
  "Tool Use": "tool-use",
  "Tool Result": "tool-result",
  Snapshot: "snapshot"
};
function getRoleLabel(role) {
  return ROLE_LABELS[role];
}
function getRoleFromLabel(label) {
  return LABEL_TO_ROLE[label];
}
var DEFAULT_REDACTED_PLACEHOLDER = "[REDACTED]";
function resolveMarkdownOptions(options2 = {}) {
  return {
    includeMetadata: options2.includeMetadata ?? false,
    stripTransient: options2.stripTransient ?? false,
    includeHidden: options2.includeHidden ?? true,
    redactHiddenContent: options2.redactHiddenContent ?? false,
    redactToolArguments: options2.redactToolArguments ?? false,
    redactToolResults: options2.redactToolResults ?? false,
    redactedPlaceholder: options2.redactedPlaceholder ?? DEFAULT_REDACTED_PLACEHOLDER
  };
}
function sanitizeMessage(message, options2) {
  const metadata = options2.stripTransient ? stripTransientFromRecord({ ...message.metadata }) : { ...message.metadata };
  const content = options2.redactHiddenContent && message.hidden ? options2.redactedPlaceholder : copyContent(message.content);
  const toolCall = message.toolCall ? {
    ...message.toolCall,
    arguments: options2.redactToolArguments ? options2.redactedPlaceholder : message.toolCall.arguments
  } : undefined;
  const toolResult = message.toolResult ? options2.redactToolResults ? redactToolResult(message.toolResult, options2.redactedPlaceholder) : copyToolResult(message.toolResult) : undefined;
  const baseMessage = {
    id: message.id,
    role: message.role,
    content,
    position: message.position,
    createdAt: message.createdAt,
    metadata: toReadonly(metadata),
    hidden: message.hidden,
    toolCall: toolCall ? toReadonly(toolCall) : undefined,
    toolResult: toolResult ? toReadonly(toolResult) : undefined,
    tokenUsage: message.tokenUsage ? toReadonly({ ...message.tokenUsage }) : undefined
  };
  if (isAssistantMessage(message)) {
    const assistantMessage = {
      ...baseMessage,
      role: "assistant",
      goalCompleted: message.goalCompleted
    };
    return assistantMessage;
  }
  return baseMessage;
}
function prepareConversationForMarkdown(conversation, options2) {
  const metadata = options2.stripTransient ? stripTransientFromRecord({ ...conversation.metadata }) : { ...conversation.metadata };
  const messages = getOrderedMessages(conversation).filter((message) => options2.includeHidden || !message.hidden).map((message) => sanitizeMessage(message, options2));
  return {
    schemaVersion: conversation.schemaVersion,
    id: conversation.id,
    title: conversation.title,
    status: conversation.status,
    metadata: toReadonly(metadata),
    ids: toReadonly(messages.map((message) => message.id)),
    messages: toReadonly(toIdRecord(messages)),
    createdAt: conversation.createdAt,
    updatedAt: conversation.updatedAt
  };
}
function formatMessageContent(message) {
  if (typeof message.content === "string")
    return message.content;
  const parts = messageParts(message);
  const lines = [];
  for (const part of parts) {
    if (part.type === "text" && part.text) {
      lines.push(part.text);
    } else if (part.type === "image") {
      const imageUrl = part.url;
      const altText = part.text ?? "image";
      lines.push(`![${altText}](${imageUrl})`);
    }
  }
  return lines.join(`

`);
}
function toMarkdown(conversation, options2 = {}) {
  assertConversationSafe(conversation);
  const resolved = resolveMarkdownOptions(options2);
  const prepared = prepareConversationForMarkdown(conversation, resolved);
  if (resolved.includeMetadata) {
    return toMarkdownWithMetadata(prepared, resolved);
  }
  return toMarkdownSimple(prepared);
}
function toMarkdownSimple(conversation) {
  const sections = [];
  for (const message of getOrderedMessages(conversation)) {
    const roleName = ROLE_LABELS[message.role];
    const header = `### ${roleName}`;
    const content = formatMessageContent(message);
    sections.push(`${header}

${content}`);
  }
  return sections.join(`

`);
}
function toMarkdownWithMetadata(conversation, _options) {
  const messagesMetadata = {};
  for (const message of getOrderedMessages(conversation)) {
    const messageMeta = {
      position: message.position,
      createdAt: message.createdAt,
      metadata: { ...message.metadata },
      hidden: message.hidden
    };
    if (Array.isArray(message.content)) {
      messageMeta.content = copyContent(message.content);
    }
    if (message.toolCall) {
      messageMeta.toolCall = { ...message.toolCall };
    }
    if (message.toolResult) {
      messageMeta.toolResult = { ...message.toolResult };
    }
    if (message.tokenUsage) {
      messageMeta.tokenUsage = { ...message.tokenUsage };
    }
    if (isAssistantMessage(message) && message.goalCompleted !== undefined) {
      messageMeta.goalCompleted = message.goalCompleted;
    }
    messagesMetadata[message.id] = messageMeta;
  }
  const frontmatterData = {
    schemaVersion: conversation.schemaVersion,
    id: conversation.id,
    status: conversation.status,
    metadata: { ...conversation.metadata },
    createdAt: conversation.createdAt,
    updatedAt: conversation.updatedAt,
    messages: messagesMetadata
  };
  if (conversation.title !== undefined) {
    frontmatterData.title = conversation.title;
  }
  const messageSections = [];
  for (const message of getOrderedMessages(conversation)) {
    const roleName = ROLE_LABELS[message.role];
    const header = `### ${roleName} (${message.id})`;
    const content = formatMessageContent(message);
    messageSections.push(`${header}

${content}`);
  }
  const body = messageSections.join(`

`);
  return import_gray_matter.default.stringify(body, frontmatterData);
}

class MarkdownParseError extends Error {
  constructor(message) {
    super(message);
    this.name = "MarkdownParseError";
  }
}
function generateId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
function fromMarkdown(markdown) {
  const trimmed = markdown.trim();
  const hasFrontmatter = trimmed.startsWith("---");
  const conversation = hasFrontmatter ? parseMarkdownWithMetadata(trimmed) : parseMarkdownSimple(trimmed);
  try {
    assertConversationSafe(conversation);
  } catch (error2) {
    throw new MarkdownParseError(`Invalid markdown conversation: ${error2 instanceof Error ? error2.message : String(error2)}`);
  }
  return conversation;
}
function parseMarkdownWithMetadata(trimmed) {
  let parsed;
  try {
    parsed = import_gray_matter.default(trimmed);
  } catch {
    throw new MarkdownParseError("Invalid frontmatter: failed to parse YAML");
  }
  const frontmatter = parsed.data;
  const body = parsed.content.trim();
  if (!frontmatter.id) {
    throw new MarkdownParseError('Invalid frontmatter: missing required field "id"');
  }
  const messages = [];
  const messagePattern = /^### ([\w\s]+) \(([^)]+)\)\n\n([\s\S]*?)(?=\n\n### |\n*$)/gm;
  let match;
  while ((match = messagePattern.exec(body)) !== null) {
    const [, roleDisplay, messageId, contentBody] = match;
    const role = LABEL_TO_ROLE[roleDisplay];
    if (!role) {
      throw new MarkdownParseError(`Unknown role: ${roleDisplay}`);
    }
    const messageMeta = frontmatter.messages?.[messageId];
    if (!messageMeta) {
      throw new MarkdownParseError(`Missing metadata for message: ${messageId}`);
    }
    let content;
    if (messageMeta.content) {
      content = toReadonly([...messageMeta.content]);
    } else {
      content = contentBody?.trim() ?? "";
    }
    const baseMessage = {
      id: messageId,
      role,
      content,
      position: messageMeta.position,
      createdAt: messageMeta.createdAt,
      metadata: toReadonly({ ...messageMeta.metadata }),
      hidden: messageMeta.hidden,
      toolCall: messageMeta.toolCall ? toReadonly({ ...messageMeta.toolCall }) : undefined,
      toolResult: messageMeta.toolResult ? toReadonly({ ...messageMeta.toolResult }) : undefined,
      tokenUsage: messageMeta.tokenUsage ? toReadonly({ ...messageMeta.tokenUsage }) : undefined
    };
    let message = baseMessage;
    if (role === "assistant") {
      message = {
        ...baseMessage,
        role: "assistant",
        goalCompleted: messageMeta.goalCompleted
      };
    }
    messages.push(toReadonly(message));
  }
  const conversation = {
    schemaVersion: frontmatter.schemaVersion ?? CURRENT_SCHEMA_VERSION,
    id: frontmatter.id,
    title: frontmatter.title,
    status: frontmatter.status ?? "active",
    metadata: toReadonly({ ...frontmatter.metadata }),
    ids: toReadonly(messages.map((message) => message.id)),
    messages: toReadonly(toIdRecord(messages)),
    createdAt: frontmatter.createdAt,
    updatedAt: frontmatter.updatedAt
  };
  return toReadonly(conversation);
}
function parseMarkdownSimple(body) {
  const now = new Date().toISOString();
  const messages = [];
  const messagePattern = /^### ([^\n]+)\n\n([\s\S]*?)(?=\n\n### |\n*$)/gm;
  let match;
  let position = 0;
  while ((match = messagePattern.exec(body)) !== null) {
    const [, roleDisplay, contentBody] = match;
    const role = LABEL_TO_ROLE[roleDisplay];
    if (!role) {
      throw new MarkdownParseError(`Unknown role: ${roleDisplay}`);
    }
    const message = {
      id: generateId(),
      role,
      content: contentBody?.trim() ?? "",
      position,
      createdAt: now,
      metadata: toReadonly({}),
      hidden: false
    };
    messages.push(toReadonly(message));
    position++;
  }
  const conversation = {
    schemaVersion: CURRENT_SCHEMA_VERSION,
    id: generateId(),
    status: "active",
    metadata: toReadonly({}),
    ids: toReadonly(messages.map((message) => message.id)),
    messages: toReadonly(toIdRecord(messages)),
    createdAt: now,
    updatedAt: now
  };
  return toReadonly(conversation);
}

// src/markdown/index.ts
function conversationHistoryToMarkdown(history, options2) {
  return toMarkdown(history.current, options2);
}
function conversationHistoryFromMarkdown(markdown, environment) {
  const conversation = fromMarkdown(markdown);
  return new ConversationHistory(conversation, environment);
}
export {
  toMarkdown,
  getRoleLabel,
  getRoleFromLabel,
  fromMarkdown,
  conversationHistoryToMarkdown,
  conversationHistoryFromMarkdown,
  ROLE_LABELS,
  MarkdownParseError,
  LABEL_TO_ROLE
};

//# debugId=C9F3624DCBE2A76564756E2164756E21
